export const data = { content:"openapi: 3.1.1\ninfo:\n  title: Scalar Galaxy\n  description: |\n    The Scalar Galaxy is an example OpenAPI specification to test OpenAPI tools and libraries. It’s a fictional universe with fictional planets and fictional data. Get all the data for [all planets](#tag/planets/GET/planets).\n\n    ## Resources\n\n    * https://github.com/scalar/scalar\n    * https://github.com/OAI/OpenAPI-Specification\n    * https://scalar.com\n\n    ## Markdown Support\n\n    All descriptions *can* contain ~~tons of text~~ **Markdown**. [If GitHub supports the syntax](https://docs.github.com/en/get-started/writing-on-github/getting-started-with-writing-and-formatting-on-github/basic-writing-and-formatting-syntax), chances are we’re supporting it, too. You can even create [internal links to reference endpoints](#tag/authentication/POST/user/signup).\n\n    <details>\n      <summary>Examples</summary>\n\n      **Blockquotes**\n\n      > I love OpenAPI. <3\n\n      **Tables**\n\n      | Feature          | Availability |\n      | ---------------- | ------------ |\n      | Markdown Support | ✓            |\n\n      **Accordion**\n\n      ```html\n      <details>\n        <summary>Using Details Tags</summary>\n        <p>HTML Example</p>\n      </details>\n      ```\n\n      **Images**\n\n      Yes, there’s support for images, too!\n\n      ![Empty placeholder image showing the width/height](https://images.placeholders.dev/?width=1280&height=720)\n\n      **Alerts**\n\n      > [!tip]\n      > You can now use markdown alerts in your descriptions.\n\n    </details>\n  version: 0.4.1\n  contact:\n    name: Marc from Scalar\n    url: https://scalar.com\n    email: marc@scalar.com\n  license:\n    name: MIT\n    url: https://opensource.org/license/MIT\nexternalDocs:\n  description: Documentation\n  url: https://github.com/scalar/scalar\nservers:\n  - url: https://galaxy.scalar.com\n  - url: '{protocol}://void.scalar.com/{path}'\n    description: Responds with your request data\n    variables:\n      protocol:\n        enum:\n          - https\n        default: https\n      path:\n        default: ''\nsecurity:\n  - bearerAuth: []\n  - basicAuth: []\n  - apiKeyQuery: []\n  - apiKeyHeader: []\n  - apiKeyCookie: []\n  - oAuth2: []\n  - openIdConnect: []\ntags:\n  - name: Authentication\n    description:\n      Some endpoints are public, but some require authentication. We provide\n      all the required endpoints to create an account and authorize yourself.\n  - name: Planets\n    description: Everything about planets\npaths:\n  '/planets':\n    get:\n      tags:\n        - Planets\n      summary: Get all planets\n      description: It’s easy to say you know them all, but do you really? Retrieve all the planets and check whether you missed one.\n      operationId: getAllData\n      security:\n        - {}\n      parameters:\n        - $ref: '#/components/parameters/limit'\n        - $ref: '#/components/parameters/offset'\n      responses:\n        '200':\n          description: OK\n          content:\n            application/json:\n              schema:\n                allOf:\n                  - type: object\n                    properties:\n                      data:\n                        type: array\n                        items:\n                          $ref: '#/components/schemas/Planet'\n                  - $ref: '#/components/schemas/PaginatedResource'\n            application/xml:\n              schema:\n                allOf:\n                  - type: object\n                    xml:\n                      name: planets\n                    properties:\n                      data:\n                        type: array\n                        items:\n                          $ref: '#/components/schemas/Planet'\n                  - $ref: '#/components/schemas/PaginatedResource'\n    post:\n      tags:\n        - Planets\n      summary: Create a planet\n      description: Time to play god and create a new planet. What do you think? Ah, don’t think too much. What could go wrong anyway?\n      operationId: createPlanet\n      callbacks:\n        planetCreated:\n          '{$request.body#/callbackUrl}':\n            post:\n              requestBody:\n                description: Information about the newly created planet\n                content:\n                  application/json:\n                    schema:\n                      $ref: '#/components/schemas/Planet'\n              responses:\n                '200':\n                  description: Your server returns this code if it accepts the callback\n      requestBody:\n        description: Planet\n        content:\n          application/json:\n            schema:\n              $ref: '#/components/schemas/Planet'\n          application/xml:\n            schema:\n              $ref: '#/components/schemas/Planet'\n      responses:\n        '201':\n          description: Created\n          content:\n            application/json:\n              schema:\n                $ref: '#/components/schemas/Planet'\n            application/xml:\n              schema:\n                $ref: '#/components/schemas/Planet'\n        '400':\n          $ref: '#/components/responses/BadRequest'\n        '403':\n          $ref: '#/components/responses/Forbidden'\n  '/planets/{planetId}':\n    get:\n      tags:\n        - Planets\n      summary: Get a planet\n      description: You’ll better learn a little bit more about the planets. It might come in handy once space travel is available for everyone.\n      operationId: getPlanet\n      security:\n        - {}\n      parameters:\n        - $ref: '#/components/parameters/planetId'\n      responses:\n        '200':\n          description: Planet Found\n          content:\n            application/json:\n              schema:\n                $ref: '#/components/schemas/Planet'\n            application/xml:\n              schema:\n                $ref: '#/components/schemas/Planet'\n        '404':\n          $ref: '#/components/responses/NotFound'\n    put:\n      tags:\n        - Planets\n      summary: Update a planet\n      description: Sometimes you make mistakes, that's fine. No worries, you can update all planets.\n      operationId: updatePlanet\n      requestBody:\n        description: New information about the planet\n        content:\n          application/json:\n            schema:\n              $ref: '#/components/schemas/Planet'\n          application/xml:\n            schema:\n              $ref: '#/components/schemas/Planet'\n      parameters:\n        - $ref: '#/components/parameters/planetId'\n      responses:\n        '200':\n          description: OK\n          content:\n            application/json:\n              schema:\n                $ref: '#/components/schemas/Planet'\n            application/xml:\n              schema:\n                $ref: '#/components/schemas/Planet'\n        '400':\n          $ref: '#/components/responses/BadRequest'\n        '403':\n          $ref: '#/components/responses/Forbidden'\n        '404':\n          $ref: '#/components/responses/NotFound'\n    delete:\n      tags:\n        - Planets\n      summary: Delete a planet\n      operationId: deletePlanet\n      description:\n        This endpoint was used to delete planets. Unfortunately, that caused\n        a lot of trouble for planets with life. So, this endpoint is now deprecated\n        and should not be used anymore.\n      x-scalar-stability: experimental\n      parameters:\n        - $ref: '#/components/parameters/planetId'\n      responses:\n        '204':\n          description: No Content\n        '404':\n          $ref: '#/components/responses/NotFound'\n  '/planets/{planetId}/image':\n    post:\n      tags:\n        - Planets\n      summary: Upload an image to a planet\n      description: Got a crazy good photo of a planet? Share it with the world!\n      operationId: uploadImage\n      parameters:\n        - $ref: '#/components/parameters/planetId'\n      requestBody:\n        description: Image to upload\n        content:\n          multipart/form-data:\n            schema:\n              type: object\n              properties:\n                image:\n                  type: string\n                  format: binary\n                  description: The image file to upload\n                  examples:\n                    - '@mars.jpg'\n                    - '@jupiter.png'\n      responses:\n        '200':\n          $ref: '#/components/responses/ImageUploaded'\n        '400':\n          $ref: '#/components/responses/BadRequest'\n        '403':\n          $ref: '#/components/responses/Forbidden'\n        '404':\n          $ref: '#/components/responses/NotFound'\n  '/user/signup':\n    post:\n      tags:\n        - Authentication\n      summary: Create a user\n      description: Time to create a user account, eh?\n      operationId: createUser\n      security:\n        - {}\n      requestBody:\n        description: User to create\n        content:\n          application/json:\n            schema:\n              allOf:\n                - $ref: '#/components/schemas/User'\n                - $ref: '#/components/schemas/Credentials'\n            examples:\n              Marc:\n                value:\n                  name: Marc\n                  email: marc@scalar.com\n                  password: i-love-scalar\n              Cam:\n                value:\n                  name: Cam\n                  email: cam@scalar.com\n                  password: scalar-is-cool\n          application/xml:\n            schema:\n              allOf:\n                - $ref: '#/components/schemas/User'\n                - $ref: '#/components/schemas/Credentials'\n            examples:\n              Marc:\n                value:\n                  name: Marc\n                  email: marc@scalar.com\n                  password: i-love-scalar\n              Cam:\n                value:\n                  name: Cam\n                  email: cam@scalar.com\n                  password: scalar-is-cool\n      responses:\n        '201':\n          description: Created\n          content:\n            application/json:\n              schema:\n                $ref: '#/components/schemas/User'\n            application/xml:\n              schema:\n                $ref: '#/components/schemas/User'\n        '400':\n          $ref: '#/components/responses/BadRequest'\n        '401':\n          $ref: '#/components/responses/Unauthorized'\n        '403':\n          $ref: '#/components/responses/Forbidden'\n        '409':\n          $ref: '#/components/responses/Conflict'\n        '422':\n          $ref: '#/components/responses/UnprocessableEntity'\n  '/auth/token':\n    post:\n      tags:\n        - Authentication\n      summary: Get a token\n      description: Yeah, this is the boring security stuff. Just get your super secret token and move on.\n      operationId: getToken\n      security:\n        - {}\n      requestBody:\n        description: Credentials to authenticate a user\n        content:\n          application/json:\n            schema:\n              $ref: '#/components/schemas/Credentials'\n          application/xml:\n            schema:\n              $ref: '#/components/schemas/Credentials'\n      responses:\n        '201':\n          description: Token Created\n          content:\n            application/json:\n              schema:\n                $ref: '#/components/schemas/Token'\n            application/xml:\n              schema:\n                $ref: '#/components/schemas/Token'\n        '401':\n          $ref: '#/components/responses/Unauthorized'\n        '403':\n          $ref: '#/components/responses/Forbidden'\n        '400':\n          $ref: '#/components/responses/BadRequest'\n  '/me':\n    get:\n      tags:\n        - Authentication\n      summary: Get authenticated user\n      description: Find yourself they say. That’s what you can do here.\n      operationId: getMe\n      security:\n        - basicAuth: []\n        - oAuth2:\n            - read:account\n        - bearerAuth: []\n        - apiKeyHeader: []\n        - apiKeyQuery: []\n      responses:\n        '200':\n          description: OK\n          content:\n            application/json:\n              schema:\n                $ref: '#/components/schemas/User'\n            application/xml:\n              schema:\n                $ref: '#/components/schemas/User'\n        '401':\n          $ref: '#/components/responses/Unauthorized'\n        '403':\n          $ref: '#/components/responses/Forbidden'\nwebhooks:\n  newPlanet:\n    post:\n      tags:\n        - Planets\n      requestBody:\n        description: Information about a new planet\n        content:\n          application/json:\n            schema:\n              $ref: '#/components/schemas/Planet'\n          application/xml:\n            schema:\n              $ref: '#/components/schemas/Planet'\n      responses:\n        '200':\n          description:\n            Return a 200 status to indicate that the data was received\n            successfully\ncomponents:\n  securitySchemes:\n    bearerAuth:\n      type: http\n      scheme: bearer\n      description: JWT Bearer token authentication\n    basicAuth:\n      type: http\n      scheme: basic\n      description: Basic HTTP authentication\n    apiKeyHeader:\n      type: apiKey\n      in: header\n      name: X-API-Key\n      description: API key request header\n    apiKeyQuery:\n      type: apiKey\n      in: query\n      name: api_key\n      description: API key query parameter\n    apiKeyCookie:\n      type: apiKey\n      in: cookie\n      name: api_key\n      description: API key browser cookie\n    oAuth2:\n      type: oauth2\n      description: OAuth 2.0 authentication\n      flows:\n        authorizationCode:\n          authorizationUrl: https://galaxy.scalar.com/oauth/authorize\n          tokenUrl: https://galaxy.scalar.com/oauth/token\n          scopes:\n            read:account: read your account information\n            write:planets: modify planets in your account\n            read:planets: read your planets\n        clientCredentials:\n          tokenUrl: https://galaxy.scalar.com/oauth/token\n          scopes:\n            read:account: read your account information\n            write:planets: modify planets in your account\n            read:planets: read your planets\n        # Legacy\n        implicit:\n          authorizationUrl: https://galaxy.scalar.com/oauth/authorize\n          scopes:\n            read:account: read your account information\n            write:planets: modify planets in your account\n            read:planets: read your planets\n        # Legacy\n        password:\n          tokenUrl: https://galaxy.scalar.com/oauth/token\n          scopes:\n            read:account: read your account information\n            write:planets: modify planets in your account\n            read:planets: read your planets\n    openIdConnect:\n      type: openIdConnect\n      openIdConnectUrl: https://galaxy.scalar.com/.well-known/openid-configuration\n      description: OpenID Connect Authentication\n  parameters:\n    planetId:\n      name: planetId\n      description: The ID of the planet to get\n      in: path\n      required: true\n      schema:\n        type: integer\n        format: int64\n        examples:\n          - 1\n    limit:\n      name: limit\n      description: The number of items to return\n      in: query\n      required: false\n      schema:\n        type: integer\n        format: int64\n        default: 10\n    offset:\n      name: offset\n      description:\n        The number of items to skip before starting to collect the result\n        set\n      in: query\n      required: false\n      schema:\n        type: integer\n        format: int64\n        default: 0\n  responses:\n    ImageUploaded:\n      description: Image uploaded\n      content:\n        application/json:\n          schema:\n            $ref: '#/components/schemas/ImageUploadedMessage'\n        application/xml:\n          schema:\n            $ref: '#/components/schemas/ImageUploadedMessage'\n    BadRequest:\n      description: Bad Request\n      content:\n        application/json:\n          schema:\n            $ref: '#/components/schemas/BadRequestError'\n        application/xml:\n          schema:\n            $ref: '#/components/schemas/BadRequestError'\n    Forbidden:\n      description: Forbidden\n      content:\n        application/json:\n          schema:\n            $ref: '#/components/schemas/ForbiddenError'\n        application/xml:\n          schema:\n            $ref: '#/components/schemas/ForbiddenError'\n    NotFound:\n      description: NotFound\n      content:\n        application/json:\n          schema:\n            $ref: '#/components/schemas/NotFoundError'\n        application/xml:\n          schema:\n            $ref: '#/components/schemas/NotFoundError'\n    Unauthorized:\n      description: Unauthorized\n      content:\n        application/json:\n          schema:\n            $ref: '#/components/schemas/UnauthorizedError'\n        application/xml:\n          schema:\n            $ref: '#/components/schemas/UnauthorizedError'\n    Conflict:\n      description: Conflict\n      content:\n        application/json:\n          schema:\n            $ref: '#/components/schemas/Conflict'\n        application/xml:\n          schema:\n            $ref: '#/components/schemas/Conflict'\n    UnprocessableEntity:\n      description: Unprocessable Entity\n      content:\n        application/json:\n          schema:\n            $ref: '#/components/schemas/UnprocessableEntity'\n        application/xml:\n          schema:\n            $ref: '#/components/schemas/UnprocessableEntity'\n  schemas:\n    User:\n      description: A user\n      type: object\n      xml:\n        name: user\n      properties:\n        id:\n          type: integer\n          format: int64\n          readOnly: true\n          examples:\n            - 1\n        name:\n          type: string\n          examples:\n            - Marc\n    Credentials:\n      description: Credentials to authenticate a user\n      type: object\n      required:\n        - email\n        - password\n      properties:\n        email:\n          type: string\n          format: email\n          examples:\n            - marc@scalar.com\n        password:\n          type: string\n          writeOnly: true\n          examples:\n            - i-love-scalar\n            - i-love-OSS\n            - i-love-code\n    Token:\n      description: A token to authenticate a user\n      type: object\n      properties:\n        token:\n          type: string\n          examples:\n            - eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiIxMjM0NTY3ODkwIiwibmFtZSI6IkpvaG4gRG9lIiwiaWF0IjoxNTE2MjM5MDIyfQ.SflKxwRJSMeKKF2QT4fwpMeJf36POk6yJV_adQssw5c\n    Planet:\n      description: A planet in the Scalar Galaxy\n      type: object\n      required:\n        - id\n        - name\n      xml:\n        name: planet\n      properties:\n        id:\n          type: integer\n          format: int64\n          readOnly: true\n          examples:\n            - 1\n          x-variable: planetId\n        name:\n          type: string\n          examples:\n            - Mars\n            - Jupiter\n            - HD 40307g\n        description:\n          type:\n            - string\n            - 'null'\n          examples:\n            - The red planet\n            - A gas giant with a great red spot\n        type:\n          type: string\n          enum:\n            - terrestrial\n            - gas_giant\n            - ice_giant\n            - dwarf\n            - super_earth\n          examples:\n            - terrestrial\n        habitabilityIndex:\n          type: number\n          format: float\n          minimum: 0\n          maximum: 1\n          description: A score from 0 to 1 indicating potential habitability\n          examples:\n            - 0.68\n        physicalProperties:\n          type: object\n          properties:\n            mass:\n              type: number\n              format: float\n              description: Mass in Earth masses\n              examples:\n                - 0.107\n            radius:\n              type: number\n              format: float\n              description: Radius in Earth radii\n              examples:\n                - 0.532\n            gravity:\n              type: number\n              format: float\n              description: Surface gravity in Earth g\n              examples:\n                - 0.378\n            temperature:\n              type: object\n              properties:\n                min:\n                  type: number\n                  format: float\n                  description: Minimum temperature in Kelvin\n                  examples:\n                    - 130\n                max:\n                  type: number\n                  format: float\n                  description: Maximum temperature in Kelvin\n                  examples:\n                    - 308\n                average:\n                  type: number\n                  format: float\n                  description: Average temperature in Kelvin\n                  examples:\n                    - 210\n        atmosphere:\n          type: array\n          description: Atmospheric composition\n          items:\n            type: object\n            properties:\n              compound:\n                type: string\n                examples:\n                  - CO2\n                  - N2\n              percentage:\n                type: number\n                format: float\n                examples:\n                  - 95.3\n        discoveredAt:\n          type: string\n          format: date-time\n          examples:\n            - '1610-01-07T00:00:00Z'\n        image:\n          type: string\n          nullable: true\n          examples:\n            - https://cdn.scalar.com/photos/mars.jpg\n        satellites:\n          type: array\n          items:\n            $ref: '#/components/schemas/Satellite'\n        creator:\n          $ref: '#/components/schemas/User'\n        tags:\n          type: array\n          items:\n            type: string\n          examples:\n            - ['solar-system', 'rocky', 'explored']\n        lastUpdated:\n          type: string\n          format: date-time\n          readOnly: true\n          examples:\n            - '2024-01-15T14:30:00Z'\n        callbackUrl:\n          type: string\n          format: uri\n          description: URL to receive notifications about this planet\n          examples:\n            - https://example.com/webhook\n    PaginatedResource:\n      description: A paginated resource\n      type: object\n      properties:\n        meta:\n          type: object\n          properties:\n            limit:\n              type: integer\n              format: int64\n              examples:\n                - 10\n            offset:\n              type: integer\n              format: int64\n              examples:\n                - 0\n            total:\n              type: integer\n              format: int64\n              examples:\n                - 100\n            next:\n              type:\n                - string\n                - 'null'\n              examples:\n                - '/planets?limit=10&offset=10'\n    ImageUploadedMessage:\n      x-scalar-ignore: true\n      description: Message about an image upload\n      type: object\n      properties:\n        message:\n          type: string\n          examples:\n            - Image uploaded successfully\n        imageUrl:\n          type: string\n          description: The URL where the uploaded image can be accessed\n          examples:\n            - https://cdn.scalar.com/images/8f47c132-9d1f-4f83-b5a4-91db5ee757ab.jpg\n        uploadedAt:\n          type: string\n          format: date-time\n          description: Timestamp when the image was uploaded\n          examples:\n            - '2024-01-15T14:30:00Z'\n        fileSize:\n          type: integer\n          description: Size of the uploaded image in bytes\n          examples:\n            - 1048576\n        mimeType:\n          type: string\n          description: The content type of the uploaded image\n          examples:\n            - image/jpeg\n            - image/png\n    BadRequestError:\n      x-scalar-ignore: true\n      description: RFC 7807 (https://datatracker.ietf.org/doc/html/rfc7807)\n      type: object\n      properties:\n        type:\n          type: string\n          examples:\n            - https://example.com/errors/bad-request\n        title:\n          type: string\n          examples:\n            - Bad Request\n        status:\n          type: integer\n          format: int64\n          examples:\n            - 400\n        detail:\n          type: string\n          examples:\n            - The request was invalid.\n    ForbiddenError:\n      x-scalar-ignore: true\n      description: RFC 7807 (https://datatracker.ietf.org/doc/html/rfc7807)\n      type: object\n      properties:\n        type:\n          type: string\n          examples:\n            - https://example.com/errors/forbidden\n        title:\n          type: string\n          examples:\n            - Forbidden\n        status:\n          type: integer\n          format: int64\n          examples:\n            - 403\n        detail:\n          type: string\n          examples:\n            - You are not authorized to access this resource.\n    NotFoundError:\n      x-scalar-ignore: true\n      description: RFC 7807 (https://datatracker.ietf.org/doc/html/rfc7807)\n      type: object\n      properties:\n        type:\n          type: string\n          examples:\n            - https://example.com/errors/not-found\n        title:\n          type: string\n          examples:\n            - Not Found\n        status:\n          type: integer\n          format: int64\n          examples:\n            - 404\n        detail:\n          type: string\n          examples:\n            - The resource you are trying to access does not exist.\n    UnauthorizedError:\n      x-scalar-ignore: true\n      description: RFC 7807 (https://datatracker.ietf.org/doc/html/rfc7807)\n      type: object\n      properties:\n        type:\n          type: string\n          examples:\n            - https://example.com/errors/not-found\n        title:\n          type: string\n          examples:\n            - Unauthorized\n        status:\n          type: integer\n          format: int64\n          examples:\n            - 401\n        detail:\n          type: string\n          examples:\n            - You are not authorized to access this resource.\n    Conflict:\n      x-scalar-ignore: true\n      description: RFC 7807 (https://datatracker.ietf.org/doc/html/rfc7807)\n      type: object\n      properties:\n        type:\n          type: string\n          examples:\n            - https://example.com/errors/conflict\n        title:\n          type: string\n          examples:\n            - Conflict\n        status:\n          type: integer\n          format: int64\n          examples:\n            - 409\n        detail:\n          type: string\n          examples:\n            - The resource you are trying to access is in conflict.\n    UnprocessableEntity:\n      x-scalar-ignore: true\n      description: RFC 7807 (https://datatracker.ietf.org/doc/html/rfc7807)\n      type: object\n      properties:\n        type:\n          type: string\n          examples:\n            - https://example.com/errors/unprocessable-entity\n        title:\n          type: string\n          examples:\n            - Unprocessable Entity\n        status:\n          type: integer\n          format: int64\n          examples:\n            - 422\n        detail:\n          type: string\n          examples:\n            - The request was invalid.\n    Satellite:\n      description: A natural satellite (moon) orbiting a planet\n      type: object\n      required:\n        - name\n      properties:\n        name:\n          type: string\n          examples:\n            - Phobos\n        diameter:\n          type: number\n          format: float\n          description: Diameter in kilometers\n          examples:\n            - 22.2\n",
  parsed:{ openapi:"3.1.1",
    info:{ title:"Scalar Galaxy",
      description:"The Scalar Galaxy is an example OpenAPI specification to test OpenAPI tools and libraries. It’s a fictional universe with fictional planets and fictional data. Get all the data for [all planets](#tag/planets/GET/planets).\n\n## Resources\n\n* https://github.com/scalar/scalar\n* https://github.com/OAI/OpenAPI-Specification\n* https://scalar.com\n\n## Markdown Support\n\nAll descriptions *can* contain ~~tons of text~~ **Markdown**. [If GitHub supports the syntax](https://docs.github.com/en/get-started/writing-on-github/getting-started-with-writing-and-formatting-on-github/basic-writing-and-formatting-syntax), chances are we’re supporting it, too. You can even create [internal links to reference endpoints](#tag/authentication/POST/user/signup).\n\n<details>\n  <summary>Examples</summary>\n\n  **Blockquotes**\n\n  > I love OpenAPI. <3\n\n  **Tables**\n\n  | Feature          | Availability |\n  | ---------------- | ------------ |\n  | Markdown Support | ✓            |\n\n  **Accordion**\n\n  ```html\n  <details>\n    <summary>Using Details Tags</summary>\n    <p>HTML Example</p>\n  </details>\n  ```\n\n  **Images**\n\n  Yes, there’s support for images, too!\n\n  ![Empty placeholder image showing the width/height](https://images.placeholders.dev/?width=1280&height=720)\n\n  **Alerts**\n\n  > [!tip]\n  > You can now use markdown alerts in your descriptions.\n\n</details>\n",
      version:"0.4.1",
      contact:{ name:"Marc from Scalar",
        url:"https://scalar.com",
        email:"marc@scalar.com" },
      license:{ name:"MIT",
        url:"https://opensource.org/license/MIT" } },
    externalDocs:{ description:"Documentation",
      url:"https://github.com/scalar/scalar" },
    servers:[ { url:"https://galaxy.scalar.com" },
      { url:"{protocol}://void.scalar.com/{path}",
        description:"Responds with your request data",
        variables:{ protocol:{ "enum":[ "https" ],
            "default":"https" },
          path:{ "default":"" } } } ],
    security:[ { bearerAuth:[  ] },
      { basicAuth:[  ] },
      { apiKeyQuery:[  ] },
      { apiKeyHeader:[  ] },
      { apiKeyCookie:[  ] },
      { oAuth2:[  ] },
      { openIdConnect:[  ] } ],
    tags:[ { name:"Authentication",
        description:"Some endpoints are public, but some require authentication. We provide all the required endpoints to create an account and authorize yourself.",
        operations:[ { httpVerb:"POST",
            path:"/user/signup",
            operationId:"createUser",
            name:"Create a user",
            description:"Time to create a user account, eh?",
            information:{ tags:[ "Authentication" ],
              summary:"Create a user",
              description:"Time to create a user account, eh?",
              operationId:"createUser",
              security:[ {} ],
              requestBody:{ description:"User to create",
                content:{ "application/json":{ schema:{ allOf:[ { description:"A user",
                          type:"object",
                          xml:{ name:"user" },
                          properties:{ id:{ type:"integer",
                              format:"int64",
                              readOnly:true,
                              examples:[ 1 ] },
                            name:{ type:"string",
                              examples:[ "Marc" ] } } },
                        { description:"Credentials to authenticate a user",
                          type:"object",
                          required:[ "email",
                            "password" ],
                          properties:{ email:{ type:"string",
                              format:"email",
                              examples:[ "marc@scalar.com" ] },
                            password:{ type:"string",
                              writeOnly:true,
                              examples:[ "i-love-scalar",
                                "i-love-OSS",
                                "i-love-code" ] } } } ] },
                    examples:{ Marc:{ value:{ name:"Marc",
                          email:"marc@scalar.com",
                          password:"i-love-scalar" } },
                      Cam:{ value:{ name:"Cam",
                          email:"cam@scalar.com",
                          password:"scalar-is-cool" } } } },
                  "application/xml":{ schema:{ allOf:[ { description:"A user",
                          type:"object",
                          xml:{ name:"user" },
                          properties:{ id:{ type:"integer",
                              format:"int64",
                              readOnly:true,
                              examples:[ 1 ] },
                            name:{ type:"string",
                              examples:[ "Marc" ] } } },
                        { description:"Credentials to authenticate a user",
                          type:"object",
                          required:[ "email",
                            "password" ],
                          properties:{ email:{ type:"string",
                              format:"email",
                              examples:[ "marc@scalar.com" ] },
                            password:{ type:"string",
                              writeOnly:true,
                              examples:[ "i-love-scalar",
                                "i-love-OSS",
                                "i-love-code" ] } } } ] },
                    examples:{ Marc:{ value:{ name:"Marc",
                          email:"marc@scalar.com",
                          password:"i-love-scalar" } },
                      Cam:{ value:{ name:"Cam",
                          email:"cam@scalar.com",
                          password:"scalar-is-cool" } } } } } },
              responses:{ 201:{ description:"Created",
                  content:{ "application/json":{ schema:{ description:"A user",
                        type:"object",
                        xml:{ name:"user" },
                        properties:{ id:{ type:"integer",
                            format:"int64",
                            readOnly:true,
                            examples:[ 1 ] },
                          name:{ type:"string",
                            examples:[ "Marc" ] } } } },
                    "application/xml":{ schema:{ description:"A user",
                        type:"object",
                        xml:{ name:"user" },
                        properties:{ id:{ type:"integer",
                            format:"int64",
                            readOnly:true,
                            examples:[ 1 ] },
                          name:{ type:"string",
                            examples:[ "Marc" ] } } } } } },
                400:{ description:"Bad Request",
                  content:{ "application/json":{ schema:{ "x-scalar-ignore":true,
                        description:"RFC 7807 (https://datatracker.ietf.org/doc/html/rfc7807)",
                        type:"object",
                        properties:{ type:{ type:"string",
                            examples:[ "https://example.com/errors/bad-request" ] },
                          title:{ type:"string",
                            examples:[ "Bad Request" ] },
                          status:{ type:"integer",
                            format:"int64",
                            examples:[ 400 ] },
                          detail:{ type:"string",
                            examples:[ "The request was invalid." ] } } } },
                    "application/xml":{ schema:{ "x-scalar-ignore":true,
                        description:"RFC 7807 (https://datatracker.ietf.org/doc/html/rfc7807)",
                        type:"object",
                        properties:{ type:{ type:"string",
                            examples:[ "https://example.com/errors/bad-request" ] },
                          title:{ type:"string",
                            examples:[ "Bad Request" ] },
                          status:{ type:"integer",
                            format:"int64",
                            examples:[ 400 ] },
                          detail:{ type:"string",
                            examples:[ "The request was invalid." ] } } } } } },
                401:{ description:"Unauthorized",
                  content:{ "application/json":{ schema:{ "x-scalar-ignore":true,
                        description:"RFC 7807 (https://datatracker.ietf.org/doc/html/rfc7807)",
                        type:"object",
                        properties:{ type:{ type:"string",
                            examples:[ "https://example.com/errors/not-found" ] },
                          title:{ type:"string",
                            examples:[ "Unauthorized" ] },
                          status:{ type:"integer",
                            format:"int64",
                            examples:[ 401 ] },
                          detail:{ type:"string",
                            examples:[ "You are not authorized to access this resource." ] } } } },
                    "application/xml":{ schema:{ "x-scalar-ignore":true,
                        description:"RFC 7807 (https://datatracker.ietf.org/doc/html/rfc7807)",
                        type:"object",
                        properties:{ type:{ type:"string",
                            examples:[ "https://example.com/errors/not-found" ] },
                          title:{ type:"string",
                            examples:[ "Unauthorized" ] },
                          status:{ type:"integer",
                            format:"int64",
                            examples:[ 401 ] },
                          detail:{ type:"string",
                            examples:[ "You are not authorized to access this resource." ] } } } } } },
                403:{ description:"Forbidden",
                  content:{ "application/json":{ schema:{ "x-scalar-ignore":true,
                        description:"RFC 7807 (https://datatracker.ietf.org/doc/html/rfc7807)",
                        type:"object",
                        properties:{ type:{ type:"string",
                            examples:[ "https://example.com/errors/forbidden" ] },
                          title:{ type:"string",
                            examples:[ "Forbidden" ] },
                          status:{ type:"integer",
                            format:"int64",
                            examples:[ 403 ] },
                          detail:{ type:"string",
                            examples:[ "You are not authorized to access this resource." ] } } } },
                    "application/xml":{ schema:{ "x-scalar-ignore":true,
                        description:"RFC 7807 (https://datatracker.ietf.org/doc/html/rfc7807)",
                        type:"object",
                        properties:{ type:{ type:"string",
                            examples:[ "https://example.com/errors/forbidden" ] },
                          title:{ type:"string",
                            examples:[ "Forbidden" ] },
                          status:{ type:"integer",
                            format:"int64",
                            examples:[ 403 ] },
                          detail:{ type:"string",
                            examples:[ "You are not authorized to access this resource." ] } } } } } },
                409:{ description:"Conflict",
                  content:{ "application/json":{ schema:{ "x-scalar-ignore":true,
                        description:"RFC 7807 (https://datatracker.ietf.org/doc/html/rfc7807)",
                        type:"object",
                        properties:{ type:{ type:"string",
                            examples:[ "https://example.com/errors/conflict" ] },
                          title:{ type:"string",
                            examples:[ "Conflict" ] },
                          status:{ type:"integer",
                            format:"int64",
                            examples:[ 409 ] },
                          detail:{ type:"string",
                            examples:[ "The resource you are trying to access is in conflict." ] } } } },
                    "application/xml":{ schema:{ "x-scalar-ignore":true,
                        description:"RFC 7807 (https://datatracker.ietf.org/doc/html/rfc7807)",
                        type:"object",
                        properties:{ type:{ type:"string",
                            examples:[ "https://example.com/errors/conflict" ] },
                          title:{ type:"string",
                            examples:[ "Conflict" ] },
                          status:{ type:"integer",
                            format:"int64",
                            examples:[ 409 ] },
                          detail:{ type:"string",
                            examples:[ "The resource you are trying to access is in conflict." ] } } } } } },
                422:{ description:"Unprocessable Entity",
                  content:{ "application/json":{ schema:{ "x-scalar-ignore":true,
                        description:"RFC 7807 (https://datatracker.ietf.org/doc/html/rfc7807)",
                        type:"object",
                        properties:{ type:{ type:"string",
                            examples:[ "https://example.com/errors/unprocessable-entity" ] },
                          title:{ type:"string",
                            examples:[ "Unprocessable Entity" ] },
                          status:{ type:"integer",
                            format:"int64",
                            examples:[ 422 ] },
                          detail:{ type:"string",
                            examples:[ "The request was invalid." ] } } } },
                    "application/xml":{ schema:{ "x-scalar-ignore":true,
                        description:"RFC 7807 (https://datatracker.ietf.org/doc/html/rfc7807)",
                        type:"object",
                        properties:{ type:{ type:"string",
                            examples:[ "https://example.com/errors/unprocessable-entity" ] },
                          title:{ type:"string",
                            examples:[ "Unprocessable Entity" ] },
                          status:{ type:"integer",
                            format:"int64",
                            examples:[ 422 ] },
                          detail:{ type:"string",
                            examples:[ "The request was invalid." ] } } } } } } } },
            pathParameters:undefined },
          { httpVerb:"POST",
            path:"/auth/token",
            operationId:"getToken",
            name:"Get a token",
            description:"Yeah, this is the boring security stuff. Just get your super secret token and move on.",
            information:{ tags:[ "Authentication" ],
              summary:"Get a token",
              description:"Yeah, this is the boring security stuff. Just get your super secret token and move on.",
              operationId:"getToken",
              security:[ {} ],
              requestBody:{ description:"Credentials to authenticate a user",
                content:{ "application/json":{ schema:{ description:"Credentials to authenticate a user",
                      type:"object",
                      required:[ "email",
                        "password" ],
                      properties:{ email:{ type:"string",
                          format:"email",
                          examples:[ "marc@scalar.com" ] },
                        password:{ type:"string",
                          writeOnly:true,
                          examples:[ "i-love-scalar",
                            "i-love-OSS",
                            "i-love-code" ] } } } },
                  "application/xml":{ schema:{ description:"Credentials to authenticate a user",
                      type:"object",
                      required:[ "email",
                        "password" ],
                      properties:{ email:{ type:"string",
                          format:"email",
                          examples:[ "marc@scalar.com" ] },
                        password:{ type:"string",
                          writeOnly:true,
                          examples:[ "i-love-scalar",
                            "i-love-OSS",
                            "i-love-code" ] } } } } } },
              responses:{ 201:{ description:"Token Created",
                  content:{ "application/json":{ schema:{ description:"A token to authenticate a user",
                        type:"object",
                        properties:{ token:{ type:"string",
                            examples:[ "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiIxMjM0NTY3ODkwIiwibmFtZSI6IkpvaG4gRG9lIiwiaWF0IjoxNTE2MjM5MDIyfQ.SflKxwRJSMeKKF2QT4fwpMeJf36POk6yJV_adQssw5c" ] } } } },
                    "application/xml":{ schema:{ description:"A token to authenticate a user",
                        type:"object",
                        properties:{ token:{ type:"string",
                            examples:[ "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiIxMjM0NTY3ODkwIiwibmFtZSI6IkpvaG4gRG9lIiwiaWF0IjoxNTE2MjM5MDIyfQ.SflKxwRJSMeKKF2QT4fwpMeJf36POk6yJV_adQssw5c" ] } } } } } },
                400:{ description:"Bad Request",
                  content:{ "application/json":{ schema:{ "x-scalar-ignore":true,
                        description:"RFC 7807 (https://datatracker.ietf.org/doc/html/rfc7807)",
                        type:"object",
                        properties:{ type:{ type:"string",
                            examples:[ "https://example.com/errors/bad-request" ] },
                          title:{ type:"string",
                            examples:[ "Bad Request" ] },
                          status:{ type:"integer",
                            format:"int64",
                            examples:[ 400 ] },
                          detail:{ type:"string",
                            examples:[ "The request was invalid." ] } } } },
                    "application/xml":{ schema:{ "x-scalar-ignore":true,
                        description:"RFC 7807 (https://datatracker.ietf.org/doc/html/rfc7807)",
                        type:"object",
                        properties:{ type:{ type:"string",
                            examples:[ "https://example.com/errors/bad-request" ] },
                          title:{ type:"string",
                            examples:[ "Bad Request" ] },
                          status:{ type:"integer",
                            format:"int64",
                            examples:[ 400 ] },
                          detail:{ type:"string",
                            examples:[ "The request was invalid." ] } } } } } },
                401:{ description:"Unauthorized",
                  content:{ "application/json":{ schema:{ "x-scalar-ignore":true,
                        description:"RFC 7807 (https://datatracker.ietf.org/doc/html/rfc7807)",
                        type:"object",
                        properties:{ type:{ type:"string",
                            examples:[ "https://example.com/errors/not-found" ] },
                          title:{ type:"string",
                            examples:[ "Unauthorized" ] },
                          status:{ type:"integer",
                            format:"int64",
                            examples:[ 401 ] },
                          detail:{ type:"string",
                            examples:[ "You are not authorized to access this resource." ] } } } },
                    "application/xml":{ schema:{ "x-scalar-ignore":true,
                        description:"RFC 7807 (https://datatracker.ietf.org/doc/html/rfc7807)",
                        type:"object",
                        properties:{ type:{ type:"string",
                            examples:[ "https://example.com/errors/not-found" ] },
                          title:{ type:"string",
                            examples:[ "Unauthorized" ] },
                          status:{ type:"integer",
                            format:"int64",
                            examples:[ 401 ] },
                          detail:{ type:"string",
                            examples:[ "You are not authorized to access this resource." ] } } } } } },
                403:{ description:"Forbidden",
                  content:{ "application/json":{ schema:{ "x-scalar-ignore":true,
                        description:"RFC 7807 (https://datatracker.ietf.org/doc/html/rfc7807)",
                        type:"object",
                        properties:{ type:{ type:"string",
                            examples:[ "https://example.com/errors/forbidden" ] },
                          title:{ type:"string",
                            examples:[ "Forbidden" ] },
                          status:{ type:"integer",
                            format:"int64",
                            examples:[ 403 ] },
                          detail:{ type:"string",
                            examples:[ "You are not authorized to access this resource." ] } } } },
                    "application/xml":{ schema:{ "x-scalar-ignore":true,
                        description:"RFC 7807 (https://datatracker.ietf.org/doc/html/rfc7807)",
                        type:"object",
                        properties:{ type:{ type:"string",
                            examples:[ "https://example.com/errors/forbidden" ] },
                          title:{ type:"string",
                            examples:[ "Forbidden" ] },
                          status:{ type:"integer",
                            format:"int64",
                            examples:[ 403 ] },
                          detail:{ type:"string",
                            examples:[ "You are not authorized to access this resource." ] } } } } } } } },
            pathParameters:undefined },
          { httpVerb:"GET",
            path:"/me",
            operationId:"getMe",
            name:"Get authenticated user",
            description:"Find yourself they say. That’s what you can do here.",
            information:{ tags:[ "Authentication" ],
              summary:"Get authenticated user",
              description:"Find yourself they say. That’s what you can do here.",
              operationId:"getMe",
              security:[ { basicAuth:[  ] },
                { oAuth2:[ "read:account" ] },
                { bearerAuth:[  ] },
                { apiKeyHeader:[  ] },
                { apiKeyQuery:[  ] } ],
              responses:{ 200:{ description:"OK",
                  content:{ "application/json":{ schema:{ description:"A user",
                        type:"object",
                        xml:{ name:"user" },
                        properties:{ id:{ type:"integer",
                            format:"int64",
                            readOnly:true,
                            examples:[ 1 ] },
                          name:{ type:"string",
                            examples:[ "Marc" ] } } } },
                    "application/xml":{ schema:{ description:"A user",
                        type:"object",
                        xml:{ name:"user" },
                        properties:{ id:{ type:"integer",
                            format:"int64",
                            readOnly:true,
                            examples:[ 1 ] },
                          name:{ type:"string",
                            examples:[ "Marc" ] } } } } } },
                401:{ description:"Unauthorized",
                  content:{ "application/json":{ schema:{ "x-scalar-ignore":true,
                        description:"RFC 7807 (https://datatracker.ietf.org/doc/html/rfc7807)",
                        type:"object",
                        properties:{ type:{ type:"string",
                            examples:[ "https://example.com/errors/not-found" ] },
                          title:{ type:"string",
                            examples:[ "Unauthorized" ] },
                          status:{ type:"integer",
                            format:"int64",
                            examples:[ 401 ] },
                          detail:{ type:"string",
                            examples:[ "You are not authorized to access this resource." ] } } } },
                    "application/xml":{ schema:{ "x-scalar-ignore":true,
                        description:"RFC 7807 (https://datatracker.ietf.org/doc/html/rfc7807)",
                        type:"object",
                        properties:{ type:{ type:"string",
                            examples:[ "https://example.com/errors/not-found" ] },
                          title:{ type:"string",
                            examples:[ "Unauthorized" ] },
                          status:{ type:"integer",
                            format:"int64",
                            examples:[ 401 ] },
                          detail:{ type:"string",
                            examples:[ "You are not authorized to access this resource." ] } } } } } },
                403:{ description:"Forbidden",
                  content:{ "application/json":{ schema:{ "x-scalar-ignore":true,
                        description:"RFC 7807 (https://datatracker.ietf.org/doc/html/rfc7807)",
                        type:"object",
                        properties:{ type:{ type:"string",
                            examples:[ "https://example.com/errors/forbidden" ] },
                          title:{ type:"string",
                            examples:[ "Forbidden" ] },
                          status:{ type:"integer",
                            format:"int64",
                            examples:[ 403 ] },
                          detail:{ type:"string",
                            examples:[ "You are not authorized to access this resource." ] } } } },
                    "application/xml":{ schema:{ "x-scalar-ignore":true,
                        description:"RFC 7807 (https://datatracker.ietf.org/doc/html/rfc7807)",
                        type:"object",
                        properties:{ type:{ type:"string",
                            examples:[ "https://example.com/errors/forbidden" ] },
                          title:{ type:"string",
                            examples:[ "Forbidden" ] },
                          status:{ type:"integer",
                            format:"int64",
                            examples:[ 403 ] },
                          detail:{ type:"string",
                            examples:[ "You are not authorized to access this resource." ] } } } } } } } },
            pathParameters:undefined } ] },
      { name:"Planets",
        description:"Everything about planets",
        operations:[ { httpVerb:"GET",
            path:"/planets",
            operationId:"getAllData",
            name:"Get all planets",
            description:"It’s easy to say you know them all, but do you really? Retrieve all the planets and check whether you missed one.",
            information:{ tags:[ "Planets" ],
              summary:"Get all planets",
              description:"It’s easy to say you know them all, but do you really? Retrieve all the planets and check whether you missed one.",
              operationId:"getAllData",
              security:[ {} ],
              parameters:[ { name:"limit",
                  description:"The number of items to return",
                  "in":"query",
                  required:false,
                  schema:{ type:"integer",
                    format:"int64",
                    "default":10 } },
                { name:"offset",
                  description:"The number of items to skip before starting to collect the result set",
                  "in":"query",
                  required:false,
                  schema:{ type:"integer",
                    format:"int64",
                    "default":0 } } ],
              responses:{ 200:{ description:"OK",
                  content:{ "application/json":{ schema:{ allOf:[ { type:"object",
                            properties:{ data:{ type:"array",
                                items:{ description:"A planet in the Scalar Galaxy",
                                  type:"object",
                                  required:[ "id",
                                    "name" ],
                                  xml:{ name:"planet" },
                                  properties:{ id:{ type:"integer",
                                      format:"int64",
                                      readOnly:true,
                                      examples:[ 1 ],
                                      "x-variable":"planetId" },
                                    name:{ type:"string",
                                      examples:[ "Mars",
                                        "Jupiter",
                                        "HD 40307g" ] },
                                    description:{ type:[ "string",
                                        "null" ],
                                      examples:[ "The red planet",
                                        "A gas giant with a great red spot" ] },
                                    type:{ type:"string",
                                      "enum":[ "terrestrial",
                                        "gas_giant",
                                        "ice_giant",
                                        "dwarf",
                                        "super_earth" ],
                                      examples:[ "terrestrial" ] },
                                    habitabilityIndex:{ type:"number",
                                      format:"float",
                                      minimum:0,
                                      maximum:1,
                                      description:"A score from 0 to 1 indicating potential habitability",
                                      examples:[ 0.68 ] },
                                    physicalProperties:{ type:"object",
                                      properties:{ mass:{ type:"number",
                                          format:"float",
                                          description:"Mass in Earth masses",
                                          examples:[ 0.107 ] },
                                        radius:{ type:"number",
                                          format:"float",
                                          description:"Radius in Earth radii",
                                          examples:[ 0.532 ] },
                                        gravity:{ type:"number",
                                          format:"float",
                                          description:"Surface gravity in Earth g",
                                          examples:[ 0.378 ] },
                                        temperature:{ type:"object",
                                          properties:{ min:{ type:"number",
                                              format:"float",
                                              description:"Minimum temperature in Kelvin",
                                              examples:[ 130 ] },
                                            max:{ type:"number",
                                              format:"float",
                                              description:"Maximum temperature in Kelvin",
                                              examples:[ 308 ] },
                                            average:{ type:"number",
                                              format:"float",
                                              description:"Average temperature in Kelvin",
                                              examples:[ 210 ] } } } } },
                                    atmosphere:{ type:"array",
                                      description:"Atmospheric composition",
                                      items:{ type:"object",
                                        properties:{ compound:{ type:"string",
                                            examples:[ "CO2",
                                              "N2" ] },
                                          percentage:{ type:"number",
                                            format:"float",
                                            examples:[ 95.3 ] } } } },
                                    discoveredAt:{ type:"string",
                                      format:"date-time",
                                      examples:[ "1610-01-07T00:00:00Z" ] },
                                    image:{ type:"string",
                                      nullable:true,
                                      examples:[ "https://cdn.scalar.com/photos/mars.jpg" ] },
                                    satellites:{ type:"array",
                                      items:{ description:"A natural satellite (moon) orbiting a planet",
                                        type:"object",
                                        required:[ "name" ],
                                        properties:{ name:{ type:"string",
                                            examples:[ "Phobos" ] },
                                          diameter:{ type:"number",
                                            format:"float",
                                            description:"Diameter in kilometers",
                                            examples:[ 22.2 ] } } } },
                                    creator:{ description:"A user",
                                      type:"object",
                                      xml:{ name:"user" },
                                      properties:{ id:{ type:"integer",
                                          format:"int64",
                                          readOnly:true,
                                          examples:[ 1 ] },
                                        name:{ type:"string",
                                          examples:[ "Marc" ] } } },
                                    tags:{ type:"array",
                                      items:{ type:"string" },
                                      examples:[ [ "solar-system",
                                          "rocky",
                                          "explored" ] ] },
                                    lastUpdated:{ type:"string",
                                      format:"date-time",
                                      readOnly:true,
                                      examples:[ "2024-01-15T14:30:00Z" ] },
                                    callbackUrl:{ type:"string",
                                      format:"uri",
                                      description:"URL to receive notifications about this planet",
                                      examples:[ "https://example.com/webhook" ] } } } } } },
                          { description:"A paginated resource",
                            type:"object",
                            properties:{ meta:{ type:"object",
                                properties:{ limit:{ type:"integer",
                                    format:"int64",
                                    examples:[ 10 ] },
                                  offset:{ type:"integer",
                                    format:"int64",
                                    examples:[ 0 ] },
                                  total:{ type:"integer",
                                    format:"int64",
                                    examples:[ 100 ] },
                                  next:{ type:[ "string",
                                      "null" ],
                                    examples:[ "/planets?limit=10&offset=10" ] } } } } } ] } },
                    "application/xml":{ schema:{ allOf:[ { type:"object",
                            xml:{ name:"planets" },
                            properties:{ data:{ type:"array",
                                items:{ description:"A planet in the Scalar Galaxy",
                                  type:"object",
                                  required:[ "id",
                                    "name" ],
                                  xml:{ name:"planet" },
                                  properties:{ id:{ type:"integer",
                                      format:"int64",
                                      readOnly:true,
                                      examples:[ 1 ],
                                      "x-variable":"planetId" },
                                    name:{ type:"string",
                                      examples:[ "Mars",
                                        "Jupiter",
                                        "HD 40307g" ] },
                                    description:{ type:[ "string",
                                        "null" ],
                                      examples:[ "The red planet",
                                        "A gas giant with a great red spot" ] },
                                    type:{ type:"string",
                                      "enum":[ "terrestrial",
                                        "gas_giant",
                                        "ice_giant",
                                        "dwarf",
                                        "super_earth" ],
                                      examples:[ "terrestrial" ] },
                                    habitabilityIndex:{ type:"number",
                                      format:"float",
                                      minimum:0,
                                      maximum:1,
                                      description:"A score from 0 to 1 indicating potential habitability",
                                      examples:[ 0.68 ] },
                                    physicalProperties:{ type:"object",
                                      properties:{ mass:{ type:"number",
                                          format:"float",
                                          description:"Mass in Earth masses",
                                          examples:[ 0.107 ] },
                                        radius:{ type:"number",
                                          format:"float",
                                          description:"Radius in Earth radii",
                                          examples:[ 0.532 ] },
                                        gravity:{ type:"number",
                                          format:"float",
                                          description:"Surface gravity in Earth g",
                                          examples:[ 0.378 ] },
                                        temperature:{ type:"object",
                                          properties:{ min:{ type:"number",
                                              format:"float",
                                              description:"Minimum temperature in Kelvin",
                                              examples:[ 130 ] },
                                            max:{ type:"number",
                                              format:"float",
                                              description:"Maximum temperature in Kelvin",
                                              examples:[ 308 ] },
                                            average:{ type:"number",
                                              format:"float",
                                              description:"Average temperature in Kelvin",
                                              examples:[ 210 ] } } } } },
                                    atmosphere:{ type:"array",
                                      description:"Atmospheric composition",
                                      items:{ type:"object",
                                        properties:{ compound:{ type:"string",
                                            examples:[ "CO2",
                                              "N2" ] },
                                          percentage:{ type:"number",
                                            format:"float",
                                            examples:[ 95.3 ] } } } },
                                    discoveredAt:{ type:"string",
                                      format:"date-time",
                                      examples:[ "1610-01-07T00:00:00Z" ] },
                                    image:{ type:"string",
                                      nullable:true,
                                      examples:[ "https://cdn.scalar.com/photos/mars.jpg" ] },
                                    satellites:{ type:"array",
                                      items:{ description:"A natural satellite (moon) orbiting a planet",
                                        type:"object",
                                        required:[ "name" ],
                                        properties:{ name:{ type:"string",
                                            examples:[ "Phobos" ] },
                                          diameter:{ type:"number",
                                            format:"float",
                                            description:"Diameter in kilometers",
                                            examples:[ 22.2 ] } } } },
                                    creator:{ description:"A user",
                                      type:"object",
                                      xml:{ name:"user" },
                                      properties:{ id:{ type:"integer",
                                          format:"int64",
                                          readOnly:true,
                                          examples:[ 1 ] },
                                        name:{ type:"string",
                                          examples:[ "Marc" ] } } },
                                    tags:{ type:"array",
                                      items:{ type:"string" },
                                      examples:[ [ "solar-system",
                                          "rocky",
                                          "explored" ] ] },
                                    lastUpdated:{ type:"string",
                                      format:"date-time",
                                      readOnly:true,
                                      examples:[ "2024-01-15T14:30:00Z" ] },
                                    callbackUrl:{ type:"string",
                                      format:"uri",
                                      description:"URL to receive notifications about this planet",
                                      examples:[ "https://example.com/webhook" ] } } } } } },
                          { description:"A paginated resource",
                            type:"object",
                            properties:{ meta:{ type:"object",
                                properties:{ limit:{ type:"integer",
                                    format:"int64",
                                    examples:[ 10 ] },
                                  offset:{ type:"integer",
                                    format:"int64",
                                    examples:[ 0 ] },
                                  total:{ type:"integer",
                                    format:"int64",
                                    examples:[ 100 ] },
                                  next:{ type:[ "string",
                                      "null" ],
                                    examples:[ "/planets?limit=10&offset=10" ] } } } } } ] } } } } } },
            pathParameters:undefined },
          { httpVerb:"POST",
            path:"/planets",
            operationId:"createPlanet",
            name:"Create a planet",
            description:"Time to play god and create a new planet. What do you think? Ah, don’t think too much. What could go wrong anyway?",
            information:{ tags:[ "Planets" ],
              summary:"Create a planet",
              description:"Time to play god and create a new planet. What do you think? Ah, don’t think too much. What could go wrong anyway?",
              operationId:"createPlanet",
              callbacks:{ planetCreated:{ "{$request.body#/callbackUrl}":{ post:{ requestBody:{ description:"Information about the newly created planet",
                        content:{ "application/json":{ schema:{ description:"A planet in the Scalar Galaxy",
                              type:"object",
                              required:[ "id",
                                "name" ],
                              xml:{ name:"planet" },
                              properties:{ id:{ type:"integer",
                                  format:"int64",
                                  readOnly:true,
                                  examples:[ 1 ],
                                  "x-variable":"planetId" },
                                name:{ type:"string",
                                  examples:[ "Mars",
                                    "Jupiter",
                                    "HD 40307g" ] },
                                description:{ type:[ "string",
                                    "null" ],
                                  examples:[ "The red planet",
                                    "A gas giant with a great red spot" ] },
                                type:{ type:"string",
                                  "enum":[ "terrestrial",
                                    "gas_giant",
                                    "ice_giant",
                                    "dwarf",
                                    "super_earth" ],
                                  examples:[ "terrestrial" ] },
                                habitabilityIndex:{ type:"number",
                                  format:"float",
                                  minimum:0,
                                  maximum:1,
                                  description:"A score from 0 to 1 indicating potential habitability",
                                  examples:[ 0.68 ] },
                                physicalProperties:{ type:"object",
                                  properties:{ mass:{ type:"number",
                                      format:"float",
                                      description:"Mass in Earth masses",
                                      examples:[ 0.107 ] },
                                    radius:{ type:"number",
                                      format:"float",
                                      description:"Radius in Earth radii",
                                      examples:[ 0.532 ] },
                                    gravity:{ type:"number",
                                      format:"float",
                                      description:"Surface gravity in Earth g",
                                      examples:[ 0.378 ] },
                                    temperature:{ type:"object",
                                      properties:{ min:{ type:"number",
                                          format:"float",
                                          description:"Minimum temperature in Kelvin",
                                          examples:[ 130 ] },
                                        max:{ type:"number",
                                          format:"float",
                                          description:"Maximum temperature in Kelvin",
                                          examples:[ 308 ] },
                                        average:{ type:"number",
                                          format:"float",
                                          description:"Average temperature in Kelvin",
                                          examples:[ 210 ] } } } } },
                                atmosphere:{ type:"array",
                                  description:"Atmospheric composition",
                                  items:{ type:"object",
                                    properties:{ compound:{ type:"string",
                                        examples:[ "CO2",
                                          "N2" ] },
                                      percentage:{ type:"number",
                                        format:"float",
                                        examples:[ 95.3 ] } } } },
                                discoveredAt:{ type:"string",
                                  format:"date-time",
                                  examples:[ "1610-01-07T00:00:00Z" ] },
                                image:{ type:"string",
                                  nullable:true,
                                  examples:[ "https://cdn.scalar.com/photos/mars.jpg" ] },
                                satellites:{ type:"array",
                                  items:{ description:"A natural satellite (moon) orbiting a planet",
                                    type:"object",
                                    required:[ "name" ],
                                    properties:{ name:{ type:"string",
                                        examples:[ "Phobos" ] },
                                      diameter:{ type:"number",
                                        format:"float",
                                        description:"Diameter in kilometers",
                                        examples:[ 22.2 ] } } } },
                                creator:{ description:"A user",
                                  type:"object",
                                  xml:{ name:"user" },
                                  properties:{ id:{ type:"integer",
                                      format:"int64",
                                      readOnly:true,
                                      examples:[ 1 ] },
                                    name:{ type:"string",
                                      examples:[ "Marc" ] } } },
                                tags:{ type:"array",
                                  items:{ type:"string" },
                                  examples:[ [ "solar-system",
                                      "rocky",
                                      "explored" ] ] },
                                lastUpdated:{ type:"string",
                                  format:"date-time",
                                  readOnly:true,
                                  examples:[ "2024-01-15T14:30:00Z" ] },
                                callbackUrl:{ type:"string",
                                  format:"uri",
                                  description:"URL to receive notifications about this planet",
                                  examples:[ "https://example.com/webhook" ] } } } } } },
                      responses:{ 200:{ description:"Your server returns this code if it accepts the callback" } } } } } },
              requestBody:{ description:"Planet",
                content:{ "application/json":{ schema:{ description:"A planet in the Scalar Galaxy",
                      type:"object",
                      required:[ "id",
                        "name" ],
                      xml:{ name:"planet" },
                      properties:{ id:{ type:"integer",
                          format:"int64",
                          readOnly:true,
                          examples:[ 1 ],
                          "x-variable":"planetId" },
                        name:{ type:"string",
                          examples:[ "Mars",
                            "Jupiter",
                            "HD 40307g" ] },
                        description:{ type:[ "string",
                            "null" ],
                          examples:[ "The red planet",
                            "A gas giant with a great red spot" ] },
                        type:{ type:"string",
                          "enum":[ "terrestrial",
                            "gas_giant",
                            "ice_giant",
                            "dwarf",
                            "super_earth" ],
                          examples:[ "terrestrial" ] },
                        habitabilityIndex:{ type:"number",
                          format:"float",
                          minimum:0,
                          maximum:1,
                          description:"A score from 0 to 1 indicating potential habitability",
                          examples:[ 0.68 ] },
                        physicalProperties:{ type:"object",
                          properties:{ mass:{ type:"number",
                              format:"float",
                              description:"Mass in Earth masses",
                              examples:[ 0.107 ] },
                            radius:{ type:"number",
                              format:"float",
                              description:"Radius in Earth radii",
                              examples:[ 0.532 ] },
                            gravity:{ type:"number",
                              format:"float",
                              description:"Surface gravity in Earth g",
                              examples:[ 0.378 ] },
                            temperature:{ type:"object",
                              properties:{ min:{ type:"number",
                                  format:"float",
                                  description:"Minimum temperature in Kelvin",
                                  examples:[ 130 ] },
                                max:{ type:"number",
                                  format:"float",
                                  description:"Maximum temperature in Kelvin",
                                  examples:[ 308 ] },
                                average:{ type:"number",
                                  format:"float",
                                  description:"Average temperature in Kelvin",
                                  examples:[ 210 ] } } } } },
                        atmosphere:{ type:"array",
                          description:"Atmospheric composition",
                          items:{ type:"object",
                            properties:{ compound:{ type:"string",
                                examples:[ "CO2",
                                  "N2" ] },
                              percentage:{ type:"number",
                                format:"float",
                                examples:[ 95.3 ] } } } },
                        discoveredAt:{ type:"string",
                          format:"date-time",
                          examples:[ "1610-01-07T00:00:00Z" ] },
                        image:{ type:"string",
                          nullable:true,
                          examples:[ "https://cdn.scalar.com/photos/mars.jpg" ] },
                        satellites:{ type:"array",
                          items:{ description:"A natural satellite (moon) orbiting a planet",
                            type:"object",
                            required:[ "name" ],
                            properties:{ name:{ type:"string",
                                examples:[ "Phobos" ] },
                              diameter:{ type:"number",
                                format:"float",
                                description:"Diameter in kilometers",
                                examples:[ 22.2 ] } } } },
                        creator:{ description:"A user",
                          type:"object",
                          xml:{ name:"user" },
                          properties:{ id:{ type:"integer",
                              format:"int64",
                              readOnly:true,
                              examples:[ 1 ] },
                            name:{ type:"string",
                              examples:[ "Marc" ] } } },
                        tags:{ type:"array",
                          items:{ type:"string" },
                          examples:[ [ "solar-system",
                              "rocky",
                              "explored" ] ] },
                        lastUpdated:{ type:"string",
                          format:"date-time",
                          readOnly:true,
                          examples:[ "2024-01-15T14:30:00Z" ] },
                        callbackUrl:{ type:"string",
                          format:"uri",
                          description:"URL to receive notifications about this planet",
                          examples:[ "https://example.com/webhook" ] } } } },
                  "application/xml":{ schema:{ description:"A planet in the Scalar Galaxy",
                      type:"object",
                      required:[ "id",
                        "name" ],
                      xml:{ name:"planet" },
                      properties:{ id:{ type:"integer",
                          format:"int64",
                          readOnly:true,
                          examples:[ 1 ],
                          "x-variable":"planetId" },
                        name:{ type:"string",
                          examples:[ "Mars",
                            "Jupiter",
                            "HD 40307g" ] },
                        description:{ type:[ "string",
                            "null" ],
                          examples:[ "The red planet",
                            "A gas giant with a great red spot" ] },
                        type:{ type:"string",
                          "enum":[ "terrestrial",
                            "gas_giant",
                            "ice_giant",
                            "dwarf",
                            "super_earth" ],
                          examples:[ "terrestrial" ] },
                        habitabilityIndex:{ type:"number",
                          format:"float",
                          minimum:0,
                          maximum:1,
                          description:"A score from 0 to 1 indicating potential habitability",
                          examples:[ 0.68 ] },
                        physicalProperties:{ type:"object",
                          properties:{ mass:{ type:"number",
                              format:"float",
                              description:"Mass in Earth masses",
                              examples:[ 0.107 ] },
                            radius:{ type:"number",
                              format:"float",
                              description:"Radius in Earth radii",
                              examples:[ 0.532 ] },
                            gravity:{ type:"number",
                              format:"float",
                              description:"Surface gravity in Earth g",
                              examples:[ 0.378 ] },
                            temperature:{ type:"object",
                              properties:{ min:{ type:"number",
                                  format:"float",
                                  description:"Minimum temperature in Kelvin",
                                  examples:[ 130 ] },
                                max:{ type:"number",
                                  format:"float",
                                  description:"Maximum temperature in Kelvin",
                                  examples:[ 308 ] },
                                average:{ type:"number",
                                  format:"float",
                                  description:"Average temperature in Kelvin",
                                  examples:[ 210 ] } } } } },
                        atmosphere:{ type:"array",
                          description:"Atmospheric composition",
                          items:{ type:"object",
                            properties:{ compound:{ type:"string",
                                examples:[ "CO2",
                                  "N2" ] },
                              percentage:{ type:"number",
                                format:"float",
                                examples:[ 95.3 ] } } } },
                        discoveredAt:{ type:"string",
                          format:"date-time",
                          examples:[ "1610-01-07T00:00:00Z" ] },
                        image:{ type:"string",
                          nullable:true,
                          examples:[ "https://cdn.scalar.com/photos/mars.jpg" ] },
                        satellites:{ type:"array",
                          items:{ description:"A natural satellite (moon) orbiting a planet",
                            type:"object",
                            required:[ "name" ],
                            properties:{ name:{ type:"string",
                                examples:[ "Phobos" ] },
                              diameter:{ type:"number",
                                format:"float",
                                description:"Diameter in kilometers",
                                examples:[ 22.2 ] } } } },
                        creator:{ description:"A user",
                          type:"object",
                          xml:{ name:"user" },
                          properties:{ id:{ type:"integer",
                              format:"int64",
                              readOnly:true,
                              examples:[ 1 ] },
                            name:{ type:"string",
                              examples:[ "Marc" ] } } },
                        tags:{ type:"array",
                          items:{ type:"string" },
                          examples:[ [ "solar-system",
                              "rocky",
                              "explored" ] ] },
                        lastUpdated:{ type:"string",
                          format:"date-time",
                          readOnly:true,
                          examples:[ "2024-01-15T14:30:00Z" ] },
                        callbackUrl:{ type:"string",
                          format:"uri",
                          description:"URL to receive notifications about this planet",
                          examples:[ "https://example.com/webhook" ] } } } } } },
              responses:{ 201:{ description:"Created",
                  content:{ "application/json":{ schema:{ description:"A planet in the Scalar Galaxy",
                        type:"object",
                        required:[ "id",
                          "name" ],
                        xml:{ name:"planet" },
                        properties:{ id:{ type:"integer",
                            format:"int64",
                            readOnly:true,
                            examples:[ 1 ],
                            "x-variable":"planetId" },
                          name:{ type:"string",
                            examples:[ "Mars",
                              "Jupiter",
                              "HD 40307g" ] },
                          description:{ type:[ "string",
                              "null" ],
                            examples:[ "The red planet",
                              "A gas giant with a great red spot" ] },
                          type:{ type:"string",
                            "enum":[ "terrestrial",
                              "gas_giant",
                              "ice_giant",
                              "dwarf",
                              "super_earth" ],
                            examples:[ "terrestrial" ] },
                          habitabilityIndex:{ type:"number",
                            format:"float",
                            minimum:0,
                            maximum:1,
                            description:"A score from 0 to 1 indicating potential habitability",
                            examples:[ 0.68 ] },
                          physicalProperties:{ type:"object",
                            properties:{ mass:{ type:"number",
                                format:"float",
                                description:"Mass in Earth masses",
                                examples:[ 0.107 ] },
                              radius:{ type:"number",
                                format:"float",
                                description:"Radius in Earth radii",
                                examples:[ 0.532 ] },
                              gravity:{ type:"number",
                                format:"float",
                                description:"Surface gravity in Earth g",
                                examples:[ 0.378 ] },
                              temperature:{ type:"object",
                                properties:{ min:{ type:"number",
                                    format:"float",
                                    description:"Minimum temperature in Kelvin",
                                    examples:[ 130 ] },
                                  max:{ type:"number",
                                    format:"float",
                                    description:"Maximum temperature in Kelvin",
                                    examples:[ 308 ] },
                                  average:{ type:"number",
                                    format:"float",
                                    description:"Average temperature in Kelvin",
                                    examples:[ 210 ] } } } } },
                          atmosphere:{ type:"array",
                            description:"Atmospheric composition",
                            items:{ type:"object",
                              properties:{ compound:{ type:"string",
                                  examples:[ "CO2",
                                    "N2" ] },
                                percentage:{ type:"number",
                                  format:"float",
                                  examples:[ 95.3 ] } } } },
                          discoveredAt:{ type:"string",
                            format:"date-time",
                            examples:[ "1610-01-07T00:00:00Z" ] },
                          image:{ type:"string",
                            nullable:true,
                            examples:[ "https://cdn.scalar.com/photos/mars.jpg" ] },
                          satellites:{ type:"array",
                            items:{ description:"A natural satellite (moon) orbiting a planet",
                              type:"object",
                              required:[ "name" ],
                              properties:{ name:{ type:"string",
                                  examples:[ "Phobos" ] },
                                diameter:{ type:"number",
                                  format:"float",
                                  description:"Diameter in kilometers",
                                  examples:[ 22.2 ] } } } },
                          creator:{ description:"A user",
                            type:"object",
                            xml:{ name:"user" },
                            properties:{ id:{ type:"integer",
                                format:"int64",
                                readOnly:true,
                                examples:[ 1 ] },
                              name:{ type:"string",
                                examples:[ "Marc" ] } } },
                          tags:{ type:"array",
                            items:{ type:"string" },
                            examples:[ [ "solar-system",
                                "rocky",
                                "explored" ] ] },
                          lastUpdated:{ type:"string",
                            format:"date-time",
                            readOnly:true,
                            examples:[ "2024-01-15T14:30:00Z" ] },
                          callbackUrl:{ type:"string",
                            format:"uri",
                            description:"URL to receive notifications about this planet",
                            examples:[ "https://example.com/webhook" ] } } } },
                    "application/xml":{ schema:{ description:"A planet in the Scalar Galaxy",
                        type:"object",
                        required:[ "id",
                          "name" ],
                        xml:{ name:"planet" },
                        properties:{ id:{ type:"integer",
                            format:"int64",
                            readOnly:true,
                            examples:[ 1 ],
                            "x-variable":"planetId" },
                          name:{ type:"string",
                            examples:[ "Mars",
                              "Jupiter",
                              "HD 40307g" ] },
                          description:{ type:[ "string",
                              "null" ],
                            examples:[ "The red planet",
                              "A gas giant with a great red spot" ] },
                          type:{ type:"string",
                            "enum":[ "terrestrial",
                              "gas_giant",
                              "ice_giant",
                              "dwarf",
                              "super_earth" ],
                            examples:[ "terrestrial" ] },
                          habitabilityIndex:{ type:"number",
                            format:"float",
                            minimum:0,
                            maximum:1,
                            description:"A score from 0 to 1 indicating potential habitability",
                            examples:[ 0.68 ] },
                          physicalProperties:{ type:"object",
                            properties:{ mass:{ type:"number",
                                format:"float",
                                description:"Mass in Earth masses",
                                examples:[ 0.107 ] },
                              radius:{ type:"number",
                                format:"float",
                                description:"Radius in Earth radii",
                                examples:[ 0.532 ] },
                              gravity:{ type:"number",
                                format:"float",
                                description:"Surface gravity in Earth g",
                                examples:[ 0.378 ] },
                              temperature:{ type:"object",
                                properties:{ min:{ type:"number",
                                    format:"float",
                                    description:"Minimum temperature in Kelvin",
                                    examples:[ 130 ] },
                                  max:{ type:"number",
                                    format:"float",
                                    description:"Maximum temperature in Kelvin",
                                    examples:[ 308 ] },
                                  average:{ type:"number",
                                    format:"float",
                                    description:"Average temperature in Kelvin",
                                    examples:[ 210 ] } } } } },
                          atmosphere:{ type:"array",
                            description:"Atmospheric composition",
                            items:{ type:"object",
                              properties:{ compound:{ type:"string",
                                  examples:[ "CO2",
                                    "N2" ] },
                                percentage:{ type:"number",
                                  format:"float",
                                  examples:[ 95.3 ] } } } },
                          discoveredAt:{ type:"string",
                            format:"date-time",
                            examples:[ "1610-01-07T00:00:00Z" ] },
                          image:{ type:"string",
                            nullable:true,
                            examples:[ "https://cdn.scalar.com/photos/mars.jpg" ] },
                          satellites:{ type:"array",
                            items:{ description:"A natural satellite (moon) orbiting a planet",
                              type:"object",
                              required:[ "name" ],
                              properties:{ name:{ type:"string",
                                  examples:[ "Phobos" ] },
                                diameter:{ type:"number",
                                  format:"float",
                                  description:"Diameter in kilometers",
                                  examples:[ 22.2 ] } } } },
                          creator:{ description:"A user",
                            type:"object",
                            xml:{ name:"user" },
                            properties:{ id:{ type:"integer",
                                format:"int64",
                                readOnly:true,
                                examples:[ 1 ] },
                              name:{ type:"string",
                                examples:[ "Marc" ] } } },
                          tags:{ type:"array",
                            items:{ type:"string" },
                            examples:[ [ "solar-system",
                                "rocky",
                                "explored" ] ] },
                          lastUpdated:{ type:"string",
                            format:"date-time",
                            readOnly:true,
                            examples:[ "2024-01-15T14:30:00Z" ] },
                          callbackUrl:{ type:"string",
                            format:"uri",
                            description:"URL to receive notifications about this planet",
                            examples:[ "https://example.com/webhook" ] } } } } } },
                400:{ description:"Bad Request",
                  content:{ "application/json":{ schema:{ "x-scalar-ignore":true,
                        description:"RFC 7807 (https://datatracker.ietf.org/doc/html/rfc7807)",
                        type:"object",
                        properties:{ type:{ type:"string",
                            examples:[ "https://example.com/errors/bad-request" ] },
                          title:{ type:"string",
                            examples:[ "Bad Request" ] },
                          status:{ type:"integer",
                            format:"int64",
                            examples:[ 400 ] },
                          detail:{ type:"string",
                            examples:[ "The request was invalid." ] } } } },
                    "application/xml":{ schema:{ "x-scalar-ignore":true,
                        description:"RFC 7807 (https://datatracker.ietf.org/doc/html/rfc7807)",
                        type:"object",
                        properties:{ type:{ type:"string",
                            examples:[ "https://example.com/errors/bad-request" ] },
                          title:{ type:"string",
                            examples:[ "Bad Request" ] },
                          status:{ type:"integer",
                            format:"int64",
                            examples:[ 400 ] },
                          detail:{ type:"string",
                            examples:[ "The request was invalid." ] } } } } } },
                403:{ description:"Forbidden",
                  content:{ "application/json":{ schema:{ "x-scalar-ignore":true,
                        description:"RFC 7807 (https://datatracker.ietf.org/doc/html/rfc7807)",
                        type:"object",
                        properties:{ type:{ type:"string",
                            examples:[ "https://example.com/errors/forbidden" ] },
                          title:{ type:"string",
                            examples:[ "Forbidden" ] },
                          status:{ type:"integer",
                            format:"int64",
                            examples:[ 403 ] },
                          detail:{ type:"string",
                            examples:[ "You are not authorized to access this resource." ] } } } },
                    "application/xml":{ schema:{ "x-scalar-ignore":true,
                        description:"RFC 7807 (https://datatracker.ietf.org/doc/html/rfc7807)",
                        type:"object",
                        properties:{ type:{ type:"string",
                            examples:[ "https://example.com/errors/forbidden" ] },
                          title:{ type:"string",
                            examples:[ "Forbidden" ] },
                          status:{ type:"integer",
                            format:"int64",
                            examples:[ 403 ] },
                          detail:{ type:"string",
                            examples:[ "You are not authorized to access this resource." ] } } } } } } } },
            pathParameters:undefined },
          { httpVerb:"GET",
            path:"/planets/{planetId}",
            operationId:"getPlanet",
            name:"Get a planet",
            description:"You’ll better learn a little bit more about the planets. It might come in handy once space travel is available for everyone.",
            information:{ tags:[ "Planets" ],
              summary:"Get a planet",
              description:"You’ll better learn a little bit more about the planets. It might come in handy once space travel is available for everyone.",
              operationId:"getPlanet",
              security:[ {} ],
              parameters:[ { name:"planetId",
                  description:"The ID of the planet to get",
                  "in":"path",
                  required:true,
                  schema:{ type:"integer",
                    format:"int64",
                    examples:[ 1 ] } } ],
              responses:{ 200:{ description:"Planet Found",
                  content:{ "application/json":{ schema:{ description:"A planet in the Scalar Galaxy",
                        type:"object",
                        required:[ "id",
                          "name" ],
                        xml:{ name:"planet" },
                        properties:{ id:{ type:"integer",
                            format:"int64",
                            readOnly:true,
                            examples:[ 1 ],
                            "x-variable":"planetId" },
                          name:{ type:"string",
                            examples:[ "Mars",
                              "Jupiter",
                              "HD 40307g" ] },
                          description:{ type:[ "string",
                              "null" ],
                            examples:[ "The red planet",
                              "A gas giant with a great red spot" ] },
                          type:{ type:"string",
                            "enum":[ "terrestrial",
                              "gas_giant",
                              "ice_giant",
                              "dwarf",
                              "super_earth" ],
                            examples:[ "terrestrial" ] },
                          habitabilityIndex:{ type:"number",
                            format:"float",
                            minimum:0,
                            maximum:1,
                            description:"A score from 0 to 1 indicating potential habitability",
                            examples:[ 0.68 ] },
                          physicalProperties:{ type:"object",
                            properties:{ mass:{ type:"number",
                                format:"float",
                                description:"Mass in Earth masses",
                                examples:[ 0.107 ] },
                              radius:{ type:"number",
                                format:"float",
                                description:"Radius in Earth radii",
                                examples:[ 0.532 ] },
                              gravity:{ type:"number",
                                format:"float",
                                description:"Surface gravity in Earth g",
                                examples:[ 0.378 ] },
                              temperature:{ type:"object",
                                properties:{ min:{ type:"number",
                                    format:"float",
                                    description:"Minimum temperature in Kelvin",
                                    examples:[ 130 ] },
                                  max:{ type:"number",
                                    format:"float",
                                    description:"Maximum temperature in Kelvin",
                                    examples:[ 308 ] },
                                  average:{ type:"number",
                                    format:"float",
                                    description:"Average temperature in Kelvin",
                                    examples:[ 210 ] } } } } },
                          atmosphere:{ type:"array",
                            description:"Atmospheric composition",
                            items:{ type:"object",
                              properties:{ compound:{ type:"string",
                                  examples:[ "CO2",
                                    "N2" ] },
                                percentage:{ type:"number",
                                  format:"float",
                                  examples:[ 95.3 ] } } } },
                          discoveredAt:{ type:"string",
                            format:"date-time",
                            examples:[ "1610-01-07T00:00:00Z" ] },
                          image:{ type:"string",
                            nullable:true,
                            examples:[ "https://cdn.scalar.com/photos/mars.jpg" ] },
                          satellites:{ type:"array",
                            items:{ description:"A natural satellite (moon) orbiting a planet",
                              type:"object",
                              required:[ "name" ],
                              properties:{ name:{ type:"string",
                                  examples:[ "Phobos" ] },
                                diameter:{ type:"number",
                                  format:"float",
                                  description:"Diameter in kilometers",
                                  examples:[ 22.2 ] } } } },
                          creator:{ description:"A user",
                            type:"object",
                            xml:{ name:"user" },
                            properties:{ id:{ type:"integer",
                                format:"int64",
                                readOnly:true,
                                examples:[ 1 ] },
                              name:{ type:"string",
                                examples:[ "Marc" ] } } },
                          tags:{ type:"array",
                            items:{ type:"string" },
                            examples:[ [ "solar-system",
                                "rocky",
                                "explored" ] ] },
                          lastUpdated:{ type:"string",
                            format:"date-time",
                            readOnly:true,
                            examples:[ "2024-01-15T14:30:00Z" ] },
                          callbackUrl:{ type:"string",
                            format:"uri",
                            description:"URL to receive notifications about this planet",
                            examples:[ "https://example.com/webhook" ] } } } },
                    "application/xml":{ schema:{ description:"A planet in the Scalar Galaxy",
                        type:"object",
                        required:[ "id",
                          "name" ],
                        xml:{ name:"planet" },
                        properties:{ id:{ type:"integer",
                            format:"int64",
                            readOnly:true,
                            examples:[ 1 ],
                            "x-variable":"planetId" },
                          name:{ type:"string",
                            examples:[ "Mars",
                              "Jupiter",
                              "HD 40307g" ] },
                          description:{ type:[ "string",
                              "null" ],
                            examples:[ "The red planet",
                              "A gas giant with a great red spot" ] },
                          type:{ type:"string",
                            "enum":[ "terrestrial",
                              "gas_giant",
                              "ice_giant",
                              "dwarf",
                              "super_earth" ],
                            examples:[ "terrestrial" ] },
                          habitabilityIndex:{ type:"number",
                            format:"float",
                            minimum:0,
                            maximum:1,
                            description:"A score from 0 to 1 indicating potential habitability",
                            examples:[ 0.68 ] },
                          physicalProperties:{ type:"object",
                            properties:{ mass:{ type:"number",
                                format:"float",
                                description:"Mass in Earth masses",
                                examples:[ 0.107 ] },
                              radius:{ type:"number",
                                format:"float",
                                description:"Radius in Earth radii",
                                examples:[ 0.532 ] },
                              gravity:{ type:"number",
                                format:"float",
                                description:"Surface gravity in Earth g",
                                examples:[ 0.378 ] },
                              temperature:{ type:"object",
                                properties:{ min:{ type:"number",
                                    format:"float",
                                    description:"Minimum temperature in Kelvin",
                                    examples:[ 130 ] },
                                  max:{ type:"number",
                                    format:"float",
                                    description:"Maximum temperature in Kelvin",
                                    examples:[ 308 ] },
                                  average:{ type:"number",
                                    format:"float",
                                    description:"Average temperature in Kelvin",
                                    examples:[ 210 ] } } } } },
                          atmosphere:{ type:"array",
                            description:"Atmospheric composition",
                            items:{ type:"object",
                              properties:{ compound:{ type:"string",
                                  examples:[ "CO2",
                                    "N2" ] },
                                percentage:{ type:"number",
                                  format:"float",
                                  examples:[ 95.3 ] } } } },
                          discoveredAt:{ type:"string",
                            format:"date-time",
                            examples:[ "1610-01-07T00:00:00Z" ] },
                          image:{ type:"string",
                            nullable:true,
                            examples:[ "https://cdn.scalar.com/photos/mars.jpg" ] },
                          satellites:{ type:"array",
                            items:{ description:"A natural satellite (moon) orbiting a planet",
                              type:"object",
                              required:[ "name" ],
                              properties:{ name:{ type:"string",
                                  examples:[ "Phobos" ] },
                                diameter:{ type:"number",
                                  format:"float",
                                  description:"Diameter in kilometers",
                                  examples:[ 22.2 ] } } } },
                          creator:{ description:"A user",
                            type:"object",
                            xml:{ name:"user" },
                            properties:{ id:{ type:"integer",
                                format:"int64",
                                readOnly:true,
                                examples:[ 1 ] },
                              name:{ type:"string",
                                examples:[ "Marc" ] } } },
                          tags:{ type:"array",
                            items:{ type:"string" },
                            examples:[ [ "solar-system",
                                "rocky",
                                "explored" ] ] },
                          lastUpdated:{ type:"string",
                            format:"date-time",
                            readOnly:true,
                            examples:[ "2024-01-15T14:30:00Z" ] },
                          callbackUrl:{ type:"string",
                            format:"uri",
                            description:"URL to receive notifications about this planet",
                            examples:[ "https://example.com/webhook" ] } } } } } },
                404:{ description:"NotFound",
                  content:{ "application/json":{ schema:{ "x-scalar-ignore":true,
                        description:"RFC 7807 (https://datatracker.ietf.org/doc/html/rfc7807)",
                        type:"object",
                        properties:{ type:{ type:"string",
                            examples:[ "https://example.com/errors/not-found" ] },
                          title:{ type:"string",
                            examples:[ "Not Found" ] },
                          status:{ type:"integer",
                            format:"int64",
                            examples:[ 404 ] },
                          detail:{ type:"string",
                            examples:[ "The resource you are trying to access does not exist." ] } } } },
                    "application/xml":{ schema:{ "x-scalar-ignore":true,
                        description:"RFC 7807 (https://datatracker.ietf.org/doc/html/rfc7807)",
                        type:"object",
                        properties:{ type:{ type:"string",
                            examples:[ "https://example.com/errors/not-found" ] },
                          title:{ type:"string",
                            examples:[ "Not Found" ] },
                          status:{ type:"integer",
                            format:"int64",
                            examples:[ 404 ] },
                          detail:{ type:"string",
                            examples:[ "The resource you are trying to access does not exist." ] } } } } } } } },
            pathParameters:undefined },
          { httpVerb:"PUT",
            path:"/planets/{planetId}",
            operationId:"updatePlanet",
            name:"Update a planet",
            description:"Sometimes you make mistakes, that's fine. No worries, you can update all planets.",
            information:{ tags:[ "Planets" ],
              summary:"Update a planet",
              description:"Sometimes you make mistakes, that's fine. No worries, you can update all planets.",
              operationId:"updatePlanet",
              requestBody:{ description:"New information about the planet",
                content:{ "application/json":{ schema:{ description:"A planet in the Scalar Galaxy",
                      type:"object",
                      required:[ "id",
                        "name" ],
                      xml:{ name:"planet" },
                      properties:{ id:{ type:"integer",
                          format:"int64",
                          readOnly:true,
                          examples:[ 1 ],
                          "x-variable":"planetId" },
                        name:{ type:"string",
                          examples:[ "Mars",
                            "Jupiter",
                            "HD 40307g" ] },
                        description:{ type:[ "string",
                            "null" ],
                          examples:[ "The red planet",
                            "A gas giant with a great red spot" ] },
                        type:{ type:"string",
                          "enum":[ "terrestrial",
                            "gas_giant",
                            "ice_giant",
                            "dwarf",
                            "super_earth" ],
                          examples:[ "terrestrial" ] },
                        habitabilityIndex:{ type:"number",
                          format:"float",
                          minimum:0,
                          maximum:1,
                          description:"A score from 0 to 1 indicating potential habitability",
                          examples:[ 0.68 ] },
                        physicalProperties:{ type:"object",
                          properties:{ mass:{ type:"number",
                              format:"float",
                              description:"Mass in Earth masses",
                              examples:[ 0.107 ] },
                            radius:{ type:"number",
                              format:"float",
                              description:"Radius in Earth radii",
                              examples:[ 0.532 ] },
                            gravity:{ type:"number",
                              format:"float",
                              description:"Surface gravity in Earth g",
                              examples:[ 0.378 ] },
                            temperature:{ type:"object",
                              properties:{ min:{ type:"number",
                                  format:"float",
                                  description:"Minimum temperature in Kelvin",
                                  examples:[ 130 ] },
                                max:{ type:"number",
                                  format:"float",
                                  description:"Maximum temperature in Kelvin",
                                  examples:[ 308 ] },
                                average:{ type:"number",
                                  format:"float",
                                  description:"Average temperature in Kelvin",
                                  examples:[ 210 ] } } } } },
                        atmosphere:{ type:"array",
                          description:"Atmospheric composition",
                          items:{ type:"object",
                            properties:{ compound:{ type:"string",
                                examples:[ "CO2",
                                  "N2" ] },
                              percentage:{ type:"number",
                                format:"float",
                                examples:[ 95.3 ] } } } },
                        discoveredAt:{ type:"string",
                          format:"date-time",
                          examples:[ "1610-01-07T00:00:00Z" ] },
                        image:{ type:"string",
                          nullable:true,
                          examples:[ "https://cdn.scalar.com/photos/mars.jpg" ] },
                        satellites:{ type:"array",
                          items:{ description:"A natural satellite (moon) orbiting a planet",
                            type:"object",
                            required:[ "name" ],
                            properties:{ name:{ type:"string",
                                examples:[ "Phobos" ] },
                              diameter:{ type:"number",
                                format:"float",
                                description:"Diameter in kilometers",
                                examples:[ 22.2 ] } } } },
                        creator:{ description:"A user",
                          type:"object",
                          xml:{ name:"user" },
                          properties:{ id:{ type:"integer",
                              format:"int64",
                              readOnly:true,
                              examples:[ 1 ] },
                            name:{ type:"string",
                              examples:[ "Marc" ] } } },
                        tags:{ type:"array",
                          items:{ type:"string" },
                          examples:[ [ "solar-system",
                              "rocky",
                              "explored" ] ] },
                        lastUpdated:{ type:"string",
                          format:"date-time",
                          readOnly:true,
                          examples:[ "2024-01-15T14:30:00Z" ] },
                        callbackUrl:{ type:"string",
                          format:"uri",
                          description:"URL to receive notifications about this planet",
                          examples:[ "https://example.com/webhook" ] } } } },
                  "application/xml":{ schema:{ description:"A planet in the Scalar Galaxy",
                      type:"object",
                      required:[ "id",
                        "name" ],
                      xml:{ name:"planet" },
                      properties:{ id:{ type:"integer",
                          format:"int64",
                          readOnly:true,
                          examples:[ 1 ],
                          "x-variable":"planetId" },
                        name:{ type:"string",
                          examples:[ "Mars",
                            "Jupiter",
                            "HD 40307g" ] },
                        description:{ type:[ "string",
                            "null" ],
                          examples:[ "The red planet",
                            "A gas giant with a great red spot" ] },
                        type:{ type:"string",
                          "enum":[ "terrestrial",
                            "gas_giant",
                            "ice_giant",
                            "dwarf",
                            "super_earth" ],
                          examples:[ "terrestrial" ] },
                        habitabilityIndex:{ type:"number",
                          format:"float",
                          minimum:0,
                          maximum:1,
                          description:"A score from 0 to 1 indicating potential habitability",
                          examples:[ 0.68 ] },
                        physicalProperties:{ type:"object",
                          properties:{ mass:{ type:"number",
                              format:"float",
                              description:"Mass in Earth masses",
                              examples:[ 0.107 ] },
                            radius:{ type:"number",
                              format:"float",
                              description:"Radius in Earth radii",
                              examples:[ 0.532 ] },
                            gravity:{ type:"number",
                              format:"float",
                              description:"Surface gravity in Earth g",
                              examples:[ 0.378 ] },
                            temperature:{ type:"object",
                              properties:{ min:{ type:"number",
                                  format:"float",
                                  description:"Minimum temperature in Kelvin",
                                  examples:[ 130 ] },
                                max:{ type:"number",
                                  format:"float",
                                  description:"Maximum temperature in Kelvin",
                                  examples:[ 308 ] },
                                average:{ type:"number",
                                  format:"float",
                                  description:"Average temperature in Kelvin",
                                  examples:[ 210 ] } } } } },
                        atmosphere:{ type:"array",
                          description:"Atmospheric composition",
                          items:{ type:"object",
                            properties:{ compound:{ type:"string",
                                examples:[ "CO2",
                                  "N2" ] },
                              percentage:{ type:"number",
                                format:"float",
                                examples:[ 95.3 ] } } } },
                        discoveredAt:{ type:"string",
                          format:"date-time",
                          examples:[ "1610-01-07T00:00:00Z" ] },
                        image:{ type:"string",
                          nullable:true,
                          examples:[ "https://cdn.scalar.com/photos/mars.jpg" ] },
                        satellites:{ type:"array",
                          items:{ description:"A natural satellite (moon) orbiting a planet",
                            type:"object",
                            required:[ "name" ],
                            properties:{ name:{ type:"string",
                                examples:[ "Phobos" ] },
                              diameter:{ type:"number",
                                format:"float",
                                description:"Diameter in kilometers",
                                examples:[ 22.2 ] } } } },
                        creator:{ description:"A user",
                          type:"object",
                          xml:{ name:"user" },
                          properties:{ id:{ type:"integer",
                              format:"int64",
                              readOnly:true,
                              examples:[ 1 ] },
                            name:{ type:"string",
                              examples:[ "Marc" ] } } },
                        tags:{ type:"array",
                          items:{ type:"string" },
                          examples:[ [ "solar-system",
                              "rocky",
                              "explored" ] ] },
                        lastUpdated:{ type:"string",
                          format:"date-time",
                          readOnly:true,
                          examples:[ "2024-01-15T14:30:00Z" ] },
                        callbackUrl:{ type:"string",
                          format:"uri",
                          description:"URL to receive notifications about this planet",
                          examples:[ "https://example.com/webhook" ] } } } } } },
              parameters:[ { name:"planetId",
                  description:"The ID of the planet to get",
                  "in":"path",
                  required:true,
                  schema:{ type:"integer",
                    format:"int64",
                    examples:[ 1 ] } } ],
              responses:{ 200:{ description:"OK",
                  content:{ "application/json":{ schema:{ description:"A planet in the Scalar Galaxy",
                        type:"object",
                        required:[ "id",
                          "name" ],
                        xml:{ name:"planet" },
                        properties:{ id:{ type:"integer",
                            format:"int64",
                            readOnly:true,
                            examples:[ 1 ],
                            "x-variable":"planetId" },
                          name:{ type:"string",
                            examples:[ "Mars",
                              "Jupiter",
                              "HD 40307g" ] },
                          description:{ type:[ "string",
                              "null" ],
                            examples:[ "The red planet",
                              "A gas giant with a great red spot" ] },
                          type:{ type:"string",
                            "enum":[ "terrestrial",
                              "gas_giant",
                              "ice_giant",
                              "dwarf",
                              "super_earth" ],
                            examples:[ "terrestrial" ] },
                          habitabilityIndex:{ type:"number",
                            format:"float",
                            minimum:0,
                            maximum:1,
                            description:"A score from 0 to 1 indicating potential habitability",
                            examples:[ 0.68 ] },
                          physicalProperties:{ type:"object",
                            properties:{ mass:{ type:"number",
                                format:"float",
                                description:"Mass in Earth masses",
                                examples:[ 0.107 ] },
                              radius:{ type:"number",
                                format:"float",
                                description:"Radius in Earth radii",
                                examples:[ 0.532 ] },
                              gravity:{ type:"number",
                                format:"float",
                                description:"Surface gravity in Earth g",
                                examples:[ 0.378 ] },
                              temperature:{ type:"object",
                                properties:{ min:{ type:"number",
                                    format:"float",
                                    description:"Minimum temperature in Kelvin",
                                    examples:[ 130 ] },
                                  max:{ type:"number",
                                    format:"float",
                                    description:"Maximum temperature in Kelvin",
                                    examples:[ 308 ] },
                                  average:{ type:"number",
                                    format:"float",
                                    description:"Average temperature in Kelvin",
                                    examples:[ 210 ] } } } } },
                          atmosphere:{ type:"array",
                            description:"Atmospheric composition",
                            items:{ type:"object",
                              properties:{ compound:{ type:"string",
                                  examples:[ "CO2",
                                    "N2" ] },
                                percentage:{ type:"number",
                                  format:"float",
                                  examples:[ 95.3 ] } } } },
                          discoveredAt:{ type:"string",
                            format:"date-time",
                            examples:[ "1610-01-07T00:00:00Z" ] },
                          image:{ type:"string",
                            nullable:true,
                            examples:[ "https://cdn.scalar.com/photos/mars.jpg" ] },
                          satellites:{ type:"array",
                            items:{ description:"A natural satellite (moon) orbiting a planet",
                              type:"object",
                              required:[ "name" ],
                              properties:{ name:{ type:"string",
                                  examples:[ "Phobos" ] },
                                diameter:{ type:"number",
                                  format:"float",
                                  description:"Diameter in kilometers",
                                  examples:[ 22.2 ] } } } },
                          creator:{ description:"A user",
                            type:"object",
                            xml:{ name:"user" },
                            properties:{ id:{ type:"integer",
                                format:"int64",
                                readOnly:true,
                                examples:[ 1 ] },
                              name:{ type:"string",
                                examples:[ "Marc" ] } } },
                          tags:{ type:"array",
                            items:{ type:"string" },
                            examples:[ [ "solar-system",
                                "rocky",
                                "explored" ] ] },
                          lastUpdated:{ type:"string",
                            format:"date-time",
                            readOnly:true,
                            examples:[ "2024-01-15T14:30:00Z" ] },
                          callbackUrl:{ type:"string",
                            format:"uri",
                            description:"URL to receive notifications about this planet",
                            examples:[ "https://example.com/webhook" ] } } } },
                    "application/xml":{ schema:{ description:"A planet in the Scalar Galaxy",
                        type:"object",
                        required:[ "id",
                          "name" ],
                        xml:{ name:"planet" },
                        properties:{ id:{ type:"integer",
                            format:"int64",
                            readOnly:true,
                            examples:[ 1 ],
                            "x-variable":"planetId" },
                          name:{ type:"string",
                            examples:[ "Mars",
                              "Jupiter",
                              "HD 40307g" ] },
                          description:{ type:[ "string",
                              "null" ],
                            examples:[ "The red planet",
                              "A gas giant with a great red spot" ] },
                          type:{ type:"string",
                            "enum":[ "terrestrial",
                              "gas_giant",
                              "ice_giant",
                              "dwarf",
                              "super_earth" ],
                            examples:[ "terrestrial" ] },
                          habitabilityIndex:{ type:"number",
                            format:"float",
                            minimum:0,
                            maximum:1,
                            description:"A score from 0 to 1 indicating potential habitability",
                            examples:[ 0.68 ] },
                          physicalProperties:{ type:"object",
                            properties:{ mass:{ type:"number",
                                format:"float",
                                description:"Mass in Earth masses",
                                examples:[ 0.107 ] },
                              radius:{ type:"number",
                                format:"float",
                                description:"Radius in Earth radii",
                                examples:[ 0.532 ] },
                              gravity:{ type:"number",
                                format:"float",
                                description:"Surface gravity in Earth g",
                                examples:[ 0.378 ] },
                              temperature:{ type:"object",
                                properties:{ min:{ type:"number",
                                    format:"float",
                                    description:"Minimum temperature in Kelvin",
                                    examples:[ 130 ] },
                                  max:{ type:"number",
                                    format:"float",
                                    description:"Maximum temperature in Kelvin",
                                    examples:[ 308 ] },
                                  average:{ type:"number",
                                    format:"float",
                                    description:"Average temperature in Kelvin",
                                    examples:[ 210 ] } } } } },
                          atmosphere:{ type:"array",
                            description:"Atmospheric composition",
                            items:{ type:"object",
                              properties:{ compound:{ type:"string",
                                  examples:[ "CO2",
                                    "N2" ] },
                                percentage:{ type:"number",
                                  format:"float",
                                  examples:[ 95.3 ] } } } },
                          discoveredAt:{ type:"string",
                            format:"date-time",
                            examples:[ "1610-01-07T00:00:00Z" ] },
                          image:{ type:"string",
                            nullable:true,
                            examples:[ "https://cdn.scalar.com/photos/mars.jpg" ] },
                          satellites:{ type:"array",
                            items:{ description:"A natural satellite (moon) orbiting a planet",
                              type:"object",
                              required:[ "name" ],
                              properties:{ name:{ type:"string",
                                  examples:[ "Phobos" ] },
                                diameter:{ type:"number",
                                  format:"float",
                                  description:"Diameter in kilometers",
                                  examples:[ 22.2 ] } } } },
                          creator:{ description:"A user",
                            type:"object",
                            xml:{ name:"user" },
                            properties:{ id:{ type:"integer",
                                format:"int64",
                                readOnly:true,
                                examples:[ 1 ] },
                              name:{ type:"string",
                                examples:[ "Marc" ] } } },
                          tags:{ type:"array",
                            items:{ type:"string" },
                            examples:[ [ "solar-system",
                                "rocky",
                                "explored" ] ] },
                          lastUpdated:{ type:"string",
                            format:"date-time",
                            readOnly:true,
                            examples:[ "2024-01-15T14:30:00Z" ] },
                          callbackUrl:{ type:"string",
                            format:"uri",
                            description:"URL to receive notifications about this planet",
                            examples:[ "https://example.com/webhook" ] } } } } } },
                400:{ description:"Bad Request",
                  content:{ "application/json":{ schema:{ "x-scalar-ignore":true,
                        description:"RFC 7807 (https://datatracker.ietf.org/doc/html/rfc7807)",
                        type:"object",
                        properties:{ type:{ type:"string",
                            examples:[ "https://example.com/errors/bad-request" ] },
                          title:{ type:"string",
                            examples:[ "Bad Request" ] },
                          status:{ type:"integer",
                            format:"int64",
                            examples:[ 400 ] },
                          detail:{ type:"string",
                            examples:[ "The request was invalid." ] } } } },
                    "application/xml":{ schema:{ "x-scalar-ignore":true,
                        description:"RFC 7807 (https://datatracker.ietf.org/doc/html/rfc7807)",
                        type:"object",
                        properties:{ type:{ type:"string",
                            examples:[ "https://example.com/errors/bad-request" ] },
                          title:{ type:"string",
                            examples:[ "Bad Request" ] },
                          status:{ type:"integer",
                            format:"int64",
                            examples:[ 400 ] },
                          detail:{ type:"string",
                            examples:[ "The request was invalid." ] } } } } } },
                403:{ description:"Forbidden",
                  content:{ "application/json":{ schema:{ "x-scalar-ignore":true,
                        description:"RFC 7807 (https://datatracker.ietf.org/doc/html/rfc7807)",
                        type:"object",
                        properties:{ type:{ type:"string",
                            examples:[ "https://example.com/errors/forbidden" ] },
                          title:{ type:"string",
                            examples:[ "Forbidden" ] },
                          status:{ type:"integer",
                            format:"int64",
                            examples:[ 403 ] },
                          detail:{ type:"string",
                            examples:[ "You are not authorized to access this resource." ] } } } },
                    "application/xml":{ schema:{ "x-scalar-ignore":true,
                        description:"RFC 7807 (https://datatracker.ietf.org/doc/html/rfc7807)",
                        type:"object",
                        properties:{ type:{ type:"string",
                            examples:[ "https://example.com/errors/forbidden" ] },
                          title:{ type:"string",
                            examples:[ "Forbidden" ] },
                          status:{ type:"integer",
                            format:"int64",
                            examples:[ 403 ] },
                          detail:{ type:"string",
                            examples:[ "You are not authorized to access this resource." ] } } } } } },
                404:{ description:"NotFound",
                  content:{ "application/json":{ schema:{ "x-scalar-ignore":true,
                        description:"RFC 7807 (https://datatracker.ietf.org/doc/html/rfc7807)",
                        type:"object",
                        properties:{ type:{ type:"string",
                            examples:[ "https://example.com/errors/not-found" ] },
                          title:{ type:"string",
                            examples:[ "Not Found" ] },
                          status:{ type:"integer",
                            format:"int64",
                            examples:[ 404 ] },
                          detail:{ type:"string",
                            examples:[ "The resource you are trying to access does not exist." ] } } } },
                    "application/xml":{ schema:{ "x-scalar-ignore":true,
                        description:"RFC 7807 (https://datatracker.ietf.org/doc/html/rfc7807)",
                        type:"object",
                        properties:{ type:{ type:"string",
                            examples:[ "https://example.com/errors/not-found" ] },
                          title:{ type:"string",
                            examples:[ "Not Found" ] },
                          status:{ type:"integer",
                            format:"int64",
                            examples:[ 404 ] },
                          detail:{ type:"string",
                            examples:[ "The resource you are trying to access does not exist." ] } } } } } } } },
            pathParameters:undefined },
          { httpVerb:"DELETE",
            path:"/planets/{planetId}",
            operationId:"deletePlanet",
            name:"Delete a planet",
            description:"This endpoint was used to delete planets. Unfortunately, that caused a lot of trouble for planets with life. So, this endpoint is now deprecated and should not be used anymore.",
            information:{ tags:[ "Planets" ],
              summary:"Delete a planet",
              operationId:"deletePlanet",
              description:"This endpoint was used to delete planets. Unfortunately, that caused a lot of trouble for planets with life. So, this endpoint is now deprecated and should not be used anymore.",
              "x-scalar-stability":"experimental",
              parameters:[ { name:"planetId",
                  description:"The ID of the planet to get",
                  "in":"path",
                  required:true,
                  schema:{ type:"integer",
                    format:"int64",
                    examples:[ 1 ] } } ],
              responses:{ 204:{ description:"No Content" },
                404:{ description:"NotFound",
                  content:{ "application/json":{ schema:{ "x-scalar-ignore":true,
                        description:"RFC 7807 (https://datatracker.ietf.org/doc/html/rfc7807)",
                        type:"object",
                        properties:{ type:{ type:"string",
                            examples:[ "https://example.com/errors/not-found" ] },
                          title:{ type:"string",
                            examples:[ "Not Found" ] },
                          status:{ type:"integer",
                            format:"int64",
                            examples:[ 404 ] },
                          detail:{ type:"string",
                            examples:[ "The resource you are trying to access does not exist." ] } } } },
                    "application/xml":{ schema:{ "x-scalar-ignore":true,
                        description:"RFC 7807 (https://datatracker.ietf.org/doc/html/rfc7807)",
                        type:"object",
                        properties:{ type:{ type:"string",
                            examples:[ "https://example.com/errors/not-found" ] },
                          title:{ type:"string",
                            examples:[ "Not Found" ] },
                          status:{ type:"integer",
                            format:"int64",
                            examples:[ 404 ] },
                          detail:{ type:"string",
                            examples:[ "The resource you are trying to access does not exist." ] } } } } } } } },
            pathParameters:undefined },
          { httpVerb:"POST",
            path:"/planets/{planetId}/image",
            operationId:"uploadImage",
            name:"Upload an image to a planet",
            description:"Got a crazy good photo of a planet? Share it with the world!",
            information:{ tags:[ "Planets" ],
              summary:"Upload an image to a planet",
              description:"Got a crazy good photo of a planet? Share it with the world!",
              operationId:"uploadImage",
              parameters:[ { name:"planetId",
                  description:"The ID of the planet to get",
                  "in":"path",
                  required:true,
                  schema:{ type:"integer",
                    format:"int64",
                    examples:[ 1 ] } } ],
              requestBody:{ description:"Image to upload",
                content:{ "multipart/form-data":{ schema:{ type:"object",
                      properties:{ image:{ type:"string",
                          format:"binary",
                          description:"The image file to upload",
                          examples:[ "@mars.jpg",
                            "@jupiter.png" ] } } } } } },
              responses:{ 200:{ description:"Image uploaded",
                  content:{ "application/json":{ schema:{ "x-scalar-ignore":true,
                        description:"Message about an image upload",
                        type:"object",
                        properties:{ message:{ type:"string",
                            examples:[ "Image uploaded successfully" ] },
                          imageUrl:{ type:"string",
                            description:"The URL where the uploaded image can be accessed",
                            examples:[ "https://cdn.scalar.com/images/8f47c132-9d1f-4f83-b5a4-91db5ee757ab.jpg" ] },
                          uploadedAt:{ type:"string",
                            format:"date-time",
                            description:"Timestamp when the image was uploaded",
                            examples:[ "2024-01-15T14:30:00Z" ] },
                          fileSize:{ type:"integer",
                            description:"Size of the uploaded image in bytes",
                            examples:[ 1048576 ] },
                          mimeType:{ type:"string",
                            description:"The content type of the uploaded image",
                            examples:[ "image/jpeg",
                              "image/png" ] } } } },
                    "application/xml":{ schema:{ "x-scalar-ignore":true,
                        description:"Message about an image upload",
                        type:"object",
                        properties:{ message:{ type:"string",
                            examples:[ "Image uploaded successfully" ] },
                          imageUrl:{ type:"string",
                            description:"The URL where the uploaded image can be accessed",
                            examples:[ "https://cdn.scalar.com/images/8f47c132-9d1f-4f83-b5a4-91db5ee757ab.jpg" ] },
                          uploadedAt:{ type:"string",
                            format:"date-time",
                            description:"Timestamp when the image was uploaded",
                            examples:[ "2024-01-15T14:30:00Z" ] },
                          fileSize:{ type:"integer",
                            description:"Size of the uploaded image in bytes",
                            examples:[ 1048576 ] },
                          mimeType:{ type:"string",
                            description:"The content type of the uploaded image",
                            examples:[ "image/jpeg",
                              "image/png" ] } } } } } },
                400:{ description:"Bad Request",
                  content:{ "application/json":{ schema:{ "x-scalar-ignore":true,
                        description:"RFC 7807 (https://datatracker.ietf.org/doc/html/rfc7807)",
                        type:"object",
                        properties:{ type:{ type:"string",
                            examples:[ "https://example.com/errors/bad-request" ] },
                          title:{ type:"string",
                            examples:[ "Bad Request" ] },
                          status:{ type:"integer",
                            format:"int64",
                            examples:[ 400 ] },
                          detail:{ type:"string",
                            examples:[ "The request was invalid." ] } } } },
                    "application/xml":{ schema:{ "x-scalar-ignore":true,
                        description:"RFC 7807 (https://datatracker.ietf.org/doc/html/rfc7807)",
                        type:"object",
                        properties:{ type:{ type:"string",
                            examples:[ "https://example.com/errors/bad-request" ] },
                          title:{ type:"string",
                            examples:[ "Bad Request" ] },
                          status:{ type:"integer",
                            format:"int64",
                            examples:[ 400 ] },
                          detail:{ type:"string",
                            examples:[ "The request was invalid." ] } } } } } },
                403:{ description:"Forbidden",
                  content:{ "application/json":{ schema:{ "x-scalar-ignore":true,
                        description:"RFC 7807 (https://datatracker.ietf.org/doc/html/rfc7807)",
                        type:"object",
                        properties:{ type:{ type:"string",
                            examples:[ "https://example.com/errors/forbidden" ] },
                          title:{ type:"string",
                            examples:[ "Forbidden" ] },
                          status:{ type:"integer",
                            format:"int64",
                            examples:[ 403 ] },
                          detail:{ type:"string",
                            examples:[ "You are not authorized to access this resource." ] } } } },
                    "application/xml":{ schema:{ "x-scalar-ignore":true,
                        description:"RFC 7807 (https://datatracker.ietf.org/doc/html/rfc7807)",
                        type:"object",
                        properties:{ type:{ type:"string",
                            examples:[ "https://example.com/errors/forbidden" ] },
                          title:{ type:"string",
                            examples:[ "Forbidden" ] },
                          status:{ type:"integer",
                            format:"int64",
                            examples:[ 403 ] },
                          detail:{ type:"string",
                            examples:[ "You are not authorized to access this resource." ] } } } } } },
                404:{ description:"NotFound",
                  content:{ "application/json":{ schema:{ "x-scalar-ignore":true,
                        description:"RFC 7807 (https://datatracker.ietf.org/doc/html/rfc7807)",
                        type:"object",
                        properties:{ type:{ type:"string",
                            examples:[ "https://example.com/errors/not-found" ] },
                          title:{ type:"string",
                            examples:[ "Not Found" ] },
                          status:{ type:"integer",
                            format:"int64",
                            examples:[ 404 ] },
                          detail:{ type:"string",
                            examples:[ "The resource you are trying to access does not exist." ] } } } },
                    "application/xml":{ schema:{ "x-scalar-ignore":true,
                        description:"RFC 7807 (https://datatracker.ietf.org/doc/html/rfc7807)",
                        type:"object",
                        properties:{ type:{ type:"string",
                            examples:[ "https://example.com/errors/not-found" ] },
                          title:{ type:"string",
                            examples:[ "Not Found" ] },
                          status:{ type:"integer",
                            format:"int64",
                            examples:[ 404 ] },
                          detail:{ type:"string",
                            examples:[ "The resource you are trying to access does not exist." ] } } } } } } } },
            pathParameters:undefined } ] } ],
    paths:{ "/planets":{ get:{ tags:[ "Planets" ],
          summary:"Get all planets",
          description:"It’s easy to say you know them all, but do you really? Retrieve all the planets and check whether you missed one.",
          operationId:"getAllData",
          security:[ {} ],
          parameters:[ { name:"limit",
              description:"The number of items to return",
              "in":"query",
              required:false,
              schema:{ type:"integer",
                format:"int64",
                "default":10 } },
            { name:"offset",
              description:"The number of items to skip before starting to collect the result set",
              "in":"query",
              required:false,
              schema:{ type:"integer",
                format:"int64",
                "default":0 } } ],
          responses:{ 200:{ description:"OK",
              content:{ "application/json":{ schema:{ allOf:[ { type:"object",
                        properties:{ data:{ type:"array",
                            items:{ description:"A planet in the Scalar Galaxy",
                              type:"object",
                              required:[ "id",
                                "name" ],
                              xml:{ name:"planet" },
                              properties:{ id:{ type:"integer",
                                  format:"int64",
                                  readOnly:true,
                                  examples:[ 1 ],
                                  "x-variable":"planetId" },
                                name:{ type:"string",
                                  examples:[ "Mars",
                                    "Jupiter",
                                    "HD 40307g" ] },
                                description:{ type:[ "string",
                                    "null" ],
                                  examples:[ "The red planet",
                                    "A gas giant with a great red spot" ] },
                                type:{ type:"string",
                                  "enum":[ "terrestrial",
                                    "gas_giant",
                                    "ice_giant",
                                    "dwarf",
                                    "super_earth" ],
                                  examples:[ "terrestrial" ] },
                                habitabilityIndex:{ type:"number",
                                  format:"float",
                                  minimum:0,
                                  maximum:1,
                                  description:"A score from 0 to 1 indicating potential habitability",
                                  examples:[ 0.68 ] },
                                physicalProperties:{ type:"object",
                                  properties:{ mass:{ type:"number",
                                      format:"float",
                                      description:"Mass in Earth masses",
                                      examples:[ 0.107 ] },
                                    radius:{ type:"number",
                                      format:"float",
                                      description:"Radius in Earth radii",
                                      examples:[ 0.532 ] },
                                    gravity:{ type:"number",
                                      format:"float",
                                      description:"Surface gravity in Earth g",
                                      examples:[ 0.378 ] },
                                    temperature:{ type:"object",
                                      properties:{ min:{ type:"number",
                                          format:"float",
                                          description:"Minimum temperature in Kelvin",
                                          examples:[ 130 ] },
                                        max:{ type:"number",
                                          format:"float",
                                          description:"Maximum temperature in Kelvin",
                                          examples:[ 308 ] },
                                        average:{ type:"number",
                                          format:"float",
                                          description:"Average temperature in Kelvin",
                                          examples:[ 210 ] } } } } },
                                atmosphere:{ type:"array",
                                  description:"Atmospheric composition",
                                  items:{ type:"object",
                                    properties:{ compound:{ type:"string",
                                        examples:[ "CO2",
                                          "N2" ] },
                                      percentage:{ type:"number",
                                        format:"float",
                                        examples:[ 95.3 ] } } } },
                                discoveredAt:{ type:"string",
                                  format:"date-time",
                                  examples:[ "1610-01-07T00:00:00Z" ] },
                                image:{ type:"string",
                                  nullable:true,
                                  examples:[ "https://cdn.scalar.com/photos/mars.jpg" ] },
                                satellites:{ type:"array",
                                  items:{ description:"A natural satellite (moon) orbiting a planet",
                                    type:"object",
                                    required:[ "name" ],
                                    properties:{ name:{ type:"string",
                                        examples:[ "Phobos" ] },
                                      diameter:{ type:"number",
                                        format:"float",
                                        description:"Diameter in kilometers",
                                        examples:[ 22.2 ] } } } },
                                creator:{ description:"A user",
                                  type:"object",
                                  xml:{ name:"user" },
                                  properties:{ id:{ type:"integer",
                                      format:"int64",
                                      readOnly:true,
                                      examples:[ 1 ] },
                                    name:{ type:"string",
                                      examples:[ "Marc" ] } } },
                                tags:{ type:"array",
                                  items:{ type:"string" },
                                  examples:[ [ "solar-system",
                                      "rocky",
                                      "explored" ] ] },
                                lastUpdated:{ type:"string",
                                  format:"date-time",
                                  readOnly:true,
                                  examples:[ "2024-01-15T14:30:00Z" ] },
                                callbackUrl:{ type:"string",
                                  format:"uri",
                                  description:"URL to receive notifications about this planet",
                                  examples:[ "https://example.com/webhook" ] } } } } } },
                      { description:"A paginated resource",
                        type:"object",
                        properties:{ meta:{ type:"object",
                            properties:{ limit:{ type:"integer",
                                format:"int64",
                                examples:[ 10 ] },
                              offset:{ type:"integer",
                                format:"int64",
                                examples:[ 0 ] },
                              total:{ type:"integer",
                                format:"int64",
                                examples:[ 100 ] },
                              next:{ type:[ "string",
                                  "null" ],
                                examples:[ "/planets?limit=10&offset=10" ] } } } } } ] } },
                "application/xml":{ schema:{ allOf:[ { type:"object",
                        xml:{ name:"planets" },
                        properties:{ data:{ type:"array",
                            items:{ description:"A planet in the Scalar Galaxy",
                              type:"object",
                              required:[ "id",
                                "name" ],
                              xml:{ name:"planet" },
                              properties:{ id:{ type:"integer",
                                  format:"int64",
                                  readOnly:true,
                                  examples:[ 1 ],
                                  "x-variable":"planetId" },
                                name:{ type:"string",
                                  examples:[ "Mars",
                                    "Jupiter",
                                    "HD 40307g" ] },
                                description:{ type:[ "string",
                                    "null" ],
                                  examples:[ "The red planet",
                                    "A gas giant with a great red spot" ] },
                                type:{ type:"string",
                                  "enum":[ "terrestrial",
                                    "gas_giant",
                                    "ice_giant",
                                    "dwarf",
                                    "super_earth" ],
                                  examples:[ "terrestrial" ] },
                                habitabilityIndex:{ type:"number",
                                  format:"float",
                                  minimum:0,
                                  maximum:1,
                                  description:"A score from 0 to 1 indicating potential habitability",
                                  examples:[ 0.68 ] },
                                physicalProperties:{ type:"object",
                                  properties:{ mass:{ type:"number",
                                      format:"float",
                                      description:"Mass in Earth masses",
                                      examples:[ 0.107 ] },
                                    radius:{ type:"number",
                                      format:"float",
                                      description:"Radius in Earth radii",
                                      examples:[ 0.532 ] },
                                    gravity:{ type:"number",
                                      format:"float",
                                      description:"Surface gravity in Earth g",
                                      examples:[ 0.378 ] },
                                    temperature:{ type:"object",
                                      properties:{ min:{ type:"number",
                                          format:"float",
                                          description:"Minimum temperature in Kelvin",
                                          examples:[ 130 ] },
                                        max:{ type:"number",
                                          format:"float",
                                          description:"Maximum temperature in Kelvin",
                                          examples:[ 308 ] },
                                        average:{ type:"number",
                                          format:"float",
                                          description:"Average temperature in Kelvin",
                                          examples:[ 210 ] } } } } },
                                atmosphere:{ type:"array",
                                  description:"Atmospheric composition",
                                  items:{ type:"object",
                                    properties:{ compound:{ type:"string",
                                        examples:[ "CO2",
                                          "N2" ] },
                                      percentage:{ type:"number",
                                        format:"float",
                                        examples:[ 95.3 ] } } } },
                                discoveredAt:{ type:"string",
                                  format:"date-time",
                                  examples:[ "1610-01-07T00:00:00Z" ] },
                                image:{ type:"string",
                                  nullable:true,
                                  examples:[ "https://cdn.scalar.com/photos/mars.jpg" ] },
                                satellites:{ type:"array",
                                  items:{ description:"A natural satellite (moon) orbiting a planet",
                                    type:"object",
                                    required:[ "name" ],
                                    properties:{ name:{ type:"string",
                                        examples:[ "Phobos" ] },
                                      diameter:{ type:"number",
                                        format:"float",
                                        description:"Diameter in kilometers",
                                        examples:[ 22.2 ] } } } },
                                creator:{ description:"A user",
                                  type:"object",
                                  xml:{ name:"user" },
                                  properties:{ id:{ type:"integer",
                                      format:"int64",
                                      readOnly:true,
                                      examples:[ 1 ] },
                                    name:{ type:"string",
                                      examples:[ "Marc" ] } } },
                                tags:{ type:"array",
                                  items:{ type:"string" },
                                  examples:[ [ "solar-system",
                                      "rocky",
                                      "explored" ] ] },
                                lastUpdated:{ type:"string",
                                  format:"date-time",
                                  readOnly:true,
                                  examples:[ "2024-01-15T14:30:00Z" ] },
                                callbackUrl:{ type:"string",
                                  format:"uri",
                                  description:"URL to receive notifications about this planet",
                                  examples:[ "https://example.com/webhook" ] } } } } } },
                      { description:"A paginated resource",
                        type:"object",
                        properties:{ meta:{ type:"object",
                            properties:{ limit:{ type:"integer",
                                format:"int64",
                                examples:[ 10 ] },
                              offset:{ type:"integer",
                                format:"int64",
                                examples:[ 0 ] },
                              total:{ type:"integer",
                                format:"int64",
                                examples:[ 100 ] },
                              next:{ type:[ "string",
                                  "null" ],
                                examples:[ "/planets?limit=10&offset=10" ] } } } } } ] } } } } } },
        post:{ tags:[ "Planets" ],
          summary:"Create a planet",
          description:"Time to play god and create a new planet. What do you think? Ah, don’t think too much. What could go wrong anyway?",
          operationId:"createPlanet",
          callbacks:{ planetCreated:{ "{$request.body#/callbackUrl}":{ post:{ requestBody:{ description:"Information about the newly created planet",
                    content:{ "application/json":{ schema:{ description:"A planet in the Scalar Galaxy",
                          type:"object",
                          required:[ "id",
                            "name" ],
                          xml:{ name:"planet" },
                          properties:{ id:{ type:"integer",
                              format:"int64",
                              readOnly:true,
                              examples:[ 1 ],
                              "x-variable":"planetId" },
                            name:{ type:"string",
                              examples:[ "Mars",
                                "Jupiter",
                                "HD 40307g" ] },
                            description:{ type:[ "string",
                                "null" ],
                              examples:[ "The red planet",
                                "A gas giant with a great red spot" ] },
                            type:{ type:"string",
                              "enum":[ "terrestrial",
                                "gas_giant",
                                "ice_giant",
                                "dwarf",
                                "super_earth" ],
                              examples:[ "terrestrial" ] },
                            habitabilityIndex:{ type:"number",
                              format:"float",
                              minimum:0,
                              maximum:1,
                              description:"A score from 0 to 1 indicating potential habitability",
                              examples:[ 0.68 ] },
                            physicalProperties:{ type:"object",
                              properties:{ mass:{ type:"number",
                                  format:"float",
                                  description:"Mass in Earth masses",
                                  examples:[ 0.107 ] },
                                radius:{ type:"number",
                                  format:"float",
                                  description:"Radius in Earth radii",
                                  examples:[ 0.532 ] },
                                gravity:{ type:"number",
                                  format:"float",
                                  description:"Surface gravity in Earth g",
                                  examples:[ 0.378 ] },
                                temperature:{ type:"object",
                                  properties:{ min:{ type:"number",
                                      format:"float",
                                      description:"Minimum temperature in Kelvin",
                                      examples:[ 130 ] },
                                    max:{ type:"number",
                                      format:"float",
                                      description:"Maximum temperature in Kelvin",
                                      examples:[ 308 ] },
                                    average:{ type:"number",
                                      format:"float",
                                      description:"Average temperature in Kelvin",
                                      examples:[ 210 ] } } } } },
                            atmosphere:{ type:"array",
                              description:"Atmospheric composition",
                              items:{ type:"object",
                                properties:{ compound:{ type:"string",
                                    examples:[ "CO2",
                                      "N2" ] },
                                  percentage:{ type:"number",
                                    format:"float",
                                    examples:[ 95.3 ] } } } },
                            discoveredAt:{ type:"string",
                              format:"date-time",
                              examples:[ "1610-01-07T00:00:00Z" ] },
                            image:{ type:"string",
                              nullable:true,
                              examples:[ "https://cdn.scalar.com/photos/mars.jpg" ] },
                            satellites:{ type:"array",
                              items:{ description:"A natural satellite (moon) orbiting a planet",
                                type:"object",
                                required:[ "name" ],
                                properties:{ name:{ type:"string",
                                    examples:[ "Phobos" ] },
                                  diameter:{ type:"number",
                                    format:"float",
                                    description:"Diameter in kilometers",
                                    examples:[ 22.2 ] } } } },
                            creator:{ description:"A user",
                              type:"object",
                              xml:{ name:"user" },
                              properties:{ id:{ type:"integer",
                                  format:"int64",
                                  readOnly:true,
                                  examples:[ 1 ] },
                                name:{ type:"string",
                                  examples:[ "Marc" ] } } },
                            tags:{ type:"array",
                              items:{ type:"string" },
                              examples:[ [ "solar-system",
                                  "rocky",
                                  "explored" ] ] },
                            lastUpdated:{ type:"string",
                              format:"date-time",
                              readOnly:true,
                              examples:[ "2024-01-15T14:30:00Z" ] },
                            callbackUrl:{ type:"string",
                              format:"uri",
                              description:"URL to receive notifications about this planet",
                              examples:[ "https://example.com/webhook" ] } } } } } },
                  responses:{ 200:{ description:"Your server returns this code if it accepts the callback" } } } } } },
          requestBody:{ description:"Planet",
            content:{ "application/json":{ schema:{ description:"A planet in the Scalar Galaxy",
                  type:"object",
                  required:[ "id",
                    "name" ],
                  xml:{ name:"planet" },
                  properties:{ id:{ type:"integer",
                      format:"int64",
                      readOnly:true,
                      examples:[ 1 ],
                      "x-variable":"planetId" },
                    name:{ type:"string",
                      examples:[ "Mars",
                        "Jupiter",
                        "HD 40307g" ] },
                    description:{ type:[ "string",
                        "null" ],
                      examples:[ "The red planet",
                        "A gas giant with a great red spot" ] },
                    type:{ type:"string",
                      "enum":[ "terrestrial",
                        "gas_giant",
                        "ice_giant",
                        "dwarf",
                        "super_earth" ],
                      examples:[ "terrestrial" ] },
                    habitabilityIndex:{ type:"number",
                      format:"float",
                      minimum:0,
                      maximum:1,
                      description:"A score from 0 to 1 indicating potential habitability",
                      examples:[ 0.68 ] },
                    physicalProperties:{ type:"object",
                      properties:{ mass:{ type:"number",
                          format:"float",
                          description:"Mass in Earth masses",
                          examples:[ 0.107 ] },
                        radius:{ type:"number",
                          format:"float",
                          description:"Radius in Earth radii",
                          examples:[ 0.532 ] },
                        gravity:{ type:"number",
                          format:"float",
                          description:"Surface gravity in Earth g",
                          examples:[ 0.378 ] },
                        temperature:{ type:"object",
                          properties:{ min:{ type:"number",
                              format:"float",
                              description:"Minimum temperature in Kelvin",
                              examples:[ 130 ] },
                            max:{ type:"number",
                              format:"float",
                              description:"Maximum temperature in Kelvin",
                              examples:[ 308 ] },
                            average:{ type:"number",
                              format:"float",
                              description:"Average temperature in Kelvin",
                              examples:[ 210 ] } } } } },
                    atmosphere:{ type:"array",
                      description:"Atmospheric composition",
                      items:{ type:"object",
                        properties:{ compound:{ type:"string",
                            examples:[ "CO2",
                              "N2" ] },
                          percentage:{ type:"number",
                            format:"float",
                            examples:[ 95.3 ] } } } },
                    discoveredAt:{ type:"string",
                      format:"date-time",
                      examples:[ "1610-01-07T00:00:00Z" ] },
                    image:{ type:"string",
                      nullable:true,
                      examples:[ "https://cdn.scalar.com/photos/mars.jpg" ] },
                    satellites:{ type:"array",
                      items:{ description:"A natural satellite (moon) orbiting a planet",
                        type:"object",
                        required:[ "name" ],
                        properties:{ name:{ type:"string",
                            examples:[ "Phobos" ] },
                          diameter:{ type:"number",
                            format:"float",
                            description:"Diameter in kilometers",
                            examples:[ 22.2 ] } } } },
                    creator:{ description:"A user",
                      type:"object",
                      xml:{ name:"user" },
                      properties:{ id:{ type:"integer",
                          format:"int64",
                          readOnly:true,
                          examples:[ 1 ] },
                        name:{ type:"string",
                          examples:[ "Marc" ] } } },
                    tags:{ type:"array",
                      items:{ type:"string" },
                      examples:[ [ "solar-system",
                          "rocky",
                          "explored" ] ] },
                    lastUpdated:{ type:"string",
                      format:"date-time",
                      readOnly:true,
                      examples:[ "2024-01-15T14:30:00Z" ] },
                    callbackUrl:{ type:"string",
                      format:"uri",
                      description:"URL to receive notifications about this planet",
                      examples:[ "https://example.com/webhook" ] } } } },
              "application/xml":{ schema:{ description:"A planet in the Scalar Galaxy",
                  type:"object",
                  required:[ "id",
                    "name" ],
                  xml:{ name:"planet" },
                  properties:{ id:{ type:"integer",
                      format:"int64",
                      readOnly:true,
                      examples:[ 1 ],
                      "x-variable":"planetId" },
                    name:{ type:"string",
                      examples:[ "Mars",
                        "Jupiter",
                        "HD 40307g" ] },
                    description:{ type:[ "string",
                        "null" ],
                      examples:[ "The red planet",
                        "A gas giant with a great red spot" ] },
                    type:{ type:"string",
                      "enum":[ "terrestrial",
                        "gas_giant",
                        "ice_giant",
                        "dwarf",
                        "super_earth" ],
                      examples:[ "terrestrial" ] },
                    habitabilityIndex:{ type:"number",
                      format:"float",
                      minimum:0,
                      maximum:1,
                      description:"A score from 0 to 1 indicating potential habitability",
                      examples:[ 0.68 ] },
                    physicalProperties:{ type:"object",
                      properties:{ mass:{ type:"number",
                          format:"float",
                          description:"Mass in Earth masses",
                          examples:[ 0.107 ] },
                        radius:{ type:"number",
                          format:"float",
                          description:"Radius in Earth radii",
                          examples:[ 0.532 ] },
                        gravity:{ type:"number",
                          format:"float",
                          description:"Surface gravity in Earth g",
                          examples:[ 0.378 ] },
                        temperature:{ type:"object",
                          properties:{ min:{ type:"number",
                              format:"float",
                              description:"Minimum temperature in Kelvin",
                              examples:[ 130 ] },
                            max:{ type:"number",
                              format:"float",
                              description:"Maximum temperature in Kelvin",
                              examples:[ 308 ] },
                            average:{ type:"number",
                              format:"float",
                              description:"Average temperature in Kelvin",
                              examples:[ 210 ] } } } } },
                    atmosphere:{ type:"array",
                      description:"Atmospheric composition",
                      items:{ type:"object",
                        properties:{ compound:{ type:"string",
                            examples:[ "CO2",
                              "N2" ] },
                          percentage:{ type:"number",
                            format:"float",
                            examples:[ 95.3 ] } } } },
                    discoveredAt:{ type:"string",
                      format:"date-time",
                      examples:[ "1610-01-07T00:00:00Z" ] },
                    image:{ type:"string",
                      nullable:true,
                      examples:[ "https://cdn.scalar.com/photos/mars.jpg" ] },
                    satellites:{ type:"array",
                      items:{ description:"A natural satellite (moon) orbiting a planet",
                        type:"object",
                        required:[ "name" ],
                        properties:{ name:{ type:"string",
                            examples:[ "Phobos" ] },
                          diameter:{ type:"number",
                            format:"float",
                            description:"Diameter in kilometers",
                            examples:[ 22.2 ] } } } },
                    creator:{ description:"A user",
                      type:"object",
                      xml:{ name:"user" },
                      properties:{ id:{ type:"integer",
                          format:"int64",
                          readOnly:true,
                          examples:[ 1 ] },
                        name:{ type:"string",
                          examples:[ "Marc" ] } } },
                    tags:{ type:"array",
                      items:{ type:"string" },
                      examples:[ [ "solar-system",
                          "rocky",
                          "explored" ] ] },
                    lastUpdated:{ type:"string",
                      format:"date-time",
                      readOnly:true,
                      examples:[ "2024-01-15T14:30:00Z" ] },
                    callbackUrl:{ type:"string",
                      format:"uri",
                      description:"URL to receive notifications about this planet",
                      examples:[ "https://example.com/webhook" ] } } } } } },
          responses:{ 201:{ description:"Created",
              content:{ "application/json":{ schema:{ description:"A planet in the Scalar Galaxy",
                    type:"object",
                    required:[ "id",
                      "name" ],
                    xml:{ name:"planet" },
                    properties:{ id:{ type:"integer",
                        format:"int64",
                        readOnly:true,
                        examples:[ 1 ],
                        "x-variable":"planetId" },
                      name:{ type:"string",
                        examples:[ "Mars",
                          "Jupiter",
                          "HD 40307g" ] },
                      description:{ type:[ "string",
                          "null" ],
                        examples:[ "The red planet",
                          "A gas giant with a great red spot" ] },
                      type:{ type:"string",
                        "enum":[ "terrestrial",
                          "gas_giant",
                          "ice_giant",
                          "dwarf",
                          "super_earth" ],
                        examples:[ "terrestrial" ] },
                      habitabilityIndex:{ type:"number",
                        format:"float",
                        minimum:0,
                        maximum:1,
                        description:"A score from 0 to 1 indicating potential habitability",
                        examples:[ 0.68 ] },
                      physicalProperties:{ type:"object",
                        properties:{ mass:{ type:"number",
                            format:"float",
                            description:"Mass in Earth masses",
                            examples:[ 0.107 ] },
                          radius:{ type:"number",
                            format:"float",
                            description:"Radius in Earth radii",
                            examples:[ 0.532 ] },
                          gravity:{ type:"number",
                            format:"float",
                            description:"Surface gravity in Earth g",
                            examples:[ 0.378 ] },
                          temperature:{ type:"object",
                            properties:{ min:{ type:"number",
                                format:"float",
                                description:"Minimum temperature in Kelvin",
                                examples:[ 130 ] },
                              max:{ type:"number",
                                format:"float",
                                description:"Maximum temperature in Kelvin",
                                examples:[ 308 ] },
                              average:{ type:"number",
                                format:"float",
                                description:"Average temperature in Kelvin",
                                examples:[ 210 ] } } } } },
                      atmosphere:{ type:"array",
                        description:"Atmospheric composition",
                        items:{ type:"object",
                          properties:{ compound:{ type:"string",
                              examples:[ "CO2",
                                "N2" ] },
                            percentage:{ type:"number",
                              format:"float",
                              examples:[ 95.3 ] } } } },
                      discoveredAt:{ type:"string",
                        format:"date-time",
                        examples:[ "1610-01-07T00:00:00Z" ] },
                      image:{ type:"string",
                        nullable:true,
                        examples:[ "https://cdn.scalar.com/photos/mars.jpg" ] },
                      satellites:{ type:"array",
                        items:{ description:"A natural satellite (moon) orbiting a planet",
                          type:"object",
                          required:[ "name" ],
                          properties:{ name:{ type:"string",
                              examples:[ "Phobos" ] },
                            diameter:{ type:"number",
                              format:"float",
                              description:"Diameter in kilometers",
                              examples:[ 22.2 ] } } } },
                      creator:{ description:"A user",
                        type:"object",
                        xml:{ name:"user" },
                        properties:{ id:{ type:"integer",
                            format:"int64",
                            readOnly:true,
                            examples:[ 1 ] },
                          name:{ type:"string",
                            examples:[ "Marc" ] } } },
                      tags:{ type:"array",
                        items:{ type:"string" },
                        examples:[ [ "solar-system",
                            "rocky",
                            "explored" ] ] },
                      lastUpdated:{ type:"string",
                        format:"date-time",
                        readOnly:true,
                        examples:[ "2024-01-15T14:30:00Z" ] },
                      callbackUrl:{ type:"string",
                        format:"uri",
                        description:"URL to receive notifications about this planet",
                        examples:[ "https://example.com/webhook" ] } } } },
                "application/xml":{ schema:{ description:"A planet in the Scalar Galaxy",
                    type:"object",
                    required:[ "id",
                      "name" ],
                    xml:{ name:"planet" },
                    properties:{ id:{ type:"integer",
                        format:"int64",
                        readOnly:true,
                        examples:[ 1 ],
                        "x-variable":"planetId" },
                      name:{ type:"string",
                        examples:[ "Mars",
                          "Jupiter",
                          "HD 40307g" ] },
                      description:{ type:[ "string",
                          "null" ],
                        examples:[ "The red planet",
                          "A gas giant with a great red spot" ] },
                      type:{ type:"string",
                        "enum":[ "terrestrial",
                          "gas_giant",
                          "ice_giant",
                          "dwarf",
                          "super_earth" ],
                        examples:[ "terrestrial" ] },
                      habitabilityIndex:{ type:"number",
                        format:"float",
                        minimum:0,
                        maximum:1,
                        description:"A score from 0 to 1 indicating potential habitability",
                        examples:[ 0.68 ] },
                      physicalProperties:{ type:"object",
                        properties:{ mass:{ type:"number",
                            format:"float",
                            description:"Mass in Earth masses",
                            examples:[ 0.107 ] },
                          radius:{ type:"number",
                            format:"float",
                            description:"Radius in Earth radii",
                            examples:[ 0.532 ] },
                          gravity:{ type:"number",
                            format:"float",
                            description:"Surface gravity in Earth g",
                            examples:[ 0.378 ] },
                          temperature:{ type:"object",
                            properties:{ min:{ type:"number",
                                format:"float",
                                description:"Minimum temperature in Kelvin",
                                examples:[ 130 ] },
                              max:{ type:"number",
                                format:"float",
                                description:"Maximum temperature in Kelvin",
                                examples:[ 308 ] },
                              average:{ type:"number",
                                format:"float",
                                description:"Average temperature in Kelvin",
                                examples:[ 210 ] } } } } },
                      atmosphere:{ type:"array",
                        description:"Atmospheric composition",
                        items:{ type:"object",
                          properties:{ compound:{ type:"string",
                              examples:[ "CO2",
                                "N2" ] },
                            percentage:{ type:"number",
                              format:"float",
                              examples:[ 95.3 ] } } } },
                      discoveredAt:{ type:"string",
                        format:"date-time",
                        examples:[ "1610-01-07T00:00:00Z" ] },
                      image:{ type:"string",
                        nullable:true,
                        examples:[ "https://cdn.scalar.com/photos/mars.jpg" ] },
                      satellites:{ type:"array",
                        items:{ description:"A natural satellite (moon) orbiting a planet",
                          type:"object",
                          required:[ "name" ],
                          properties:{ name:{ type:"string",
                              examples:[ "Phobos" ] },
                            diameter:{ type:"number",
                              format:"float",
                              description:"Diameter in kilometers",
                              examples:[ 22.2 ] } } } },
                      creator:{ description:"A user",
                        type:"object",
                        xml:{ name:"user" },
                        properties:{ id:{ type:"integer",
                            format:"int64",
                            readOnly:true,
                            examples:[ 1 ] },
                          name:{ type:"string",
                            examples:[ "Marc" ] } } },
                      tags:{ type:"array",
                        items:{ type:"string" },
                        examples:[ [ "solar-system",
                            "rocky",
                            "explored" ] ] },
                      lastUpdated:{ type:"string",
                        format:"date-time",
                        readOnly:true,
                        examples:[ "2024-01-15T14:30:00Z" ] },
                      callbackUrl:{ type:"string",
                        format:"uri",
                        description:"URL to receive notifications about this planet",
                        examples:[ "https://example.com/webhook" ] } } } } } },
            400:{ description:"Bad Request",
              content:{ "application/json":{ schema:{ "x-scalar-ignore":true,
                    description:"RFC 7807 (https://datatracker.ietf.org/doc/html/rfc7807)",
                    type:"object",
                    properties:{ type:{ type:"string",
                        examples:[ "https://example.com/errors/bad-request" ] },
                      title:{ type:"string",
                        examples:[ "Bad Request" ] },
                      status:{ type:"integer",
                        format:"int64",
                        examples:[ 400 ] },
                      detail:{ type:"string",
                        examples:[ "The request was invalid." ] } } } },
                "application/xml":{ schema:{ "x-scalar-ignore":true,
                    description:"RFC 7807 (https://datatracker.ietf.org/doc/html/rfc7807)",
                    type:"object",
                    properties:{ type:{ type:"string",
                        examples:[ "https://example.com/errors/bad-request" ] },
                      title:{ type:"string",
                        examples:[ "Bad Request" ] },
                      status:{ type:"integer",
                        format:"int64",
                        examples:[ 400 ] },
                      detail:{ type:"string",
                        examples:[ "The request was invalid." ] } } } } } },
            403:{ description:"Forbidden",
              content:{ "application/json":{ schema:{ "x-scalar-ignore":true,
                    description:"RFC 7807 (https://datatracker.ietf.org/doc/html/rfc7807)",
                    type:"object",
                    properties:{ type:{ type:"string",
                        examples:[ "https://example.com/errors/forbidden" ] },
                      title:{ type:"string",
                        examples:[ "Forbidden" ] },
                      status:{ type:"integer",
                        format:"int64",
                        examples:[ 403 ] },
                      detail:{ type:"string",
                        examples:[ "You are not authorized to access this resource." ] } } } },
                "application/xml":{ schema:{ "x-scalar-ignore":true,
                    description:"RFC 7807 (https://datatracker.ietf.org/doc/html/rfc7807)",
                    type:"object",
                    properties:{ type:{ type:"string",
                        examples:[ "https://example.com/errors/forbidden" ] },
                      title:{ type:"string",
                        examples:[ "Forbidden" ] },
                      status:{ type:"integer",
                        format:"int64",
                        examples:[ 403 ] },
                      detail:{ type:"string",
                        examples:[ "You are not authorized to access this resource." ] } } } } } } } } },
      "/planets/{planetId}":{ get:{ tags:[ "Planets" ],
          summary:"Get a planet",
          description:"You’ll better learn a little bit more about the planets. It might come in handy once space travel is available for everyone.",
          operationId:"getPlanet",
          security:[ {} ],
          parameters:[ { name:"planetId",
              description:"The ID of the planet to get",
              "in":"path",
              required:true,
              schema:{ type:"integer",
                format:"int64",
                examples:[ 1 ] } } ],
          responses:{ 200:{ description:"Planet Found",
              content:{ "application/json":{ schema:{ description:"A planet in the Scalar Galaxy",
                    type:"object",
                    required:[ "id",
                      "name" ],
                    xml:{ name:"planet" },
                    properties:{ id:{ type:"integer",
                        format:"int64",
                        readOnly:true,
                        examples:[ 1 ],
                        "x-variable":"planetId" },
                      name:{ type:"string",
                        examples:[ "Mars",
                          "Jupiter",
                          "HD 40307g" ] },
                      description:{ type:[ "string",
                          "null" ],
                        examples:[ "The red planet",
                          "A gas giant with a great red spot" ] },
                      type:{ type:"string",
                        "enum":[ "terrestrial",
                          "gas_giant",
                          "ice_giant",
                          "dwarf",
                          "super_earth" ],
                        examples:[ "terrestrial" ] },
                      habitabilityIndex:{ type:"number",
                        format:"float",
                        minimum:0,
                        maximum:1,
                        description:"A score from 0 to 1 indicating potential habitability",
                        examples:[ 0.68 ] },
                      physicalProperties:{ type:"object",
                        properties:{ mass:{ type:"number",
                            format:"float",
                            description:"Mass in Earth masses",
                            examples:[ 0.107 ] },
                          radius:{ type:"number",
                            format:"float",
                            description:"Radius in Earth radii",
                            examples:[ 0.532 ] },
                          gravity:{ type:"number",
                            format:"float",
                            description:"Surface gravity in Earth g",
                            examples:[ 0.378 ] },
                          temperature:{ type:"object",
                            properties:{ min:{ type:"number",
                                format:"float",
                                description:"Minimum temperature in Kelvin",
                                examples:[ 130 ] },
                              max:{ type:"number",
                                format:"float",
                                description:"Maximum temperature in Kelvin",
                                examples:[ 308 ] },
                              average:{ type:"number",
                                format:"float",
                                description:"Average temperature in Kelvin",
                                examples:[ 210 ] } } } } },
                      atmosphere:{ type:"array",
                        description:"Atmospheric composition",
                        items:{ type:"object",
                          properties:{ compound:{ type:"string",
                              examples:[ "CO2",
                                "N2" ] },
                            percentage:{ type:"number",
                              format:"float",
                              examples:[ 95.3 ] } } } },
                      discoveredAt:{ type:"string",
                        format:"date-time",
                        examples:[ "1610-01-07T00:00:00Z" ] },
                      image:{ type:"string",
                        nullable:true,
                        examples:[ "https://cdn.scalar.com/photos/mars.jpg" ] },
                      satellites:{ type:"array",
                        items:{ description:"A natural satellite (moon) orbiting a planet",
                          type:"object",
                          required:[ "name" ],
                          properties:{ name:{ type:"string",
                              examples:[ "Phobos" ] },
                            diameter:{ type:"number",
                              format:"float",
                              description:"Diameter in kilometers",
                              examples:[ 22.2 ] } } } },
                      creator:{ description:"A user",
                        type:"object",
                        xml:{ name:"user" },
                        properties:{ id:{ type:"integer",
                            format:"int64",
                            readOnly:true,
                            examples:[ 1 ] },
                          name:{ type:"string",
                            examples:[ "Marc" ] } } },
                      tags:{ type:"array",
                        items:{ type:"string" },
                        examples:[ [ "solar-system",
                            "rocky",
                            "explored" ] ] },
                      lastUpdated:{ type:"string",
                        format:"date-time",
                        readOnly:true,
                        examples:[ "2024-01-15T14:30:00Z" ] },
                      callbackUrl:{ type:"string",
                        format:"uri",
                        description:"URL to receive notifications about this planet",
                        examples:[ "https://example.com/webhook" ] } } } },
                "application/xml":{ schema:{ description:"A planet in the Scalar Galaxy",
                    type:"object",
                    required:[ "id",
                      "name" ],
                    xml:{ name:"planet" },
                    properties:{ id:{ type:"integer",
                        format:"int64",
                        readOnly:true,
                        examples:[ 1 ],
                        "x-variable":"planetId" },
                      name:{ type:"string",
                        examples:[ "Mars",
                          "Jupiter",
                          "HD 40307g" ] },
                      description:{ type:[ "string",
                          "null" ],
                        examples:[ "The red planet",
                          "A gas giant with a great red spot" ] },
                      type:{ type:"string",
                        "enum":[ "terrestrial",
                          "gas_giant",
                          "ice_giant",
                          "dwarf",
                          "super_earth" ],
                        examples:[ "terrestrial" ] },
                      habitabilityIndex:{ type:"number",
                        format:"float",
                        minimum:0,
                        maximum:1,
                        description:"A score from 0 to 1 indicating potential habitability",
                        examples:[ 0.68 ] },
                      physicalProperties:{ type:"object",
                        properties:{ mass:{ type:"number",
                            format:"float",
                            description:"Mass in Earth masses",
                            examples:[ 0.107 ] },
                          radius:{ type:"number",
                            format:"float",
                            description:"Radius in Earth radii",
                            examples:[ 0.532 ] },
                          gravity:{ type:"number",
                            format:"float",
                            description:"Surface gravity in Earth g",
                            examples:[ 0.378 ] },
                          temperature:{ type:"object",
                            properties:{ min:{ type:"number",
                                format:"float",
                                description:"Minimum temperature in Kelvin",
                                examples:[ 130 ] },
                              max:{ type:"number",
                                format:"float",
                                description:"Maximum temperature in Kelvin",
                                examples:[ 308 ] },
                              average:{ type:"number",
                                format:"float",
                                description:"Average temperature in Kelvin",
                                examples:[ 210 ] } } } } },
                      atmosphere:{ type:"array",
                        description:"Atmospheric composition",
                        items:{ type:"object",
                          properties:{ compound:{ type:"string",
                              examples:[ "CO2",
                                "N2" ] },
                            percentage:{ type:"number",
                              format:"float",
                              examples:[ 95.3 ] } } } },
                      discoveredAt:{ type:"string",
                        format:"date-time",
                        examples:[ "1610-01-07T00:00:00Z" ] },
                      image:{ type:"string",
                        nullable:true,
                        examples:[ "https://cdn.scalar.com/photos/mars.jpg" ] },
                      satellites:{ type:"array",
                        items:{ description:"A natural satellite (moon) orbiting a planet",
                          type:"object",
                          required:[ "name" ],
                          properties:{ name:{ type:"string",
                              examples:[ "Phobos" ] },
                            diameter:{ type:"number",
                              format:"float",
                              description:"Diameter in kilometers",
                              examples:[ 22.2 ] } } } },
                      creator:{ description:"A user",
                        type:"object",
                        xml:{ name:"user" },
                        properties:{ id:{ type:"integer",
                            format:"int64",
                            readOnly:true,
                            examples:[ 1 ] },
                          name:{ type:"string",
                            examples:[ "Marc" ] } } },
                      tags:{ type:"array",
                        items:{ type:"string" },
                        examples:[ [ "solar-system",
                            "rocky",
                            "explored" ] ] },
                      lastUpdated:{ type:"string",
                        format:"date-time",
                        readOnly:true,
                        examples:[ "2024-01-15T14:30:00Z" ] },
                      callbackUrl:{ type:"string",
                        format:"uri",
                        description:"URL to receive notifications about this planet",
                        examples:[ "https://example.com/webhook" ] } } } } } },
            404:{ description:"NotFound",
              content:{ "application/json":{ schema:{ "x-scalar-ignore":true,
                    description:"RFC 7807 (https://datatracker.ietf.org/doc/html/rfc7807)",
                    type:"object",
                    properties:{ type:{ type:"string",
                        examples:[ "https://example.com/errors/not-found" ] },
                      title:{ type:"string",
                        examples:[ "Not Found" ] },
                      status:{ type:"integer",
                        format:"int64",
                        examples:[ 404 ] },
                      detail:{ type:"string",
                        examples:[ "The resource you are trying to access does not exist." ] } } } },
                "application/xml":{ schema:{ "x-scalar-ignore":true,
                    description:"RFC 7807 (https://datatracker.ietf.org/doc/html/rfc7807)",
                    type:"object",
                    properties:{ type:{ type:"string",
                        examples:[ "https://example.com/errors/not-found" ] },
                      title:{ type:"string",
                        examples:[ "Not Found" ] },
                      status:{ type:"integer",
                        format:"int64",
                        examples:[ 404 ] },
                      detail:{ type:"string",
                        examples:[ "The resource you are trying to access does not exist." ] } } } } } } } },
        put:{ tags:[ "Planets" ],
          summary:"Update a planet",
          description:"Sometimes you make mistakes, that's fine. No worries, you can update all planets.",
          operationId:"updatePlanet",
          requestBody:{ description:"New information about the planet",
            content:{ "application/json":{ schema:{ description:"A planet in the Scalar Galaxy",
                  type:"object",
                  required:[ "id",
                    "name" ],
                  xml:{ name:"planet" },
                  properties:{ id:{ type:"integer",
                      format:"int64",
                      readOnly:true,
                      examples:[ 1 ],
                      "x-variable":"planetId" },
                    name:{ type:"string",
                      examples:[ "Mars",
                        "Jupiter",
                        "HD 40307g" ] },
                    description:{ type:[ "string",
                        "null" ],
                      examples:[ "The red planet",
                        "A gas giant with a great red spot" ] },
                    type:{ type:"string",
                      "enum":[ "terrestrial",
                        "gas_giant",
                        "ice_giant",
                        "dwarf",
                        "super_earth" ],
                      examples:[ "terrestrial" ] },
                    habitabilityIndex:{ type:"number",
                      format:"float",
                      minimum:0,
                      maximum:1,
                      description:"A score from 0 to 1 indicating potential habitability",
                      examples:[ 0.68 ] },
                    physicalProperties:{ type:"object",
                      properties:{ mass:{ type:"number",
                          format:"float",
                          description:"Mass in Earth masses",
                          examples:[ 0.107 ] },
                        radius:{ type:"number",
                          format:"float",
                          description:"Radius in Earth radii",
                          examples:[ 0.532 ] },
                        gravity:{ type:"number",
                          format:"float",
                          description:"Surface gravity in Earth g",
                          examples:[ 0.378 ] },
                        temperature:{ type:"object",
                          properties:{ min:{ type:"number",
                              format:"float",
                              description:"Minimum temperature in Kelvin",
                              examples:[ 130 ] },
                            max:{ type:"number",
                              format:"float",
                              description:"Maximum temperature in Kelvin",
                              examples:[ 308 ] },
                            average:{ type:"number",
                              format:"float",
                              description:"Average temperature in Kelvin",
                              examples:[ 210 ] } } } } },
                    atmosphere:{ type:"array",
                      description:"Atmospheric composition",
                      items:{ type:"object",
                        properties:{ compound:{ type:"string",
                            examples:[ "CO2",
                              "N2" ] },
                          percentage:{ type:"number",
                            format:"float",
                            examples:[ 95.3 ] } } } },
                    discoveredAt:{ type:"string",
                      format:"date-time",
                      examples:[ "1610-01-07T00:00:00Z" ] },
                    image:{ type:"string",
                      nullable:true,
                      examples:[ "https://cdn.scalar.com/photos/mars.jpg" ] },
                    satellites:{ type:"array",
                      items:{ description:"A natural satellite (moon) orbiting a planet",
                        type:"object",
                        required:[ "name" ],
                        properties:{ name:{ type:"string",
                            examples:[ "Phobos" ] },
                          diameter:{ type:"number",
                            format:"float",
                            description:"Diameter in kilometers",
                            examples:[ 22.2 ] } } } },
                    creator:{ description:"A user",
                      type:"object",
                      xml:{ name:"user" },
                      properties:{ id:{ type:"integer",
                          format:"int64",
                          readOnly:true,
                          examples:[ 1 ] },
                        name:{ type:"string",
                          examples:[ "Marc" ] } } },
                    tags:{ type:"array",
                      items:{ type:"string" },
                      examples:[ [ "solar-system",
                          "rocky",
                          "explored" ] ] },
                    lastUpdated:{ type:"string",
                      format:"date-time",
                      readOnly:true,
                      examples:[ "2024-01-15T14:30:00Z" ] },
                    callbackUrl:{ type:"string",
                      format:"uri",
                      description:"URL to receive notifications about this planet",
                      examples:[ "https://example.com/webhook" ] } } } },
              "application/xml":{ schema:{ description:"A planet in the Scalar Galaxy",
                  type:"object",
                  required:[ "id",
                    "name" ],
                  xml:{ name:"planet" },
                  properties:{ id:{ type:"integer",
                      format:"int64",
                      readOnly:true,
                      examples:[ 1 ],
                      "x-variable":"planetId" },
                    name:{ type:"string",
                      examples:[ "Mars",
                        "Jupiter",
                        "HD 40307g" ] },
                    description:{ type:[ "string",
                        "null" ],
                      examples:[ "The red planet",
                        "A gas giant with a great red spot" ] },
                    type:{ type:"string",
                      "enum":[ "terrestrial",
                        "gas_giant",
                        "ice_giant",
                        "dwarf",
                        "super_earth" ],
                      examples:[ "terrestrial" ] },
                    habitabilityIndex:{ type:"number",
                      format:"float",
                      minimum:0,
                      maximum:1,
                      description:"A score from 0 to 1 indicating potential habitability",
                      examples:[ 0.68 ] },
                    physicalProperties:{ type:"object",
                      properties:{ mass:{ type:"number",
                          format:"float",
                          description:"Mass in Earth masses",
                          examples:[ 0.107 ] },
                        radius:{ type:"number",
                          format:"float",
                          description:"Radius in Earth radii",
                          examples:[ 0.532 ] },
                        gravity:{ type:"number",
                          format:"float",
                          description:"Surface gravity in Earth g",
                          examples:[ 0.378 ] },
                        temperature:{ type:"object",
                          properties:{ min:{ type:"number",
                              format:"float",
                              description:"Minimum temperature in Kelvin",
                              examples:[ 130 ] },
                            max:{ type:"number",
                              format:"float",
                              description:"Maximum temperature in Kelvin",
                              examples:[ 308 ] },
                            average:{ type:"number",
                              format:"float",
                              description:"Average temperature in Kelvin",
                              examples:[ 210 ] } } } } },
                    atmosphere:{ type:"array",
                      description:"Atmospheric composition",
                      items:{ type:"object",
                        properties:{ compound:{ type:"string",
                            examples:[ "CO2",
                              "N2" ] },
                          percentage:{ type:"number",
                            format:"float",
                            examples:[ 95.3 ] } } } },
                    discoveredAt:{ type:"string",
                      format:"date-time",
                      examples:[ "1610-01-07T00:00:00Z" ] },
                    image:{ type:"string",
                      nullable:true,
                      examples:[ "https://cdn.scalar.com/photos/mars.jpg" ] },
                    satellites:{ type:"array",
                      items:{ description:"A natural satellite (moon) orbiting a planet",
                        type:"object",
                        required:[ "name" ],
                        properties:{ name:{ type:"string",
                            examples:[ "Phobos" ] },
                          diameter:{ type:"number",
                            format:"float",
                            description:"Diameter in kilometers",
                            examples:[ 22.2 ] } } } },
                    creator:{ description:"A user",
                      type:"object",
                      xml:{ name:"user" },
                      properties:{ id:{ type:"integer",
                          format:"int64",
                          readOnly:true,
                          examples:[ 1 ] },
                        name:{ type:"string",
                          examples:[ "Marc" ] } } },
                    tags:{ type:"array",
                      items:{ type:"string" },
                      examples:[ [ "solar-system",
                          "rocky",
                          "explored" ] ] },
                    lastUpdated:{ type:"string",
                      format:"date-time",
                      readOnly:true,
                      examples:[ "2024-01-15T14:30:00Z" ] },
                    callbackUrl:{ type:"string",
                      format:"uri",
                      description:"URL to receive notifications about this planet",
                      examples:[ "https://example.com/webhook" ] } } } } } },
          parameters:[ { name:"planetId",
              description:"The ID of the planet to get",
              "in":"path",
              required:true,
              schema:{ type:"integer",
                format:"int64",
                examples:[ 1 ] } } ],
          responses:{ 200:{ description:"OK",
              content:{ "application/json":{ schema:{ description:"A planet in the Scalar Galaxy",
                    type:"object",
                    required:[ "id",
                      "name" ],
                    xml:{ name:"planet" },
                    properties:{ id:{ type:"integer",
                        format:"int64",
                        readOnly:true,
                        examples:[ 1 ],
                        "x-variable":"planetId" },
                      name:{ type:"string",
                        examples:[ "Mars",
                          "Jupiter",
                          "HD 40307g" ] },
                      description:{ type:[ "string",
                          "null" ],
                        examples:[ "The red planet",
                          "A gas giant with a great red spot" ] },
                      type:{ type:"string",
                        "enum":[ "terrestrial",
                          "gas_giant",
                          "ice_giant",
                          "dwarf",
                          "super_earth" ],
                        examples:[ "terrestrial" ] },
                      habitabilityIndex:{ type:"number",
                        format:"float",
                        minimum:0,
                        maximum:1,
                        description:"A score from 0 to 1 indicating potential habitability",
                        examples:[ 0.68 ] },
                      physicalProperties:{ type:"object",
                        properties:{ mass:{ type:"number",
                            format:"float",
                            description:"Mass in Earth masses",
                            examples:[ 0.107 ] },
                          radius:{ type:"number",
                            format:"float",
                            description:"Radius in Earth radii",
                            examples:[ 0.532 ] },
                          gravity:{ type:"number",
                            format:"float",
                            description:"Surface gravity in Earth g",
                            examples:[ 0.378 ] },
                          temperature:{ type:"object",
                            properties:{ min:{ type:"number",
                                format:"float",
                                description:"Minimum temperature in Kelvin",
                                examples:[ 130 ] },
                              max:{ type:"number",
                                format:"float",
                                description:"Maximum temperature in Kelvin",
                                examples:[ 308 ] },
                              average:{ type:"number",
                                format:"float",
                                description:"Average temperature in Kelvin",
                                examples:[ 210 ] } } } } },
                      atmosphere:{ type:"array",
                        description:"Atmospheric composition",
                        items:{ type:"object",
                          properties:{ compound:{ type:"string",
                              examples:[ "CO2",
                                "N2" ] },
                            percentage:{ type:"number",
                              format:"float",
                              examples:[ 95.3 ] } } } },
                      discoveredAt:{ type:"string",
                        format:"date-time",
                        examples:[ "1610-01-07T00:00:00Z" ] },
                      image:{ type:"string",
                        nullable:true,
                        examples:[ "https://cdn.scalar.com/photos/mars.jpg" ] },
                      satellites:{ type:"array",
                        items:{ description:"A natural satellite (moon) orbiting a planet",
                          type:"object",
                          required:[ "name" ],
                          properties:{ name:{ type:"string",
                              examples:[ "Phobos" ] },
                            diameter:{ type:"number",
                              format:"float",
                              description:"Diameter in kilometers",
                              examples:[ 22.2 ] } } } },
                      creator:{ description:"A user",
                        type:"object",
                        xml:{ name:"user" },
                        properties:{ id:{ type:"integer",
                            format:"int64",
                            readOnly:true,
                            examples:[ 1 ] },
                          name:{ type:"string",
                            examples:[ "Marc" ] } } },
                      tags:{ type:"array",
                        items:{ type:"string" },
                        examples:[ [ "solar-system",
                            "rocky",
                            "explored" ] ] },
                      lastUpdated:{ type:"string",
                        format:"date-time",
                        readOnly:true,
                        examples:[ "2024-01-15T14:30:00Z" ] },
                      callbackUrl:{ type:"string",
                        format:"uri",
                        description:"URL to receive notifications about this planet",
                        examples:[ "https://example.com/webhook" ] } } } },
                "application/xml":{ schema:{ description:"A planet in the Scalar Galaxy",
                    type:"object",
                    required:[ "id",
                      "name" ],
                    xml:{ name:"planet" },
                    properties:{ id:{ type:"integer",
                        format:"int64",
                        readOnly:true,
                        examples:[ 1 ],
                        "x-variable":"planetId" },
                      name:{ type:"string",
                        examples:[ "Mars",
                          "Jupiter",
                          "HD 40307g" ] },
                      description:{ type:[ "string",
                          "null" ],
                        examples:[ "The red planet",
                          "A gas giant with a great red spot" ] },
                      type:{ type:"string",
                        "enum":[ "terrestrial",
                          "gas_giant",
                          "ice_giant",
                          "dwarf",
                          "super_earth" ],
                        examples:[ "terrestrial" ] },
                      habitabilityIndex:{ type:"number",
                        format:"float",
                        minimum:0,
                        maximum:1,
                        description:"A score from 0 to 1 indicating potential habitability",
                        examples:[ 0.68 ] },
                      physicalProperties:{ type:"object",
                        properties:{ mass:{ type:"number",
                            format:"float",
                            description:"Mass in Earth masses",
                            examples:[ 0.107 ] },
                          radius:{ type:"number",
                            format:"float",
                            description:"Radius in Earth radii",
                            examples:[ 0.532 ] },
                          gravity:{ type:"number",
                            format:"float",
                            description:"Surface gravity in Earth g",
                            examples:[ 0.378 ] },
                          temperature:{ type:"object",
                            properties:{ min:{ type:"number",
                                format:"float",
                                description:"Minimum temperature in Kelvin",
                                examples:[ 130 ] },
                              max:{ type:"number",
                                format:"float",
                                description:"Maximum temperature in Kelvin",
                                examples:[ 308 ] },
                              average:{ type:"number",
                                format:"float",
                                description:"Average temperature in Kelvin",
                                examples:[ 210 ] } } } } },
                      atmosphere:{ type:"array",
                        description:"Atmospheric composition",
                        items:{ type:"object",
                          properties:{ compound:{ type:"string",
                              examples:[ "CO2",
                                "N2" ] },
                            percentage:{ type:"number",
                              format:"float",
                              examples:[ 95.3 ] } } } },
                      discoveredAt:{ type:"string",
                        format:"date-time",
                        examples:[ "1610-01-07T00:00:00Z" ] },
                      image:{ type:"string",
                        nullable:true,
                        examples:[ "https://cdn.scalar.com/photos/mars.jpg" ] },
                      satellites:{ type:"array",
                        items:{ description:"A natural satellite (moon) orbiting a planet",
                          type:"object",
                          required:[ "name" ],
                          properties:{ name:{ type:"string",
                              examples:[ "Phobos" ] },
                            diameter:{ type:"number",
                              format:"float",
                              description:"Diameter in kilometers",
                              examples:[ 22.2 ] } } } },
                      creator:{ description:"A user",
                        type:"object",
                        xml:{ name:"user" },
                        properties:{ id:{ type:"integer",
                            format:"int64",
                            readOnly:true,
                            examples:[ 1 ] },
                          name:{ type:"string",
                            examples:[ "Marc" ] } } },
                      tags:{ type:"array",
                        items:{ type:"string" },
                        examples:[ [ "solar-system",
                            "rocky",
                            "explored" ] ] },
                      lastUpdated:{ type:"string",
                        format:"date-time",
                        readOnly:true,
                        examples:[ "2024-01-15T14:30:00Z" ] },
                      callbackUrl:{ type:"string",
                        format:"uri",
                        description:"URL to receive notifications about this planet",
                        examples:[ "https://example.com/webhook" ] } } } } } },
            400:{ description:"Bad Request",
              content:{ "application/json":{ schema:{ "x-scalar-ignore":true,
                    description:"RFC 7807 (https://datatracker.ietf.org/doc/html/rfc7807)",
                    type:"object",
                    properties:{ type:{ type:"string",
                        examples:[ "https://example.com/errors/bad-request" ] },
                      title:{ type:"string",
                        examples:[ "Bad Request" ] },
                      status:{ type:"integer",
                        format:"int64",
                        examples:[ 400 ] },
                      detail:{ type:"string",
                        examples:[ "The request was invalid." ] } } } },
                "application/xml":{ schema:{ "x-scalar-ignore":true,
                    description:"RFC 7807 (https://datatracker.ietf.org/doc/html/rfc7807)",
                    type:"object",
                    properties:{ type:{ type:"string",
                        examples:[ "https://example.com/errors/bad-request" ] },
                      title:{ type:"string",
                        examples:[ "Bad Request" ] },
                      status:{ type:"integer",
                        format:"int64",
                        examples:[ 400 ] },
                      detail:{ type:"string",
                        examples:[ "The request was invalid." ] } } } } } },
            403:{ description:"Forbidden",
              content:{ "application/json":{ schema:{ "x-scalar-ignore":true,
                    description:"RFC 7807 (https://datatracker.ietf.org/doc/html/rfc7807)",
                    type:"object",
                    properties:{ type:{ type:"string",
                        examples:[ "https://example.com/errors/forbidden" ] },
                      title:{ type:"string",
                        examples:[ "Forbidden" ] },
                      status:{ type:"integer",
                        format:"int64",
                        examples:[ 403 ] },
                      detail:{ type:"string",
                        examples:[ "You are not authorized to access this resource." ] } } } },
                "application/xml":{ schema:{ "x-scalar-ignore":true,
                    description:"RFC 7807 (https://datatracker.ietf.org/doc/html/rfc7807)",
                    type:"object",
                    properties:{ type:{ type:"string",
                        examples:[ "https://example.com/errors/forbidden" ] },
                      title:{ type:"string",
                        examples:[ "Forbidden" ] },
                      status:{ type:"integer",
                        format:"int64",
                        examples:[ 403 ] },
                      detail:{ type:"string",
                        examples:[ "You are not authorized to access this resource." ] } } } } } },
            404:{ description:"NotFound",
              content:{ "application/json":{ schema:{ "x-scalar-ignore":true,
                    description:"RFC 7807 (https://datatracker.ietf.org/doc/html/rfc7807)",
                    type:"object",
                    properties:{ type:{ type:"string",
                        examples:[ "https://example.com/errors/not-found" ] },
                      title:{ type:"string",
                        examples:[ "Not Found" ] },
                      status:{ type:"integer",
                        format:"int64",
                        examples:[ 404 ] },
                      detail:{ type:"string",
                        examples:[ "The resource you are trying to access does not exist." ] } } } },
                "application/xml":{ schema:{ "x-scalar-ignore":true,
                    description:"RFC 7807 (https://datatracker.ietf.org/doc/html/rfc7807)",
                    type:"object",
                    properties:{ type:{ type:"string",
                        examples:[ "https://example.com/errors/not-found" ] },
                      title:{ type:"string",
                        examples:[ "Not Found" ] },
                      status:{ type:"integer",
                        format:"int64",
                        examples:[ 404 ] },
                      detail:{ type:"string",
                        examples:[ "The resource you are trying to access does not exist." ] } } } } } } } },
        "delete":{ tags:[ "Planets" ],
          summary:"Delete a planet",
          operationId:"deletePlanet",
          description:"This endpoint was used to delete planets. Unfortunately, that caused a lot of trouble for planets with life. So, this endpoint is now deprecated and should not be used anymore.",
          "x-scalar-stability":"experimental",
          parameters:[ { name:"planetId",
              description:"The ID of the planet to get",
              "in":"path",
              required:true,
              schema:{ type:"integer",
                format:"int64",
                examples:[ 1 ] } } ],
          responses:{ 204:{ description:"No Content" },
            404:{ description:"NotFound",
              content:{ "application/json":{ schema:{ "x-scalar-ignore":true,
                    description:"RFC 7807 (https://datatracker.ietf.org/doc/html/rfc7807)",
                    type:"object",
                    properties:{ type:{ type:"string",
                        examples:[ "https://example.com/errors/not-found" ] },
                      title:{ type:"string",
                        examples:[ "Not Found" ] },
                      status:{ type:"integer",
                        format:"int64",
                        examples:[ 404 ] },
                      detail:{ type:"string",
                        examples:[ "The resource you are trying to access does not exist." ] } } } },
                "application/xml":{ schema:{ "x-scalar-ignore":true,
                    description:"RFC 7807 (https://datatracker.ietf.org/doc/html/rfc7807)",
                    type:"object",
                    properties:{ type:{ type:"string",
                        examples:[ "https://example.com/errors/not-found" ] },
                      title:{ type:"string",
                        examples:[ "Not Found" ] },
                      status:{ type:"integer",
                        format:"int64",
                        examples:[ 404 ] },
                      detail:{ type:"string",
                        examples:[ "The resource you are trying to access does not exist." ] } } } } } } } } },
      "/planets/{planetId}/image":{ post:{ tags:[ "Planets" ],
          summary:"Upload an image to a planet",
          description:"Got a crazy good photo of a planet? Share it with the world!",
          operationId:"uploadImage",
          parameters:[ { name:"planetId",
              description:"The ID of the planet to get",
              "in":"path",
              required:true,
              schema:{ type:"integer",
                format:"int64",
                examples:[ 1 ] } } ],
          requestBody:{ description:"Image to upload",
            content:{ "multipart/form-data":{ schema:{ type:"object",
                  properties:{ image:{ type:"string",
                      format:"binary",
                      description:"The image file to upload",
                      examples:[ "@mars.jpg",
                        "@jupiter.png" ] } } } } } },
          responses:{ 200:{ description:"Image uploaded",
              content:{ "application/json":{ schema:{ "x-scalar-ignore":true,
                    description:"Message about an image upload",
                    type:"object",
                    properties:{ message:{ type:"string",
                        examples:[ "Image uploaded successfully" ] },
                      imageUrl:{ type:"string",
                        description:"The URL where the uploaded image can be accessed",
                        examples:[ "https://cdn.scalar.com/images/8f47c132-9d1f-4f83-b5a4-91db5ee757ab.jpg" ] },
                      uploadedAt:{ type:"string",
                        format:"date-time",
                        description:"Timestamp when the image was uploaded",
                        examples:[ "2024-01-15T14:30:00Z" ] },
                      fileSize:{ type:"integer",
                        description:"Size of the uploaded image in bytes",
                        examples:[ 1048576 ] },
                      mimeType:{ type:"string",
                        description:"The content type of the uploaded image",
                        examples:[ "image/jpeg",
                          "image/png" ] } } } },
                "application/xml":{ schema:{ "x-scalar-ignore":true,
                    description:"Message about an image upload",
                    type:"object",
                    properties:{ message:{ type:"string",
                        examples:[ "Image uploaded successfully" ] },
                      imageUrl:{ type:"string",
                        description:"The URL where the uploaded image can be accessed",
                        examples:[ "https://cdn.scalar.com/images/8f47c132-9d1f-4f83-b5a4-91db5ee757ab.jpg" ] },
                      uploadedAt:{ type:"string",
                        format:"date-time",
                        description:"Timestamp when the image was uploaded",
                        examples:[ "2024-01-15T14:30:00Z" ] },
                      fileSize:{ type:"integer",
                        description:"Size of the uploaded image in bytes",
                        examples:[ 1048576 ] },
                      mimeType:{ type:"string",
                        description:"The content type of the uploaded image",
                        examples:[ "image/jpeg",
                          "image/png" ] } } } } } },
            400:{ description:"Bad Request",
              content:{ "application/json":{ schema:{ "x-scalar-ignore":true,
                    description:"RFC 7807 (https://datatracker.ietf.org/doc/html/rfc7807)",
                    type:"object",
                    properties:{ type:{ type:"string",
                        examples:[ "https://example.com/errors/bad-request" ] },
                      title:{ type:"string",
                        examples:[ "Bad Request" ] },
                      status:{ type:"integer",
                        format:"int64",
                        examples:[ 400 ] },
                      detail:{ type:"string",
                        examples:[ "The request was invalid." ] } } } },
                "application/xml":{ schema:{ "x-scalar-ignore":true,
                    description:"RFC 7807 (https://datatracker.ietf.org/doc/html/rfc7807)",
                    type:"object",
                    properties:{ type:{ type:"string",
                        examples:[ "https://example.com/errors/bad-request" ] },
                      title:{ type:"string",
                        examples:[ "Bad Request" ] },
                      status:{ type:"integer",
                        format:"int64",
                        examples:[ 400 ] },
                      detail:{ type:"string",
                        examples:[ "The request was invalid." ] } } } } } },
            403:{ description:"Forbidden",
              content:{ "application/json":{ schema:{ "x-scalar-ignore":true,
                    description:"RFC 7807 (https://datatracker.ietf.org/doc/html/rfc7807)",
                    type:"object",
                    properties:{ type:{ type:"string",
                        examples:[ "https://example.com/errors/forbidden" ] },
                      title:{ type:"string",
                        examples:[ "Forbidden" ] },
                      status:{ type:"integer",
                        format:"int64",
                        examples:[ 403 ] },
                      detail:{ type:"string",
                        examples:[ "You are not authorized to access this resource." ] } } } },
                "application/xml":{ schema:{ "x-scalar-ignore":true,
                    description:"RFC 7807 (https://datatracker.ietf.org/doc/html/rfc7807)",
                    type:"object",
                    properties:{ type:{ type:"string",
                        examples:[ "https://example.com/errors/forbidden" ] },
                      title:{ type:"string",
                        examples:[ "Forbidden" ] },
                      status:{ type:"integer",
                        format:"int64",
                        examples:[ 403 ] },
                      detail:{ type:"string",
                        examples:[ "You are not authorized to access this resource." ] } } } } } },
            404:{ description:"NotFound",
              content:{ "application/json":{ schema:{ "x-scalar-ignore":true,
                    description:"RFC 7807 (https://datatracker.ietf.org/doc/html/rfc7807)",
                    type:"object",
                    properties:{ type:{ type:"string",
                        examples:[ "https://example.com/errors/not-found" ] },
                      title:{ type:"string",
                        examples:[ "Not Found" ] },
                      status:{ type:"integer",
                        format:"int64",
                        examples:[ 404 ] },
                      detail:{ type:"string",
                        examples:[ "The resource you are trying to access does not exist." ] } } } },
                "application/xml":{ schema:{ "x-scalar-ignore":true,
                    description:"RFC 7807 (https://datatracker.ietf.org/doc/html/rfc7807)",
                    type:"object",
                    properties:{ type:{ type:"string",
                        examples:[ "https://example.com/errors/not-found" ] },
                      title:{ type:"string",
                        examples:[ "Not Found" ] },
                      status:{ type:"integer",
                        format:"int64",
                        examples:[ 404 ] },
                      detail:{ type:"string",
                        examples:[ "The resource you are trying to access does not exist." ] } } } } } } } } },
      "/user/signup":{ post:{ tags:[ "Authentication" ],
          summary:"Create a user",
          description:"Time to create a user account, eh?",
          operationId:"createUser",
          security:[ {} ],
          requestBody:{ description:"User to create",
            content:{ "application/json":{ schema:{ allOf:[ { description:"A user",
                      type:"object",
                      xml:{ name:"user" },
                      properties:{ id:{ type:"integer",
                          format:"int64",
                          readOnly:true,
                          examples:[ 1 ] },
                        name:{ type:"string",
                          examples:[ "Marc" ] } } },
                    { description:"Credentials to authenticate a user",
                      type:"object",
                      required:[ "email",
                        "password" ],
                      properties:{ email:{ type:"string",
                          format:"email",
                          examples:[ "marc@scalar.com" ] },
                        password:{ type:"string",
                          writeOnly:true,
                          examples:[ "i-love-scalar",
                            "i-love-OSS",
                            "i-love-code" ] } } } ] },
                examples:{ Marc:{ value:{ name:"Marc",
                      email:"marc@scalar.com",
                      password:"i-love-scalar" } },
                  Cam:{ value:{ name:"Cam",
                      email:"cam@scalar.com",
                      password:"scalar-is-cool" } } } },
              "application/xml":{ schema:{ allOf:[ { description:"A user",
                      type:"object",
                      xml:{ name:"user" },
                      properties:{ id:{ type:"integer",
                          format:"int64",
                          readOnly:true,
                          examples:[ 1 ] },
                        name:{ type:"string",
                          examples:[ "Marc" ] } } },
                    { description:"Credentials to authenticate a user",
                      type:"object",
                      required:[ "email",
                        "password" ],
                      properties:{ email:{ type:"string",
                          format:"email",
                          examples:[ "marc@scalar.com" ] },
                        password:{ type:"string",
                          writeOnly:true,
                          examples:[ "i-love-scalar",
                            "i-love-OSS",
                            "i-love-code" ] } } } ] },
                examples:{ Marc:{ value:{ name:"Marc",
                      email:"marc@scalar.com",
                      password:"i-love-scalar" } },
                  Cam:{ value:{ name:"Cam",
                      email:"cam@scalar.com",
                      password:"scalar-is-cool" } } } } } },
          responses:{ 201:{ description:"Created",
              content:{ "application/json":{ schema:{ description:"A user",
                    type:"object",
                    xml:{ name:"user" },
                    properties:{ id:{ type:"integer",
                        format:"int64",
                        readOnly:true,
                        examples:[ 1 ] },
                      name:{ type:"string",
                        examples:[ "Marc" ] } } } },
                "application/xml":{ schema:{ description:"A user",
                    type:"object",
                    xml:{ name:"user" },
                    properties:{ id:{ type:"integer",
                        format:"int64",
                        readOnly:true,
                        examples:[ 1 ] },
                      name:{ type:"string",
                        examples:[ "Marc" ] } } } } } },
            400:{ description:"Bad Request",
              content:{ "application/json":{ schema:{ "x-scalar-ignore":true,
                    description:"RFC 7807 (https://datatracker.ietf.org/doc/html/rfc7807)",
                    type:"object",
                    properties:{ type:{ type:"string",
                        examples:[ "https://example.com/errors/bad-request" ] },
                      title:{ type:"string",
                        examples:[ "Bad Request" ] },
                      status:{ type:"integer",
                        format:"int64",
                        examples:[ 400 ] },
                      detail:{ type:"string",
                        examples:[ "The request was invalid." ] } } } },
                "application/xml":{ schema:{ "x-scalar-ignore":true,
                    description:"RFC 7807 (https://datatracker.ietf.org/doc/html/rfc7807)",
                    type:"object",
                    properties:{ type:{ type:"string",
                        examples:[ "https://example.com/errors/bad-request" ] },
                      title:{ type:"string",
                        examples:[ "Bad Request" ] },
                      status:{ type:"integer",
                        format:"int64",
                        examples:[ 400 ] },
                      detail:{ type:"string",
                        examples:[ "The request was invalid." ] } } } } } },
            401:{ description:"Unauthorized",
              content:{ "application/json":{ schema:{ "x-scalar-ignore":true,
                    description:"RFC 7807 (https://datatracker.ietf.org/doc/html/rfc7807)",
                    type:"object",
                    properties:{ type:{ type:"string",
                        examples:[ "https://example.com/errors/not-found" ] },
                      title:{ type:"string",
                        examples:[ "Unauthorized" ] },
                      status:{ type:"integer",
                        format:"int64",
                        examples:[ 401 ] },
                      detail:{ type:"string",
                        examples:[ "You are not authorized to access this resource." ] } } } },
                "application/xml":{ schema:{ "x-scalar-ignore":true,
                    description:"RFC 7807 (https://datatracker.ietf.org/doc/html/rfc7807)",
                    type:"object",
                    properties:{ type:{ type:"string",
                        examples:[ "https://example.com/errors/not-found" ] },
                      title:{ type:"string",
                        examples:[ "Unauthorized" ] },
                      status:{ type:"integer",
                        format:"int64",
                        examples:[ 401 ] },
                      detail:{ type:"string",
                        examples:[ "You are not authorized to access this resource." ] } } } } } },
            403:{ description:"Forbidden",
              content:{ "application/json":{ schema:{ "x-scalar-ignore":true,
                    description:"RFC 7807 (https://datatracker.ietf.org/doc/html/rfc7807)",
                    type:"object",
                    properties:{ type:{ type:"string",
                        examples:[ "https://example.com/errors/forbidden" ] },
                      title:{ type:"string",
                        examples:[ "Forbidden" ] },
                      status:{ type:"integer",
                        format:"int64",
                        examples:[ 403 ] },
                      detail:{ type:"string",
                        examples:[ "You are not authorized to access this resource." ] } } } },
                "application/xml":{ schema:{ "x-scalar-ignore":true,
                    description:"RFC 7807 (https://datatracker.ietf.org/doc/html/rfc7807)",
                    type:"object",
                    properties:{ type:{ type:"string",
                        examples:[ "https://example.com/errors/forbidden" ] },
                      title:{ type:"string",
                        examples:[ "Forbidden" ] },
                      status:{ type:"integer",
                        format:"int64",
                        examples:[ 403 ] },
                      detail:{ type:"string",
                        examples:[ "You are not authorized to access this resource." ] } } } } } },
            409:{ description:"Conflict",
              content:{ "application/json":{ schema:{ "x-scalar-ignore":true,
                    description:"RFC 7807 (https://datatracker.ietf.org/doc/html/rfc7807)",
                    type:"object",
                    properties:{ type:{ type:"string",
                        examples:[ "https://example.com/errors/conflict" ] },
                      title:{ type:"string",
                        examples:[ "Conflict" ] },
                      status:{ type:"integer",
                        format:"int64",
                        examples:[ 409 ] },
                      detail:{ type:"string",
                        examples:[ "The resource you are trying to access is in conflict." ] } } } },
                "application/xml":{ schema:{ "x-scalar-ignore":true,
                    description:"RFC 7807 (https://datatracker.ietf.org/doc/html/rfc7807)",
                    type:"object",
                    properties:{ type:{ type:"string",
                        examples:[ "https://example.com/errors/conflict" ] },
                      title:{ type:"string",
                        examples:[ "Conflict" ] },
                      status:{ type:"integer",
                        format:"int64",
                        examples:[ 409 ] },
                      detail:{ type:"string",
                        examples:[ "The resource you are trying to access is in conflict." ] } } } } } },
            422:{ description:"Unprocessable Entity",
              content:{ "application/json":{ schema:{ "x-scalar-ignore":true,
                    description:"RFC 7807 (https://datatracker.ietf.org/doc/html/rfc7807)",
                    type:"object",
                    properties:{ type:{ type:"string",
                        examples:[ "https://example.com/errors/unprocessable-entity" ] },
                      title:{ type:"string",
                        examples:[ "Unprocessable Entity" ] },
                      status:{ type:"integer",
                        format:"int64",
                        examples:[ 422 ] },
                      detail:{ type:"string",
                        examples:[ "The request was invalid." ] } } } },
                "application/xml":{ schema:{ "x-scalar-ignore":true,
                    description:"RFC 7807 (https://datatracker.ietf.org/doc/html/rfc7807)",
                    type:"object",
                    properties:{ type:{ type:"string",
                        examples:[ "https://example.com/errors/unprocessable-entity" ] },
                      title:{ type:"string",
                        examples:[ "Unprocessable Entity" ] },
                      status:{ type:"integer",
                        format:"int64",
                        examples:[ 422 ] },
                      detail:{ type:"string",
                        examples:[ "The request was invalid." ] } } } } } } } } },
      "/auth/token":{ post:{ tags:[ "Authentication" ],
          summary:"Get a token",
          description:"Yeah, this is the boring security stuff. Just get your super secret token and move on.",
          operationId:"getToken",
          security:[ {} ],
          requestBody:{ description:"Credentials to authenticate a user",
            content:{ "application/json":{ schema:{ description:"Credentials to authenticate a user",
                  type:"object",
                  required:[ "email",
                    "password" ],
                  properties:{ email:{ type:"string",
                      format:"email",
                      examples:[ "marc@scalar.com" ] },
                    password:{ type:"string",
                      writeOnly:true,
                      examples:[ "i-love-scalar",
                        "i-love-OSS",
                        "i-love-code" ] } } } },
              "application/xml":{ schema:{ description:"Credentials to authenticate a user",
                  type:"object",
                  required:[ "email",
                    "password" ],
                  properties:{ email:{ type:"string",
                      format:"email",
                      examples:[ "marc@scalar.com" ] },
                    password:{ type:"string",
                      writeOnly:true,
                      examples:[ "i-love-scalar",
                        "i-love-OSS",
                        "i-love-code" ] } } } } } },
          responses:{ 201:{ description:"Token Created",
              content:{ "application/json":{ schema:{ description:"A token to authenticate a user",
                    type:"object",
                    properties:{ token:{ type:"string",
                        examples:[ "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiIxMjM0NTY3ODkwIiwibmFtZSI6IkpvaG4gRG9lIiwiaWF0IjoxNTE2MjM5MDIyfQ.SflKxwRJSMeKKF2QT4fwpMeJf36POk6yJV_adQssw5c" ] } } } },
                "application/xml":{ schema:{ description:"A token to authenticate a user",
                    type:"object",
                    properties:{ token:{ type:"string",
                        examples:[ "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiIxMjM0NTY3ODkwIiwibmFtZSI6IkpvaG4gRG9lIiwiaWF0IjoxNTE2MjM5MDIyfQ.SflKxwRJSMeKKF2QT4fwpMeJf36POk6yJV_adQssw5c" ] } } } } } },
            400:{ description:"Bad Request",
              content:{ "application/json":{ schema:{ "x-scalar-ignore":true,
                    description:"RFC 7807 (https://datatracker.ietf.org/doc/html/rfc7807)",
                    type:"object",
                    properties:{ type:{ type:"string",
                        examples:[ "https://example.com/errors/bad-request" ] },
                      title:{ type:"string",
                        examples:[ "Bad Request" ] },
                      status:{ type:"integer",
                        format:"int64",
                        examples:[ 400 ] },
                      detail:{ type:"string",
                        examples:[ "The request was invalid." ] } } } },
                "application/xml":{ schema:{ "x-scalar-ignore":true,
                    description:"RFC 7807 (https://datatracker.ietf.org/doc/html/rfc7807)",
                    type:"object",
                    properties:{ type:{ type:"string",
                        examples:[ "https://example.com/errors/bad-request" ] },
                      title:{ type:"string",
                        examples:[ "Bad Request" ] },
                      status:{ type:"integer",
                        format:"int64",
                        examples:[ 400 ] },
                      detail:{ type:"string",
                        examples:[ "The request was invalid." ] } } } } } },
            401:{ description:"Unauthorized",
              content:{ "application/json":{ schema:{ "x-scalar-ignore":true,
                    description:"RFC 7807 (https://datatracker.ietf.org/doc/html/rfc7807)",
                    type:"object",
                    properties:{ type:{ type:"string",
                        examples:[ "https://example.com/errors/not-found" ] },
                      title:{ type:"string",
                        examples:[ "Unauthorized" ] },
                      status:{ type:"integer",
                        format:"int64",
                        examples:[ 401 ] },
                      detail:{ type:"string",
                        examples:[ "You are not authorized to access this resource." ] } } } },
                "application/xml":{ schema:{ "x-scalar-ignore":true,
                    description:"RFC 7807 (https://datatracker.ietf.org/doc/html/rfc7807)",
                    type:"object",
                    properties:{ type:{ type:"string",
                        examples:[ "https://example.com/errors/not-found" ] },
                      title:{ type:"string",
                        examples:[ "Unauthorized" ] },
                      status:{ type:"integer",
                        format:"int64",
                        examples:[ 401 ] },
                      detail:{ type:"string",
                        examples:[ "You are not authorized to access this resource." ] } } } } } },
            403:{ description:"Forbidden",
              content:{ "application/json":{ schema:{ "x-scalar-ignore":true,
                    description:"RFC 7807 (https://datatracker.ietf.org/doc/html/rfc7807)",
                    type:"object",
                    properties:{ type:{ type:"string",
                        examples:[ "https://example.com/errors/forbidden" ] },
                      title:{ type:"string",
                        examples:[ "Forbidden" ] },
                      status:{ type:"integer",
                        format:"int64",
                        examples:[ 403 ] },
                      detail:{ type:"string",
                        examples:[ "You are not authorized to access this resource." ] } } } },
                "application/xml":{ schema:{ "x-scalar-ignore":true,
                    description:"RFC 7807 (https://datatracker.ietf.org/doc/html/rfc7807)",
                    type:"object",
                    properties:{ type:{ type:"string",
                        examples:[ "https://example.com/errors/forbidden" ] },
                      title:{ type:"string",
                        examples:[ "Forbidden" ] },
                      status:{ type:"integer",
                        format:"int64",
                        examples:[ 403 ] },
                      detail:{ type:"string",
                        examples:[ "You are not authorized to access this resource." ] } } } } } } } } },
      "/me":{ get:{ tags:[ "Authentication" ],
          summary:"Get authenticated user",
          description:"Find yourself they say. That’s what you can do here.",
          operationId:"getMe",
          security:[ { basicAuth:[  ] },
            { oAuth2:[ "read:account" ] },
            { bearerAuth:[  ] },
            { apiKeyHeader:[  ] },
            { apiKeyQuery:[  ] } ],
          responses:{ 200:{ description:"OK",
              content:{ "application/json":{ schema:{ description:"A user",
                    type:"object",
                    xml:{ name:"user" },
                    properties:{ id:{ type:"integer",
                        format:"int64",
                        readOnly:true,
                        examples:[ 1 ] },
                      name:{ type:"string",
                        examples:[ "Marc" ] } } } },
                "application/xml":{ schema:{ description:"A user",
                    type:"object",
                    xml:{ name:"user" },
                    properties:{ id:{ type:"integer",
                        format:"int64",
                        readOnly:true,
                        examples:[ 1 ] },
                      name:{ type:"string",
                        examples:[ "Marc" ] } } } } } },
            401:{ description:"Unauthorized",
              content:{ "application/json":{ schema:{ "x-scalar-ignore":true,
                    description:"RFC 7807 (https://datatracker.ietf.org/doc/html/rfc7807)",
                    type:"object",
                    properties:{ type:{ type:"string",
                        examples:[ "https://example.com/errors/not-found" ] },
                      title:{ type:"string",
                        examples:[ "Unauthorized" ] },
                      status:{ type:"integer",
                        format:"int64",
                        examples:[ 401 ] },
                      detail:{ type:"string",
                        examples:[ "You are not authorized to access this resource." ] } } } },
                "application/xml":{ schema:{ "x-scalar-ignore":true,
                    description:"RFC 7807 (https://datatracker.ietf.org/doc/html/rfc7807)",
                    type:"object",
                    properties:{ type:{ type:"string",
                        examples:[ "https://example.com/errors/not-found" ] },
                      title:{ type:"string",
                        examples:[ "Unauthorized" ] },
                      status:{ type:"integer",
                        format:"int64",
                        examples:[ 401 ] },
                      detail:{ type:"string",
                        examples:[ "You are not authorized to access this resource." ] } } } } } },
            403:{ description:"Forbidden",
              content:{ "application/json":{ schema:{ "x-scalar-ignore":true,
                    description:"RFC 7807 (https://datatracker.ietf.org/doc/html/rfc7807)",
                    type:"object",
                    properties:{ type:{ type:"string",
                        examples:[ "https://example.com/errors/forbidden" ] },
                      title:{ type:"string",
                        examples:[ "Forbidden" ] },
                      status:{ type:"integer",
                        format:"int64",
                        examples:[ 403 ] },
                      detail:{ type:"string",
                        examples:[ "You are not authorized to access this resource." ] } } } },
                "application/xml":{ schema:{ "x-scalar-ignore":true,
                    description:"RFC 7807 (https://datatracker.ietf.org/doc/html/rfc7807)",
                    type:"object",
                    properties:{ type:{ type:"string",
                        examples:[ "https://example.com/errors/forbidden" ] },
                      title:{ type:"string",
                        examples:[ "Forbidden" ] },
                      status:{ type:"integer",
                        format:"int64",
                        examples:[ 403 ] },
                      detail:{ type:"string",
                        examples:[ "You are not authorized to access this resource." ] } } } } } } } } } },
    webhooks:{ newPlanet:{ post:{ httpVerb:"POST",
          path:"newPlanet",
          operationId:"newPlanet",
          name:"newPlanet",
          description:"",
          pathParameters:undefined,
          information:{ tags:[ { name:"Planets",
                description:"Everything about planets",
                operations:[ { httpVerb:"GET",
                    path:"/planets",
                    operationId:"getAllData",
                    name:"Get all planets",
                    description:"It’s easy to say you know them all, but do you really? Retrieve all the planets and check whether you missed one.",
                    information:{ tags:[ "Planets" ],
                      summary:"Get all planets",
                      description:"It’s easy to say you know them all, but do you really? Retrieve all the planets and check whether you missed one.",
                      operationId:"getAllData",
                      security:[ {} ],
                      parameters:[ { name:"limit",
                          description:"The number of items to return",
                          "in":"query",
                          required:false,
                          schema:{ type:"integer",
                            format:"int64",
                            "default":10 } },
                        { name:"offset",
                          description:"The number of items to skip before starting to collect the result set",
                          "in":"query",
                          required:false,
                          schema:{ type:"integer",
                            format:"int64",
                            "default":0 } } ],
                      responses:{ 200:{ description:"OK",
                          content:{ "application/json":{ schema:{ allOf:[ { type:"object",
                                    properties:{ data:{ type:"array",
                                        items:{ description:"A planet in the Scalar Galaxy",
                                          type:"object",
                                          required:[ "id",
                                            "name" ],
                                          xml:{ name:"planet" },
                                          properties:{ id:{ type:"integer",
                                              format:"int64",
                                              readOnly:true,
                                              examples:[ 1 ],
                                              "x-variable":"planetId" },
                                            name:{ type:"string",
                                              examples:[ "Mars",
                                                "Jupiter",
                                                "HD 40307g" ] },
                                            description:{ type:[ "string",
                                                "null" ],
                                              examples:[ "The red planet",
                                                "A gas giant with a great red spot" ] },
                                            type:{ type:"string",
                                              "enum":[ "terrestrial",
                                                "gas_giant",
                                                "ice_giant",
                                                "dwarf",
                                                "super_earth" ],
                                              examples:[ "terrestrial" ] },
                                            habitabilityIndex:{ type:"number",
                                              format:"float",
                                              minimum:0,
                                              maximum:1,
                                              description:"A score from 0 to 1 indicating potential habitability",
                                              examples:[ 0.68 ] },
                                            physicalProperties:{ type:"object",
                                              properties:{ mass:{ type:"number",
                                                  format:"float",
                                                  description:"Mass in Earth masses",
                                                  examples:[ 0.107 ] },
                                                radius:{ type:"number",
                                                  format:"float",
                                                  description:"Radius in Earth radii",
                                                  examples:[ 0.532 ] },
                                                gravity:{ type:"number",
                                                  format:"float",
                                                  description:"Surface gravity in Earth g",
                                                  examples:[ 0.378 ] },
                                                temperature:{ type:"object",
                                                  properties:{ min:{ type:"number",
                                                      format:"float",
                                                      description:"Minimum temperature in Kelvin",
                                                      examples:[ 130 ] },
                                                    max:{ type:"number",
                                                      format:"float",
                                                      description:"Maximum temperature in Kelvin",
                                                      examples:[ 308 ] },
                                                    average:{ type:"number",
                                                      format:"float",
                                                      description:"Average temperature in Kelvin",
                                                      examples:[ 210 ] } } } } },
                                            atmosphere:{ type:"array",
                                              description:"Atmospheric composition",
                                              items:{ type:"object",
                                                properties:{ compound:{ type:"string",
                                                    examples:[ "CO2",
                                                      "N2" ] },
                                                  percentage:{ type:"number",
                                                    format:"float",
                                                    examples:[ 95.3 ] } } } },
                                            discoveredAt:{ type:"string",
                                              format:"date-time",
                                              examples:[ "1610-01-07T00:00:00Z" ] },
                                            image:{ type:"string",
                                              nullable:true,
                                              examples:[ "https://cdn.scalar.com/photos/mars.jpg" ] },
                                            satellites:{ type:"array",
                                              items:{ description:"A natural satellite (moon) orbiting a planet",
                                                type:"object",
                                                required:[ "name" ],
                                                properties:{ name:{ type:"string",
                                                    examples:[ "Phobos" ] },
                                                  diameter:{ type:"number",
                                                    format:"float",
                                                    description:"Diameter in kilometers",
                                                    examples:[ 22.2 ] } } } },
                                            creator:{ description:"A user",
                                              type:"object",
                                              xml:{ name:"user" },
                                              properties:{ id:{ type:"integer",
                                                  format:"int64",
                                                  readOnly:true,
                                                  examples:[ 1 ] },
                                                name:{ type:"string",
                                                  examples:[ "Marc" ] } } },
                                            tags:{ type:"array",
                                              items:{ type:"string" },
                                              examples:[ [ "solar-system",
                                                  "rocky",
                                                  "explored" ] ] },
                                            lastUpdated:{ type:"string",
                                              format:"date-time",
                                              readOnly:true,
                                              examples:[ "2024-01-15T14:30:00Z" ] },
                                            callbackUrl:{ type:"string",
                                              format:"uri",
                                              description:"URL to receive notifications about this planet",
                                              examples:[ "https://example.com/webhook" ] } } } } } },
                                  { description:"A paginated resource",
                                    type:"object",
                                    properties:{ meta:{ type:"object",
                                        properties:{ limit:{ type:"integer",
                                            format:"int64",
                                            examples:[ 10 ] },
                                          offset:{ type:"integer",
                                            format:"int64",
                                            examples:[ 0 ] },
                                          total:{ type:"integer",
                                            format:"int64",
                                            examples:[ 100 ] },
                                          next:{ type:[ "string",
                                              "null" ],
                                            examples:[ "/planets?limit=10&offset=10" ] } } } } } ] } },
                            "application/xml":{ schema:{ allOf:[ { type:"object",
                                    xml:{ name:"planets" },
                                    properties:{ data:{ type:"array",
                                        items:{ description:"A planet in the Scalar Galaxy",
                                          type:"object",
                                          required:[ "id",
                                            "name" ],
                                          xml:{ name:"planet" },
                                          properties:{ id:{ type:"integer",
                                              format:"int64",
                                              readOnly:true,
                                              examples:[ 1 ],
                                              "x-variable":"planetId" },
                                            name:{ type:"string",
                                              examples:[ "Mars",
                                                "Jupiter",
                                                "HD 40307g" ] },
                                            description:{ type:[ "string",
                                                "null" ],
                                              examples:[ "The red planet",
                                                "A gas giant with a great red spot" ] },
                                            type:{ type:"string",
                                              "enum":[ "terrestrial",
                                                "gas_giant",
                                                "ice_giant",
                                                "dwarf",
                                                "super_earth" ],
                                              examples:[ "terrestrial" ] },
                                            habitabilityIndex:{ type:"number",
                                              format:"float",
                                              minimum:0,
                                              maximum:1,
                                              description:"A score from 0 to 1 indicating potential habitability",
                                              examples:[ 0.68 ] },
                                            physicalProperties:{ type:"object",
                                              properties:{ mass:{ type:"number",
                                                  format:"float",
                                                  description:"Mass in Earth masses",
                                                  examples:[ 0.107 ] },
                                                radius:{ type:"number",
                                                  format:"float",
                                                  description:"Radius in Earth radii",
                                                  examples:[ 0.532 ] },
                                                gravity:{ type:"number",
                                                  format:"float",
                                                  description:"Surface gravity in Earth g",
                                                  examples:[ 0.378 ] },
                                                temperature:{ type:"object",
                                                  properties:{ min:{ type:"number",
                                                      format:"float",
                                                      description:"Minimum temperature in Kelvin",
                                                      examples:[ 130 ] },
                                                    max:{ type:"number",
                                                      format:"float",
                                                      description:"Maximum temperature in Kelvin",
                                                      examples:[ 308 ] },
                                                    average:{ type:"number",
                                                      format:"float",
                                                      description:"Average temperature in Kelvin",
                                                      examples:[ 210 ] } } } } },
                                            atmosphere:{ type:"array",
                                              description:"Atmospheric composition",
                                              items:{ type:"object",
                                                properties:{ compound:{ type:"string",
                                                    examples:[ "CO2",
                                                      "N2" ] },
                                                  percentage:{ type:"number",
                                                    format:"float",
                                                    examples:[ 95.3 ] } } } },
                                            discoveredAt:{ type:"string",
                                              format:"date-time",
                                              examples:[ "1610-01-07T00:00:00Z" ] },
                                            image:{ type:"string",
                                              nullable:true,
                                              examples:[ "https://cdn.scalar.com/photos/mars.jpg" ] },
                                            satellites:{ type:"array",
                                              items:{ description:"A natural satellite (moon) orbiting a planet",
                                                type:"object",
                                                required:[ "name" ],
                                                properties:{ name:{ type:"string",
                                                    examples:[ "Phobos" ] },
                                                  diameter:{ type:"number",
                                                    format:"float",
                                                    description:"Diameter in kilometers",
                                                    examples:[ 22.2 ] } } } },
                                            creator:{ description:"A user",
                                              type:"object",
                                              xml:{ name:"user" },
                                              properties:{ id:{ type:"integer",
                                                  format:"int64",
                                                  readOnly:true,
                                                  examples:[ 1 ] },
                                                name:{ type:"string",
                                                  examples:[ "Marc" ] } } },
                                            tags:{ type:"array",
                                              items:{ type:"string" },
                                              examples:[ [ "solar-system",
                                                  "rocky",
                                                  "explored" ] ] },
                                            lastUpdated:{ type:"string",
                                              format:"date-time",
                                              readOnly:true,
                                              examples:[ "2024-01-15T14:30:00Z" ] },
                                            callbackUrl:{ type:"string",
                                              format:"uri",
                                              description:"URL to receive notifications about this planet",
                                              examples:[ "https://example.com/webhook" ] } } } } } },
                                  { description:"A paginated resource",
                                    type:"object",
                                    properties:{ meta:{ type:"object",
                                        properties:{ limit:{ type:"integer",
                                            format:"int64",
                                            examples:[ 10 ] },
                                          offset:{ type:"integer",
                                            format:"int64",
                                            examples:[ 0 ] },
                                          total:{ type:"integer",
                                            format:"int64",
                                            examples:[ 100 ] },
                                          next:{ type:[ "string",
                                              "null" ],
                                            examples:[ "/planets?limit=10&offset=10" ] } } } } } ] } } } } } },
                    pathParameters:undefined },
                  { httpVerb:"POST",
                    path:"/planets",
                    operationId:"createPlanet",
                    name:"Create a planet",
                    description:"Time to play god and create a new planet. What do you think? Ah, don’t think too much. What could go wrong anyway?",
                    information:{ tags:[ "Planets" ],
                      summary:"Create a planet",
                      description:"Time to play god and create a new planet. What do you think? Ah, don’t think too much. What could go wrong anyway?",
                      operationId:"createPlanet",
                      callbacks:{ planetCreated:{ "{$request.body#/callbackUrl}":{ post:{ requestBody:{ description:"Information about the newly created planet",
                                content:{ "application/json":{ schema:{ description:"A planet in the Scalar Galaxy",
                                      type:"object",
                                      required:[ "id",
                                        "name" ],
                                      xml:{ name:"planet" },
                                      properties:{ id:{ type:"integer",
                                          format:"int64",
                                          readOnly:true,
                                          examples:[ 1 ],
                                          "x-variable":"planetId" },
                                        name:{ type:"string",
                                          examples:[ "Mars",
                                            "Jupiter",
                                            "HD 40307g" ] },
                                        description:{ type:[ "string",
                                            "null" ],
                                          examples:[ "The red planet",
                                            "A gas giant with a great red spot" ] },
                                        type:{ type:"string",
                                          "enum":[ "terrestrial",
                                            "gas_giant",
                                            "ice_giant",
                                            "dwarf",
                                            "super_earth" ],
                                          examples:[ "terrestrial" ] },
                                        habitabilityIndex:{ type:"number",
                                          format:"float",
                                          minimum:0,
                                          maximum:1,
                                          description:"A score from 0 to 1 indicating potential habitability",
                                          examples:[ 0.68 ] },
                                        physicalProperties:{ type:"object",
                                          properties:{ mass:{ type:"number",
                                              format:"float",
                                              description:"Mass in Earth masses",
                                              examples:[ 0.107 ] },
                                            radius:{ type:"number",
                                              format:"float",
                                              description:"Radius in Earth radii",
                                              examples:[ 0.532 ] },
                                            gravity:{ type:"number",
                                              format:"float",
                                              description:"Surface gravity in Earth g",
                                              examples:[ 0.378 ] },
                                            temperature:{ type:"object",
                                              properties:{ min:{ type:"number",
                                                  format:"float",
                                                  description:"Minimum temperature in Kelvin",
                                                  examples:[ 130 ] },
                                                max:{ type:"number",
                                                  format:"float",
                                                  description:"Maximum temperature in Kelvin",
                                                  examples:[ 308 ] },
                                                average:{ type:"number",
                                                  format:"float",
                                                  description:"Average temperature in Kelvin",
                                                  examples:[ 210 ] } } } } },
                                        atmosphere:{ type:"array",
                                          description:"Atmospheric composition",
                                          items:{ type:"object",
                                            properties:{ compound:{ type:"string",
                                                examples:[ "CO2",
                                                  "N2" ] },
                                              percentage:{ type:"number",
                                                format:"float",
                                                examples:[ 95.3 ] } } } },
                                        discoveredAt:{ type:"string",
                                          format:"date-time",
                                          examples:[ "1610-01-07T00:00:00Z" ] },
                                        image:{ type:"string",
                                          nullable:true,
                                          examples:[ "https://cdn.scalar.com/photos/mars.jpg" ] },
                                        satellites:{ type:"array",
                                          items:{ description:"A natural satellite (moon) orbiting a planet",
                                            type:"object",
                                            required:[ "name" ],
                                            properties:{ name:{ type:"string",
                                                examples:[ "Phobos" ] },
                                              diameter:{ type:"number",
                                                format:"float",
                                                description:"Diameter in kilometers",
                                                examples:[ 22.2 ] } } } },
                                        creator:{ description:"A user",
                                          type:"object",
                                          xml:{ name:"user" },
                                          properties:{ id:{ type:"integer",
                                              format:"int64",
                                              readOnly:true,
                                              examples:[ 1 ] },
                                            name:{ type:"string",
                                              examples:[ "Marc" ] } } },
                                        tags:{ type:"array",
                                          items:{ type:"string" },
                                          examples:[ [ "solar-system",
                                              "rocky",
                                              "explored" ] ] },
                                        lastUpdated:{ type:"string",
                                          format:"date-time",
                                          readOnly:true,
                                          examples:[ "2024-01-15T14:30:00Z" ] },
                                        callbackUrl:{ type:"string",
                                          format:"uri",
                                          description:"URL to receive notifications about this planet",
                                          examples:[ "https://example.com/webhook" ] } } } } } },
                              responses:{ 200:{ description:"Your server returns this code if it accepts the callback" } } } } } },
                      requestBody:{ description:"Planet",
                        content:{ "application/json":{ schema:{ description:"A planet in the Scalar Galaxy",
                              type:"object",
                              required:[ "id",
                                "name" ],
                              xml:{ name:"planet" },
                              properties:{ id:{ type:"integer",
                                  format:"int64",
                                  readOnly:true,
                                  examples:[ 1 ],
                                  "x-variable":"planetId" },
                                name:{ type:"string",
                                  examples:[ "Mars",
                                    "Jupiter",
                                    "HD 40307g" ] },
                                description:{ type:[ "string",
                                    "null" ],
                                  examples:[ "The red planet",
                                    "A gas giant with a great red spot" ] },
                                type:{ type:"string",
                                  "enum":[ "terrestrial",
                                    "gas_giant",
                                    "ice_giant",
                                    "dwarf",
                                    "super_earth" ],
                                  examples:[ "terrestrial" ] },
                                habitabilityIndex:{ type:"number",
                                  format:"float",
                                  minimum:0,
                                  maximum:1,
                                  description:"A score from 0 to 1 indicating potential habitability",
                                  examples:[ 0.68 ] },
                                physicalProperties:{ type:"object",
                                  properties:{ mass:{ type:"number",
                                      format:"float",
                                      description:"Mass in Earth masses",
                                      examples:[ 0.107 ] },
                                    radius:{ type:"number",
                                      format:"float",
                                      description:"Radius in Earth radii",
                                      examples:[ 0.532 ] },
                                    gravity:{ type:"number",
                                      format:"float",
                                      description:"Surface gravity in Earth g",
                                      examples:[ 0.378 ] },
                                    temperature:{ type:"object",
                                      properties:{ min:{ type:"number",
                                          format:"float",
                                          description:"Minimum temperature in Kelvin",
                                          examples:[ 130 ] },
                                        max:{ type:"number",
                                          format:"float",
                                          description:"Maximum temperature in Kelvin",
                                          examples:[ 308 ] },
                                        average:{ type:"number",
                                          format:"float",
                                          description:"Average temperature in Kelvin",
                                          examples:[ 210 ] } } } } },
                                atmosphere:{ type:"array",
                                  description:"Atmospheric composition",
                                  items:{ type:"object",
                                    properties:{ compound:{ type:"string",
                                        examples:[ "CO2",
                                          "N2" ] },
                                      percentage:{ type:"number",
                                        format:"float",
                                        examples:[ 95.3 ] } } } },
                                discoveredAt:{ type:"string",
                                  format:"date-time",
                                  examples:[ "1610-01-07T00:00:00Z" ] },
                                image:{ type:"string",
                                  nullable:true,
                                  examples:[ "https://cdn.scalar.com/photos/mars.jpg" ] },
                                satellites:{ type:"array",
                                  items:{ description:"A natural satellite (moon) orbiting a planet",
                                    type:"object",
                                    required:[ "name" ],
                                    properties:{ name:{ type:"string",
                                        examples:[ "Phobos" ] },
                                      diameter:{ type:"number",
                                        format:"float",
                                        description:"Diameter in kilometers",
                                        examples:[ 22.2 ] } } } },
                                creator:{ description:"A user",
                                  type:"object",
                                  xml:{ name:"user" },
                                  properties:{ id:{ type:"integer",
                                      format:"int64",
                                      readOnly:true,
                                      examples:[ 1 ] },
                                    name:{ type:"string",
                                      examples:[ "Marc" ] } } },
                                tags:{ type:"array",
                                  items:{ type:"string" },
                                  examples:[ [ "solar-system",
                                      "rocky",
                                      "explored" ] ] },
                                lastUpdated:{ type:"string",
                                  format:"date-time",
                                  readOnly:true,
                                  examples:[ "2024-01-15T14:30:00Z" ] },
                                callbackUrl:{ type:"string",
                                  format:"uri",
                                  description:"URL to receive notifications about this planet",
                                  examples:[ "https://example.com/webhook" ] } } } },
                          "application/xml":{ schema:{ description:"A planet in the Scalar Galaxy",
                              type:"object",
                              required:[ "id",
                                "name" ],
                              xml:{ name:"planet" },
                              properties:{ id:{ type:"integer",
                                  format:"int64",
                                  readOnly:true,
                                  examples:[ 1 ],
                                  "x-variable":"planetId" },
                                name:{ type:"string",
                                  examples:[ "Mars",
                                    "Jupiter",
                                    "HD 40307g" ] },
                                description:{ type:[ "string",
                                    "null" ],
                                  examples:[ "The red planet",
                                    "A gas giant with a great red spot" ] },
                                type:{ type:"string",
                                  "enum":[ "terrestrial",
                                    "gas_giant",
                                    "ice_giant",
                                    "dwarf",
                                    "super_earth" ],
                                  examples:[ "terrestrial" ] },
                                habitabilityIndex:{ type:"number",
                                  format:"float",
                                  minimum:0,
                                  maximum:1,
                                  description:"A score from 0 to 1 indicating potential habitability",
                                  examples:[ 0.68 ] },
                                physicalProperties:{ type:"object",
                                  properties:{ mass:{ type:"number",
                                      format:"float",
                                      description:"Mass in Earth masses",
                                      examples:[ 0.107 ] },
                                    radius:{ type:"number",
                                      format:"float",
                                      description:"Radius in Earth radii",
                                      examples:[ 0.532 ] },
                                    gravity:{ type:"number",
                                      format:"float",
                                      description:"Surface gravity in Earth g",
                                      examples:[ 0.378 ] },
                                    temperature:{ type:"object",
                                      properties:{ min:{ type:"number",
                                          format:"float",
                                          description:"Minimum temperature in Kelvin",
                                          examples:[ 130 ] },
                                        max:{ type:"number",
                                          format:"float",
                                          description:"Maximum temperature in Kelvin",
                                          examples:[ 308 ] },
                                        average:{ type:"number",
                                          format:"float",
                                          description:"Average temperature in Kelvin",
                                          examples:[ 210 ] } } } } },
                                atmosphere:{ type:"array",
                                  description:"Atmospheric composition",
                                  items:{ type:"object",
                                    properties:{ compound:{ type:"string",
                                        examples:[ "CO2",
                                          "N2" ] },
                                      percentage:{ type:"number",
                                        format:"float",
                                        examples:[ 95.3 ] } } } },
                                discoveredAt:{ type:"string",
                                  format:"date-time",
                                  examples:[ "1610-01-07T00:00:00Z" ] },
                                image:{ type:"string",
                                  nullable:true,
                                  examples:[ "https://cdn.scalar.com/photos/mars.jpg" ] },
                                satellites:{ type:"array",
                                  items:{ description:"A natural satellite (moon) orbiting a planet",
                                    type:"object",
                                    required:[ "name" ],
                                    properties:{ name:{ type:"string",
                                        examples:[ "Phobos" ] },
                                      diameter:{ type:"number",
                                        format:"float",
                                        description:"Diameter in kilometers",
                                        examples:[ 22.2 ] } } } },
                                creator:{ description:"A user",
                                  type:"object",
                                  xml:{ name:"user" },
                                  properties:{ id:{ type:"integer",
                                      format:"int64",
                                      readOnly:true,
                                      examples:[ 1 ] },
                                    name:{ type:"string",
                                      examples:[ "Marc" ] } } },
                                tags:{ type:"array",
                                  items:{ type:"string" },
                                  examples:[ [ "solar-system",
                                      "rocky",
                                      "explored" ] ] },
                                lastUpdated:{ type:"string",
                                  format:"date-time",
                                  readOnly:true,
                                  examples:[ "2024-01-15T14:30:00Z" ] },
                                callbackUrl:{ type:"string",
                                  format:"uri",
                                  description:"URL to receive notifications about this planet",
                                  examples:[ "https://example.com/webhook" ] } } } } } },
                      responses:{ 201:{ description:"Created",
                          content:{ "application/json":{ schema:{ description:"A planet in the Scalar Galaxy",
                                type:"object",
                                required:[ "id",
                                  "name" ],
                                xml:{ name:"planet" },
                                properties:{ id:{ type:"integer",
                                    format:"int64",
                                    readOnly:true,
                                    examples:[ 1 ],
                                    "x-variable":"planetId" },
                                  name:{ type:"string",
                                    examples:[ "Mars",
                                      "Jupiter",
                                      "HD 40307g" ] },
                                  description:{ type:[ "string",
                                      "null" ],
                                    examples:[ "The red planet",
                                      "A gas giant with a great red spot" ] },
                                  type:{ type:"string",
                                    "enum":[ "terrestrial",
                                      "gas_giant",
                                      "ice_giant",
                                      "dwarf",
                                      "super_earth" ],
                                    examples:[ "terrestrial" ] },
                                  habitabilityIndex:{ type:"number",
                                    format:"float",
                                    minimum:0,
                                    maximum:1,
                                    description:"A score from 0 to 1 indicating potential habitability",
                                    examples:[ 0.68 ] },
                                  physicalProperties:{ type:"object",
                                    properties:{ mass:{ type:"number",
                                        format:"float",
                                        description:"Mass in Earth masses",
                                        examples:[ 0.107 ] },
                                      radius:{ type:"number",
                                        format:"float",
                                        description:"Radius in Earth radii",
                                        examples:[ 0.532 ] },
                                      gravity:{ type:"number",
                                        format:"float",
                                        description:"Surface gravity in Earth g",
                                        examples:[ 0.378 ] },
                                      temperature:{ type:"object",
                                        properties:{ min:{ type:"number",
                                            format:"float",
                                            description:"Minimum temperature in Kelvin",
                                            examples:[ 130 ] },
                                          max:{ type:"number",
                                            format:"float",
                                            description:"Maximum temperature in Kelvin",
                                            examples:[ 308 ] },
                                          average:{ type:"number",
                                            format:"float",
                                            description:"Average temperature in Kelvin",
                                            examples:[ 210 ] } } } } },
                                  atmosphere:{ type:"array",
                                    description:"Atmospheric composition",
                                    items:{ type:"object",
                                      properties:{ compound:{ type:"string",
                                          examples:[ "CO2",
                                            "N2" ] },
                                        percentage:{ type:"number",
                                          format:"float",
                                          examples:[ 95.3 ] } } } },
                                  discoveredAt:{ type:"string",
                                    format:"date-time",
                                    examples:[ "1610-01-07T00:00:00Z" ] },
                                  image:{ type:"string",
                                    nullable:true,
                                    examples:[ "https://cdn.scalar.com/photos/mars.jpg" ] },
                                  satellites:{ type:"array",
                                    items:{ description:"A natural satellite (moon) orbiting a planet",
                                      type:"object",
                                      required:[ "name" ],
                                      properties:{ name:{ type:"string",
                                          examples:[ "Phobos" ] },
                                        diameter:{ type:"number",
                                          format:"float",
                                          description:"Diameter in kilometers",
                                          examples:[ 22.2 ] } } } },
                                  creator:{ description:"A user",
                                    type:"object",
                                    xml:{ name:"user" },
                                    properties:{ id:{ type:"integer",
                                        format:"int64",
                                        readOnly:true,
                                        examples:[ 1 ] },
                                      name:{ type:"string",
                                        examples:[ "Marc" ] } } },
                                  tags:{ type:"array",
                                    items:{ type:"string" },
                                    examples:[ [ "solar-system",
                                        "rocky",
                                        "explored" ] ] },
                                  lastUpdated:{ type:"string",
                                    format:"date-time",
                                    readOnly:true,
                                    examples:[ "2024-01-15T14:30:00Z" ] },
                                  callbackUrl:{ type:"string",
                                    format:"uri",
                                    description:"URL to receive notifications about this planet",
                                    examples:[ "https://example.com/webhook" ] } } } },
                            "application/xml":{ schema:{ description:"A planet in the Scalar Galaxy",
                                type:"object",
                                required:[ "id",
                                  "name" ],
                                xml:{ name:"planet" },
                                properties:{ id:{ type:"integer",
                                    format:"int64",
                                    readOnly:true,
                                    examples:[ 1 ],
                                    "x-variable":"planetId" },
                                  name:{ type:"string",
                                    examples:[ "Mars",
                                      "Jupiter",
                                      "HD 40307g" ] },
                                  description:{ type:[ "string",
                                      "null" ],
                                    examples:[ "The red planet",
                                      "A gas giant with a great red spot" ] },
                                  type:{ type:"string",
                                    "enum":[ "terrestrial",
                                      "gas_giant",
                                      "ice_giant",
                                      "dwarf",
                                      "super_earth" ],
                                    examples:[ "terrestrial" ] },
                                  habitabilityIndex:{ type:"number",
                                    format:"float",
                                    minimum:0,
                                    maximum:1,
                                    description:"A score from 0 to 1 indicating potential habitability",
                                    examples:[ 0.68 ] },
                                  physicalProperties:{ type:"object",
                                    properties:{ mass:{ type:"number",
                                        format:"float",
                                        description:"Mass in Earth masses",
                                        examples:[ 0.107 ] },
                                      radius:{ type:"number",
                                        format:"float",
                                        description:"Radius in Earth radii",
                                        examples:[ 0.532 ] },
                                      gravity:{ type:"number",
                                        format:"float",
                                        description:"Surface gravity in Earth g",
                                        examples:[ 0.378 ] },
                                      temperature:{ type:"object",
                                        properties:{ min:{ type:"number",
                                            format:"float",
                                            description:"Minimum temperature in Kelvin",
                                            examples:[ 130 ] },
                                          max:{ type:"number",
                                            format:"float",
                                            description:"Maximum temperature in Kelvin",
                                            examples:[ 308 ] },
                                          average:{ type:"number",
                                            format:"float",
                                            description:"Average temperature in Kelvin",
                                            examples:[ 210 ] } } } } },
                                  atmosphere:{ type:"array",
                                    description:"Atmospheric composition",
                                    items:{ type:"object",
                                      properties:{ compound:{ type:"string",
                                          examples:[ "CO2",
                                            "N2" ] },
                                        percentage:{ type:"number",
                                          format:"float",
                                          examples:[ 95.3 ] } } } },
                                  discoveredAt:{ type:"string",
                                    format:"date-time",
                                    examples:[ "1610-01-07T00:00:00Z" ] },
                                  image:{ type:"string",
                                    nullable:true,
                                    examples:[ "https://cdn.scalar.com/photos/mars.jpg" ] },
                                  satellites:{ type:"array",
                                    items:{ description:"A natural satellite (moon) orbiting a planet",
                                      type:"object",
                                      required:[ "name" ],
                                      properties:{ name:{ type:"string",
                                          examples:[ "Phobos" ] },
                                        diameter:{ type:"number",
                                          format:"float",
                                          description:"Diameter in kilometers",
                                          examples:[ 22.2 ] } } } },
                                  creator:{ description:"A user",
                                    type:"object",
                                    xml:{ name:"user" },
                                    properties:{ id:{ type:"integer",
                                        format:"int64",
                                        readOnly:true,
                                        examples:[ 1 ] },
                                      name:{ type:"string",
                                        examples:[ "Marc" ] } } },
                                  tags:{ type:"array",
                                    items:{ type:"string" },
                                    examples:[ [ "solar-system",
                                        "rocky",
                                        "explored" ] ] },
                                  lastUpdated:{ type:"string",
                                    format:"date-time",
                                    readOnly:true,
                                    examples:[ "2024-01-15T14:30:00Z" ] },
                                  callbackUrl:{ type:"string",
                                    format:"uri",
                                    description:"URL to receive notifications about this planet",
                                    examples:[ "https://example.com/webhook" ] } } } } } },
                        400:{ description:"Bad Request",
                          content:{ "application/json":{ schema:{ "x-scalar-ignore":true,
                                description:"RFC 7807 (https://datatracker.ietf.org/doc/html/rfc7807)",
                                type:"object",
                                properties:{ type:{ type:"string",
                                    examples:[ "https://example.com/errors/bad-request" ] },
                                  title:{ type:"string",
                                    examples:[ "Bad Request" ] },
                                  status:{ type:"integer",
                                    format:"int64",
                                    examples:[ 400 ] },
                                  detail:{ type:"string",
                                    examples:[ "The request was invalid." ] } } } },
                            "application/xml":{ schema:{ "x-scalar-ignore":true,
                                description:"RFC 7807 (https://datatracker.ietf.org/doc/html/rfc7807)",
                                type:"object",
                                properties:{ type:{ type:"string",
                                    examples:[ "https://example.com/errors/bad-request" ] },
                                  title:{ type:"string",
                                    examples:[ "Bad Request" ] },
                                  status:{ type:"integer",
                                    format:"int64",
                                    examples:[ 400 ] },
                                  detail:{ type:"string",
                                    examples:[ "The request was invalid." ] } } } } } },
                        403:{ description:"Forbidden",
                          content:{ "application/json":{ schema:{ "x-scalar-ignore":true,
                                description:"RFC 7807 (https://datatracker.ietf.org/doc/html/rfc7807)",
                                type:"object",
                                properties:{ type:{ type:"string",
                                    examples:[ "https://example.com/errors/forbidden" ] },
                                  title:{ type:"string",
                                    examples:[ "Forbidden" ] },
                                  status:{ type:"integer",
                                    format:"int64",
                                    examples:[ 403 ] },
                                  detail:{ type:"string",
                                    examples:[ "You are not authorized to access this resource." ] } } } },
                            "application/xml":{ schema:{ "x-scalar-ignore":true,
                                description:"RFC 7807 (https://datatracker.ietf.org/doc/html/rfc7807)",
                                type:"object",
                                properties:{ type:{ type:"string",
                                    examples:[ "https://example.com/errors/forbidden" ] },
                                  title:{ type:"string",
                                    examples:[ "Forbidden" ] },
                                  status:{ type:"integer",
                                    format:"int64",
                                    examples:[ 403 ] },
                                  detail:{ type:"string",
                                    examples:[ "You are not authorized to access this resource." ] } } } } } } } },
                    pathParameters:undefined },
                  { httpVerb:"GET",
                    path:"/planets/{planetId}",
                    operationId:"getPlanet",
                    name:"Get a planet",
                    description:"You’ll better learn a little bit more about the planets. It might come in handy once space travel is available for everyone.",
                    information:{ tags:[ "Planets" ],
                      summary:"Get a planet",
                      description:"You’ll better learn a little bit more about the planets. It might come in handy once space travel is available for everyone.",
                      operationId:"getPlanet",
                      security:[ {} ],
                      parameters:[ { name:"planetId",
                          description:"The ID of the planet to get",
                          "in":"path",
                          required:true,
                          schema:{ type:"integer",
                            format:"int64",
                            examples:[ 1 ] } } ],
                      responses:{ 200:{ description:"Planet Found",
                          content:{ "application/json":{ schema:{ description:"A planet in the Scalar Galaxy",
                                type:"object",
                                required:[ "id",
                                  "name" ],
                                xml:{ name:"planet" },
                                properties:{ id:{ type:"integer",
                                    format:"int64",
                                    readOnly:true,
                                    examples:[ 1 ],
                                    "x-variable":"planetId" },
                                  name:{ type:"string",
                                    examples:[ "Mars",
                                      "Jupiter",
                                      "HD 40307g" ] },
                                  description:{ type:[ "string",
                                      "null" ],
                                    examples:[ "The red planet",
                                      "A gas giant with a great red spot" ] },
                                  type:{ type:"string",
                                    "enum":[ "terrestrial",
                                      "gas_giant",
                                      "ice_giant",
                                      "dwarf",
                                      "super_earth" ],
                                    examples:[ "terrestrial" ] },
                                  habitabilityIndex:{ type:"number",
                                    format:"float",
                                    minimum:0,
                                    maximum:1,
                                    description:"A score from 0 to 1 indicating potential habitability",
                                    examples:[ 0.68 ] },
                                  physicalProperties:{ type:"object",
                                    properties:{ mass:{ type:"number",
                                        format:"float",
                                        description:"Mass in Earth masses",
                                        examples:[ 0.107 ] },
                                      radius:{ type:"number",
                                        format:"float",
                                        description:"Radius in Earth radii",
                                        examples:[ 0.532 ] },
                                      gravity:{ type:"number",
                                        format:"float",
                                        description:"Surface gravity in Earth g",
                                        examples:[ 0.378 ] },
                                      temperature:{ type:"object",
                                        properties:{ min:{ type:"number",
                                            format:"float",
                                            description:"Minimum temperature in Kelvin",
                                            examples:[ 130 ] },
                                          max:{ type:"number",
                                            format:"float",
                                            description:"Maximum temperature in Kelvin",
                                            examples:[ 308 ] },
                                          average:{ type:"number",
                                            format:"float",
                                            description:"Average temperature in Kelvin",
                                            examples:[ 210 ] } } } } },
                                  atmosphere:{ type:"array",
                                    description:"Atmospheric composition",
                                    items:{ type:"object",
                                      properties:{ compound:{ type:"string",
                                          examples:[ "CO2",
                                            "N2" ] },
                                        percentage:{ type:"number",
                                          format:"float",
                                          examples:[ 95.3 ] } } } },
                                  discoveredAt:{ type:"string",
                                    format:"date-time",
                                    examples:[ "1610-01-07T00:00:00Z" ] },
                                  image:{ type:"string",
                                    nullable:true,
                                    examples:[ "https://cdn.scalar.com/photos/mars.jpg" ] },
                                  satellites:{ type:"array",
                                    items:{ description:"A natural satellite (moon) orbiting a planet",
                                      type:"object",
                                      required:[ "name" ],
                                      properties:{ name:{ type:"string",
                                          examples:[ "Phobos" ] },
                                        diameter:{ type:"number",
                                          format:"float",
                                          description:"Diameter in kilometers",
                                          examples:[ 22.2 ] } } } },
                                  creator:{ description:"A user",
                                    type:"object",
                                    xml:{ name:"user" },
                                    properties:{ id:{ type:"integer",
                                        format:"int64",
                                        readOnly:true,
                                        examples:[ 1 ] },
                                      name:{ type:"string",
                                        examples:[ "Marc" ] } } },
                                  tags:{ type:"array",
                                    items:{ type:"string" },
                                    examples:[ [ "solar-system",
                                        "rocky",
                                        "explored" ] ] },
                                  lastUpdated:{ type:"string",
                                    format:"date-time",
                                    readOnly:true,
                                    examples:[ "2024-01-15T14:30:00Z" ] },
                                  callbackUrl:{ type:"string",
                                    format:"uri",
                                    description:"URL to receive notifications about this planet",
                                    examples:[ "https://example.com/webhook" ] } } } },
                            "application/xml":{ schema:{ description:"A planet in the Scalar Galaxy",
                                type:"object",
                                required:[ "id",
                                  "name" ],
                                xml:{ name:"planet" },
                                properties:{ id:{ type:"integer",
                                    format:"int64",
                                    readOnly:true,
                                    examples:[ 1 ],
                                    "x-variable":"planetId" },
                                  name:{ type:"string",
                                    examples:[ "Mars",
                                      "Jupiter",
                                      "HD 40307g" ] },
                                  description:{ type:[ "string",
                                      "null" ],
                                    examples:[ "The red planet",
                                      "A gas giant with a great red spot" ] },
                                  type:{ type:"string",
                                    "enum":[ "terrestrial",
                                      "gas_giant",
                                      "ice_giant",
                                      "dwarf",
                                      "super_earth" ],
                                    examples:[ "terrestrial" ] },
                                  habitabilityIndex:{ type:"number",
                                    format:"float",
                                    minimum:0,
                                    maximum:1,
                                    description:"A score from 0 to 1 indicating potential habitability",
                                    examples:[ 0.68 ] },
                                  physicalProperties:{ type:"object",
                                    properties:{ mass:{ type:"number",
                                        format:"float",
                                        description:"Mass in Earth masses",
                                        examples:[ 0.107 ] },
                                      radius:{ type:"number",
                                        format:"float",
                                        description:"Radius in Earth radii",
                                        examples:[ 0.532 ] },
                                      gravity:{ type:"number",
                                        format:"float",
                                        description:"Surface gravity in Earth g",
                                        examples:[ 0.378 ] },
                                      temperature:{ type:"object",
                                        properties:{ min:{ type:"number",
                                            format:"float",
                                            description:"Minimum temperature in Kelvin",
                                            examples:[ 130 ] },
                                          max:{ type:"number",
                                            format:"float",
                                            description:"Maximum temperature in Kelvin",
                                            examples:[ 308 ] },
                                          average:{ type:"number",
                                            format:"float",
                                            description:"Average temperature in Kelvin",
                                            examples:[ 210 ] } } } } },
                                  atmosphere:{ type:"array",
                                    description:"Atmospheric composition",
                                    items:{ type:"object",
                                      properties:{ compound:{ type:"string",
                                          examples:[ "CO2",
                                            "N2" ] },
                                        percentage:{ type:"number",
                                          format:"float",
                                          examples:[ 95.3 ] } } } },
                                  discoveredAt:{ type:"string",
                                    format:"date-time",
                                    examples:[ "1610-01-07T00:00:00Z" ] },
                                  image:{ type:"string",
                                    nullable:true,
                                    examples:[ "https://cdn.scalar.com/photos/mars.jpg" ] },
                                  satellites:{ type:"array",
                                    items:{ description:"A natural satellite (moon) orbiting a planet",
                                      type:"object",
                                      required:[ "name" ],
                                      properties:{ name:{ type:"string",
                                          examples:[ "Phobos" ] },
                                        diameter:{ type:"number",
                                          format:"float",
                                          description:"Diameter in kilometers",
                                          examples:[ 22.2 ] } } } },
                                  creator:{ description:"A user",
                                    type:"object",
                                    xml:{ name:"user" },
                                    properties:{ id:{ type:"integer",
                                        format:"int64",
                                        readOnly:true,
                                        examples:[ 1 ] },
                                      name:{ type:"string",
                                        examples:[ "Marc" ] } } },
                                  tags:{ type:"array",
                                    items:{ type:"string" },
                                    examples:[ [ "solar-system",
                                        "rocky",
                                        "explored" ] ] },
                                  lastUpdated:{ type:"string",
                                    format:"date-time",
                                    readOnly:true,
                                    examples:[ "2024-01-15T14:30:00Z" ] },
                                  callbackUrl:{ type:"string",
                                    format:"uri",
                                    description:"URL to receive notifications about this planet",
                                    examples:[ "https://example.com/webhook" ] } } } } } },
                        404:{ description:"NotFound",
                          content:{ "application/json":{ schema:{ "x-scalar-ignore":true,
                                description:"RFC 7807 (https://datatracker.ietf.org/doc/html/rfc7807)",
                                type:"object",
                                properties:{ type:{ type:"string",
                                    examples:[ "https://example.com/errors/not-found" ] },
                                  title:{ type:"string",
                                    examples:[ "Not Found" ] },
                                  status:{ type:"integer",
                                    format:"int64",
                                    examples:[ 404 ] },
                                  detail:{ type:"string",
                                    examples:[ "The resource you are trying to access does not exist." ] } } } },
                            "application/xml":{ schema:{ "x-scalar-ignore":true,
                                description:"RFC 7807 (https://datatracker.ietf.org/doc/html/rfc7807)",
                                type:"object",
                                properties:{ type:{ type:"string",
                                    examples:[ "https://example.com/errors/not-found" ] },
                                  title:{ type:"string",
                                    examples:[ "Not Found" ] },
                                  status:{ type:"integer",
                                    format:"int64",
                                    examples:[ 404 ] },
                                  detail:{ type:"string",
                                    examples:[ "The resource you are trying to access does not exist." ] } } } } } } } },
                    pathParameters:undefined },
                  { httpVerb:"PUT",
                    path:"/planets/{planetId}",
                    operationId:"updatePlanet",
                    name:"Update a planet",
                    description:"Sometimes you make mistakes, that's fine. No worries, you can update all planets.",
                    information:{ tags:[ "Planets" ],
                      summary:"Update a planet",
                      description:"Sometimes you make mistakes, that's fine. No worries, you can update all planets.",
                      operationId:"updatePlanet",
                      requestBody:{ description:"New information about the planet",
                        content:{ "application/json":{ schema:{ description:"A planet in the Scalar Galaxy",
                              type:"object",
                              required:[ "id",
                                "name" ],
                              xml:{ name:"planet" },
                              properties:{ id:{ type:"integer",
                                  format:"int64",
                                  readOnly:true,
                                  examples:[ 1 ],
                                  "x-variable":"planetId" },
                                name:{ type:"string",
                                  examples:[ "Mars",
                                    "Jupiter",
                                    "HD 40307g" ] },
                                description:{ type:[ "string",
                                    "null" ],
                                  examples:[ "The red planet",
                                    "A gas giant with a great red spot" ] },
                                type:{ type:"string",
                                  "enum":[ "terrestrial",
                                    "gas_giant",
                                    "ice_giant",
                                    "dwarf",
                                    "super_earth" ],
                                  examples:[ "terrestrial" ] },
                                habitabilityIndex:{ type:"number",
                                  format:"float",
                                  minimum:0,
                                  maximum:1,
                                  description:"A score from 0 to 1 indicating potential habitability",
                                  examples:[ 0.68 ] },
                                physicalProperties:{ type:"object",
                                  properties:{ mass:{ type:"number",
                                      format:"float",
                                      description:"Mass in Earth masses",
                                      examples:[ 0.107 ] },
                                    radius:{ type:"number",
                                      format:"float",
                                      description:"Radius in Earth radii",
                                      examples:[ 0.532 ] },
                                    gravity:{ type:"number",
                                      format:"float",
                                      description:"Surface gravity in Earth g",
                                      examples:[ 0.378 ] },
                                    temperature:{ type:"object",
                                      properties:{ min:{ type:"number",
                                          format:"float",
                                          description:"Minimum temperature in Kelvin",
                                          examples:[ 130 ] },
                                        max:{ type:"number",
                                          format:"float",
                                          description:"Maximum temperature in Kelvin",
                                          examples:[ 308 ] },
                                        average:{ type:"number",
                                          format:"float",
                                          description:"Average temperature in Kelvin",
                                          examples:[ 210 ] } } } } },
                                atmosphere:{ type:"array",
                                  description:"Atmospheric composition",
                                  items:{ type:"object",
                                    properties:{ compound:{ type:"string",
                                        examples:[ "CO2",
                                          "N2" ] },
                                      percentage:{ type:"number",
                                        format:"float",
                                        examples:[ 95.3 ] } } } },
                                discoveredAt:{ type:"string",
                                  format:"date-time",
                                  examples:[ "1610-01-07T00:00:00Z" ] },
                                image:{ type:"string",
                                  nullable:true,
                                  examples:[ "https://cdn.scalar.com/photos/mars.jpg" ] },
                                satellites:{ type:"array",
                                  items:{ description:"A natural satellite (moon) orbiting a planet",
                                    type:"object",
                                    required:[ "name" ],
                                    properties:{ name:{ type:"string",
                                        examples:[ "Phobos" ] },
                                      diameter:{ type:"number",
                                        format:"float",
                                        description:"Diameter in kilometers",
                                        examples:[ 22.2 ] } } } },
                                creator:{ description:"A user",
                                  type:"object",
                                  xml:{ name:"user" },
                                  properties:{ id:{ type:"integer",
                                      format:"int64",
                                      readOnly:true,
                                      examples:[ 1 ] },
                                    name:{ type:"string",
                                      examples:[ "Marc" ] } } },
                                tags:{ type:"array",
                                  items:{ type:"string" },
                                  examples:[ [ "solar-system",
                                      "rocky",
                                      "explored" ] ] },
                                lastUpdated:{ type:"string",
                                  format:"date-time",
                                  readOnly:true,
                                  examples:[ "2024-01-15T14:30:00Z" ] },
                                callbackUrl:{ type:"string",
                                  format:"uri",
                                  description:"URL to receive notifications about this planet",
                                  examples:[ "https://example.com/webhook" ] } } } },
                          "application/xml":{ schema:{ description:"A planet in the Scalar Galaxy",
                              type:"object",
                              required:[ "id",
                                "name" ],
                              xml:{ name:"planet" },
                              properties:{ id:{ type:"integer",
                                  format:"int64",
                                  readOnly:true,
                                  examples:[ 1 ],
                                  "x-variable":"planetId" },
                                name:{ type:"string",
                                  examples:[ "Mars",
                                    "Jupiter",
                                    "HD 40307g" ] },
                                description:{ type:[ "string",
                                    "null" ],
                                  examples:[ "The red planet",
                                    "A gas giant with a great red spot" ] },
                                type:{ type:"string",
                                  "enum":[ "terrestrial",
                                    "gas_giant",
                                    "ice_giant",
                                    "dwarf",
                                    "super_earth" ],
                                  examples:[ "terrestrial" ] },
                                habitabilityIndex:{ type:"number",
                                  format:"float",
                                  minimum:0,
                                  maximum:1,
                                  description:"A score from 0 to 1 indicating potential habitability",
                                  examples:[ 0.68 ] },
                                physicalProperties:{ type:"object",
                                  properties:{ mass:{ type:"number",
                                      format:"float",
                                      description:"Mass in Earth masses",
                                      examples:[ 0.107 ] },
                                    radius:{ type:"number",
                                      format:"float",
                                      description:"Radius in Earth radii",
                                      examples:[ 0.532 ] },
                                    gravity:{ type:"number",
                                      format:"float",
                                      description:"Surface gravity in Earth g",
                                      examples:[ 0.378 ] },
                                    temperature:{ type:"object",
                                      properties:{ min:{ type:"number",
                                          format:"float",
                                          description:"Minimum temperature in Kelvin",
                                          examples:[ 130 ] },
                                        max:{ type:"number",
                                          format:"float",
                                          description:"Maximum temperature in Kelvin",
                                          examples:[ 308 ] },
                                        average:{ type:"number",
                                          format:"float",
                                          description:"Average temperature in Kelvin",
                                          examples:[ 210 ] } } } } },
                                atmosphere:{ type:"array",
                                  description:"Atmospheric composition",
                                  items:{ type:"object",
                                    properties:{ compound:{ type:"string",
                                        examples:[ "CO2",
                                          "N2" ] },
                                      percentage:{ type:"number",
                                        format:"float",
                                        examples:[ 95.3 ] } } } },
                                discoveredAt:{ type:"string",
                                  format:"date-time",
                                  examples:[ "1610-01-07T00:00:00Z" ] },
                                image:{ type:"string",
                                  nullable:true,
                                  examples:[ "https://cdn.scalar.com/photos/mars.jpg" ] },
                                satellites:{ type:"array",
                                  items:{ description:"A natural satellite (moon) orbiting a planet",
                                    type:"object",
                                    required:[ "name" ],
                                    properties:{ name:{ type:"string",
                                        examples:[ "Phobos" ] },
                                      diameter:{ type:"number",
                                        format:"float",
                                        description:"Diameter in kilometers",
                                        examples:[ 22.2 ] } } } },
                                creator:{ description:"A user",
                                  type:"object",
                                  xml:{ name:"user" },
                                  properties:{ id:{ type:"integer",
                                      format:"int64",
                                      readOnly:true,
                                      examples:[ 1 ] },
                                    name:{ type:"string",
                                      examples:[ "Marc" ] } } },
                                tags:{ type:"array",
                                  items:{ type:"string" },
                                  examples:[ [ "solar-system",
                                      "rocky",
                                      "explored" ] ] },
                                lastUpdated:{ type:"string",
                                  format:"date-time",
                                  readOnly:true,
                                  examples:[ "2024-01-15T14:30:00Z" ] },
                                callbackUrl:{ type:"string",
                                  format:"uri",
                                  description:"URL to receive notifications about this planet",
                                  examples:[ "https://example.com/webhook" ] } } } } } },
                      parameters:[ { name:"planetId",
                          description:"The ID of the planet to get",
                          "in":"path",
                          required:true,
                          schema:{ type:"integer",
                            format:"int64",
                            examples:[ 1 ] } } ],
                      responses:{ 200:{ description:"OK",
                          content:{ "application/json":{ schema:{ description:"A planet in the Scalar Galaxy",
                                type:"object",
                                required:[ "id",
                                  "name" ],
                                xml:{ name:"planet" },
                                properties:{ id:{ type:"integer",
                                    format:"int64",
                                    readOnly:true,
                                    examples:[ 1 ],
                                    "x-variable":"planetId" },
                                  name:{ type:"string",
                                    examples:[ "Mars",
                                      "Jupiter",
                                      "HD 40307g" ] },
                                  description:{ type:[ "string",
                                      "null" ],
                                    examples:[ "The red planet",
                                      "A gas giant with a great red spot" ] },
                                  type:{ type:"string",
                                    "enum":[ "terrestrial",
                                      "gas_giant",
                                      "ice_giant",
                                      "dwarf",
                                      "super_earth" ],
                                    examples:[ "terrestrial" ] },
                                  habitabilityIndex:{ type:"number",
                                    format:"float",
                                    minimum:0,
                                    maximum:1,
                                    description:"A score from 0 to 1 indicating potential habitability",
                                    examples:[ 0.68 ] },
                                  physicalProperties:{ type:"object",
                                    properties:{ mass:{ type:"number",
                                        format:"float",
                                        description:"Mass in Earth masses",
                                        examples:[ 0.107 ] },
                                      radius:{ type:"number",
                                        format:"float",
                                        description:"Radius in Earth radii",
                                        examples:[ 0.532 ] },
                                      gravity:{ type:"number",
                                        format:"float",
                                        description:"Surface gravity in Earth g",
                                        examples:[ 0.378 ] },
                                      temperature:{ type:"object",
                                        properties:{ min:{ type:"number",
                                            format:"float",
                                            description:"Minimum temperature in Kelvin",
                                            examples:[ 130 ] },
                                          max:{ type:"number",
                                            format:"float",
                                            description:"Maximum temperature in Kelvin",
                                            examples:[ 308 ] },
                                          average:{ type:"number",
                                            format:"float",
                                            description:"Average temperature in Kelvin",
                                            examples:[ 210 ] } } } } },
                                  atmosphere:{ type:"array",
                                    description:"Atmospheric composition",
                                    items:{ type:"object",
                                      properties:{ compound:{ type:"string",
                                          examples:[ "CO2",
                                            "N2" ] },
                                        percentage:{ type:"number",
                                          format:"float",
                                          examples:[ 95.3 ] } } } },
                                  discoveredAt:{ type:"string",
                                    format:"date-time",
                                    examples:[ "1610-01-07T00:00:00Z" ] },
                                  image:{ type:"string",
                                    nullable:true,
                                    examples:[ "https://cdn.scalar.com/photos/mars.jpg" ] },
                                  satellites:{ type:"array",
                                    items:{ description:"A natural satellite (moon) orbiting a planet",
                                      type:"object",
                                      required:[ "name" ],
                                      properties:{ name:{ type:"string",
                                          examples:[ "Phobos" ] },
                                        diameter:{ type:"number",
                                          format:"float",
                                          description:"Diameter in kilometers",
                                          examples:[ 22.2 ] } } } },
                                  creator:{ description:"A user",
                                    type:"object",
                                    xml:{ name:"user" },
                                    properties:{ id:{ type:"integer",
                                        format:"int64",
                                        readOnly:true,
                                        examples:[ 1 ] },
                                      name:{ type:"string",
                                        examples:[ "Marc" ] } } },
                                  tags:{ type:"array",
                                    items:{ type:"string" },
                                    examples:[ [ "solar-system",
                                        "rocky",
                                        "explored" ] ] },
                                  lastUpdated:{ type:"string",
                                    format:"date-time",
                                    readOnly:true,
                                    examples:[ "2024-01-15T14:30:00Z" ] },
                                  callbackUrl:{ type:"string",
                                    format:"uri",
                                    description:"URL to receive notifications about this planet",
                                    examples:[ "https://example.com/webhook" ] } } } },
                            "application/xml":{ schema:{ description:"A planet in the Scalar Galaxy",
                                type:"object",
                                required:[ "id",
                                  "name" ],
                                xml:{ name:"planet" },
                                properties:{ id:{ type:"integer",
                                    format:"int64",
                                    readOnly:true,
                                    examples:[ 1 ],
                                    "x-variable":"planetId" },
                                  name:{ type:"string",
                                    examples:[ "Mars",
                                      "Jupiter",
                                      "HD 40307g" ] },
                                  description:{ type:[ "string",
                                      "null" ],
                                    examples:[ "The red planet",
                                      "A gas giant with a great red spot" ] },
                                  type:{ type:"string",
                                    "enum":[ "terrestrial",
                                      "gas_giant",
                                      "ice_giant",
                                      "dwarf",
                                      "super_earth" ],
                                    examples:[ "terrestrial" ] },
                                  habitabilityIndex:{ type:"number",
                                    format:"float",
                                    minimum:0,
                                    maximum:1,
                                    description:"A score from 0 to 1 indicating potential habitability",
                                    examples:[ 0.68 ] },
                                  physicalProperties:{ type:"object",
                                    properties:{ mass:{ type:"number",
                                        format:"float",
                                        description:"Mass in Earth masses",
                                        examples:[ 0.107 ] },
                                      radius:{ type:"number",
                                        format:"float",
                                        description:"Radius in Earth radii",
                                        examples:[ 0.532 ] },
                                      gravity:{ type:"number",
                                        format:"float",
                                        description:"Surface gravity in Earth g",
                                        examples:[ 0.378 ] },
                                      temperature:{ type:"object",
                                        properties:{ min:{ type:"number",
                                            format:"float",
                                            description:"Minimum temperature in Kelvin",
                                            examples:[ 130 ] },
                                          max:{ type:"number",
                                            format:"float",
                                            description:"Maximum temperature in Kelvin",
                                            examples:[ 308 ] },
                                          average:{ type:"number",
                                            format:"float",
                                            description:"Average temperature in Kelvin",
                                            examples:[ 210 ] } } } } },
                                  atmosphere:{ type:"array",
                                    description:"Atmospheric composition",
                                    items:{ type:"object",
                                      properties:{ compound:{ type:"string",
                                          examples:[ "CO2",
                                            "N2" ] },
                                        percentage:{ type:"number",
                                          format:"float",
                                          examples:[ 95.3 ] } } } },
                                  discoveredAt:{ type:"string",
                                    format:"date-time",
                                    examples:[ "1610-01-07T00:00:00Z" ] },
                                  image:{ type:"string",
                                    nullable:true,
                                    examples:[ "https://cdn.scalar.com/photos/mars.jpg" ] },
                                  satellites:{ type:"array",
                                    items:{ description:"A natural satellite (moon) orbiting a planet",
                                      type:"object",
                                      required:[ "name" ],
                                      properties:{ name:{ type:"string",
                                          examples:[ "Phobos" ] },
                                        diameter:{ type:"number",
                                          format:"float",
                                          description:"Diameter in kilometers",
                                          examples:[ 22.2 ] } } } },
                                  creator:{ description:"A user",
                                    type:"object",
                                    xml:{ name:"user" },
                                    properties:{ id:{ type:"integer",
                                        format:"int64",
                                        readOnly:true,
                                        examples:[ 1 ] },
                                      name:{ type:"string",
                                        examples:[ "Marc" ] } } },
                                  tags:{ type:"array",
                                    items:{ type:"string" },
                                    examples:[ [ "solar-system",
                                        "rocky",
                                        "explored" ] ] },
                                  lastUpdated:{ type:"string",
                                    format:"date-time",
                                    readOnly:true,
                                    examples:[ "2024-01-15T14:30:00Z" ] },
                                  callbackUrl:{ type:"string",
                                    format:"uri",
                                    description:"URL to receive notifications about this planet",
                                    examples:[ "https://example.com/webhook" ] } } } } } },
                        400:{ description:"Bad Request",
                          content:{ "application/json":{ schema:{ "x-scalar-ignore":true,
                                description:"RFC 7807 (https://datatracker.ietf.org/doc/html/rfc7807)",
                                type:"object",
                                properties:{ type:{ type:"string",
                                    examples:[ "https://example.com/errors/bad-request" ] },
                                  title:{ type:"string",
                                    examples:[ "Bad Request" ] },
                                  status:{ type:"integer",
                                    format:"int64",
                                    examples:[ 400 ] },
                                  detail:{ type:"string",
                                    examples:[ "The request was invalid." ] } } } },
                            "application/xml":{ schema:{ "x-scalar-ignore":true,
                                description:"RFC 7807 (https://datatracker.ietf.org/doc/html/rfc7807)",
                                type:"object",
                                properties:{ type:{ type:"string",
                                    examples:[ "https://example.com/errors/bad-request" ] },
                                  title:{ type:"string",
                                    examples:[ "Bad Request" ] },
                                  status:{ type:"integer",
                                    format:"int64",
                                    examples:[ 400 ] },
                                  detail:{ type:"string",
                                    examples:[ "The request was invalid." ] } } } } } },
                        403:{ description:"Forbidden",
                          content:{ "application/json":{ schema:{ "x-scalar-ignore":true,
                                description:"RFC 7807 (https://datatracker.ietf.org/doc/html/rfc7807)",
                                type:"object",
                                properties:{ type:{ type:"string",
                                    examples:[ "https://example.com/errors/forbidden" ] },
                                  title:{ type:"string",
                                    examples:[ "Forbidden" ] },
                                  status:{ type:"integer",
                                    format:"int64",
                                    examples:[ 403 ] },
                                  detail:{ type:"string",
                                    examples:[ "You are not authorized to access this resource." ] } } } },
                            "application/xml":{ schema:{ "x-scalar-ignore":true,
                                description:"RFC 7807 (https://datatracker.ietf.org/doc/html/rfc7807)",
                                type:"object",
                                properties:{ type:{ type:"string",
                                    examples:[ "https://example.com/errors/forbidden" ] },
                                  title:{ type:"string",
                                    examples:[ "Forbidden" ] },
                                  status:{ type:"integer",
                                    format:"int64",
                                    examples:[ 403 ] },
                                  detail:{ type:"string",
                                    examples:[ "You are not authorized to access this resource." ] } } } } } },
                        404:{ description:"NotFound",
                          content:{ "application/json":{ schema:{ "x-scalar-ignore":true,
                                description:"RFC 7807 (https://datatracker.ietf.org/doc/html/rfc7807)",
                                type:"object",
                                properties:{ type:{ type:"string",
                                    examples:[ "https://example.com/errors/not-found" ] },
                                  title:{ type:"string",
                                    examples:[ "Not Found" ] },
                                  status:{ type:"integer",
                                    format:"int64",
                                    examples:[ 404 ] },
                                  detail:{ type:"string",
                                    examples:[ "The resource you are trying to access does not exist." ] } } } },
                            "application/xml":{ schema:{ "x-scalar-ignore":true,
                                description:"RFC 7807 (https://datatracker.ietf.org/doc/html/rfc7807)",
                                type:"object",
                                properties:{ type:{ type:"string",
                                    examples:[ "https://example.com/errors/not-found" ] },
                                  title:{ type:"string",
                                    examples:[ "Not Found" ] },
                                  status:{ type:"integer",
                                    format:"int64",
                                    examples:[ 404 ] },
                                  detail:{ type:"string",
                                    examples:[ "The resource you are trying to access does not exist." ] } } } } } } } },
                    pathParameters:undefined },
                  { httpVerb:"DELETE",
                    path:"/planets/{planetId}",
                    operationId:"deletePlanet",
                    name:"Delete a planet",
                    description:"This endpoint was used to delete planets. Unfortunately, that caused a lot of trouble for planets with life. So, this endpoint is now deprecated and should not be used anymore.",
                    information:{ tags:[ "Planets" ],
                      summary:"Delete a planet",
                      operationId:"deletePlanet",
                      description:"This endpoint was used to delete planets. Unfortunately, that caused a lot of trouble for planets with life. So, this endpoint is now deprecated and should not be used anymore.",
                      "x-scalar-stability":"experimental",
                      parameters:[ { name:"planetId",
                          description:"The ID of the planet to get",
                          "in":"path",
                          required:true,
                          schema:{ type:"integer",
                            format:"int64",
                            examples:[ 1 ] } } ],
                      responses:{ 204:{ description:"No Content" },
                        404:{ description:"NotFound",
                          content:{ "application/json":{ schema:{ "x-scalar-ignore":true,
                                description:"RFC 7807 (https://datatracker.ietf.org/doc/html/rfc7807)",
                                type:"object",
                                properties:{ type:{ type:"string",
                                    examples:[ "https://example.com/errors/not-found" ] },
                                  title:{ type:"string",
                                    examples:[ "Not Found" ] },
                                  status:{ type:"integer",
                                    format:"int64",
                                    examples:[ 404 ] },
                                  detail:{ type:"string",
                                    examples:[ "The resource you are trying to access does not exist." ] } } } },
                            "application/xml":{ schema:{ "x-scalar-ignore":true,
                                description:"RFC 7807 (https://datatracker.ietf.org/doc/html/rfc7807)",
                                type:"object",
                                properties:{ type:{ type:"string",
                                    examples:[ "https://example.com/errors/not-found" ] },
                                  title:{ type:"string",
                                    examples:[ "Not Found" ] },
                                  status:{ type:"integer",
                                    format:"int64",
                                    examples:[ 404 ] },
                                  detail:{ type:"string",
                                    examples:[ "The resource you are trying to access does not exist." ] } } } } } } } },
                    pathParameters:undefined },
                  { httpVerb:"POST",
                    path:"/planets/{planetId}/image",
                    operationId:"uploadImage",
                    name:"Upload an image to a planet",
                    description:"Got a crazy good photo of a planet? Share it with the world!",
                    information:{ tags:[ "Planets" ],
                      summary:"Upload an image to a planet",
                      description:"Got a crazy good photo of a planet? Share it with the world!",
                      operationId:"uploadImage",
                      parameters:[ { name:"planetId",
                          description:"The ID of the planet to get",
                          "in":"path",
                          required:true,
                          schema:{ type:"integer",
                            format:"int64",
                            examples:[ 1 ] } } ],
                      requestBody:{ description:"Image to upload",
                        content:{ "multipart/form-data":{ schema:{ type:"object",
                              properties:{ image:{ type:"string",
                                  format:"binary",
                                  description:"The image file to upload",
                                  examples:[ "@mars.jpg",
                                    "@jupiter.png" ] } } } } } },
                      responses:{ 200:{ description:"Image uploaded",
                          content:{ "application/json":{ schema:{ "x-scalar-ignore":true,
                                description:"Message about an image upload",
                                type:"object",
                                properties:{ message:{ type:"string",
                                    examples:[ "Image uploaded successfully" ] },
                                  imageUrl:{ type:"string",
                                    description:"The URL where the uploaded image can be accessed",
                                    examples:[ "https://cdn.scalar.com/images/8f47c132-9d1f-4f83-b5a4-91db5ee757ab.jpg" ] },
                                  uploadedAt:{ type:"string",
                                    format:"date-time",
                                    description:"Timestamp when the image was uploaded",
                                    examples:[ "2024-01-15T14:30:00Z" ] },
                                  fileSize:{ type:"integer",
                                    description:"Size of the uploaded image in bytes",
                                    examples:[ 1048576 ] },
                                  mimeType:{ type:"string",
                                    description:"The content type of the uploaded image",
                                    examples:[ "image/jpeg",
                                      "image/png" ] } } } },
                            "application/xml":{ schema:{ "x-scalar-ignore":true,
                                description:"Message about an image upload",
                                type:"object",
                                properties:{ message:{ type:"string",
                                    examples:[ "Image uploaded successfully" ] },
                                  imageUrl:{ type:"string",
                                    description:"The URL where the uploaded image can be accessed",
                                    examples:[ "https://cdn.scalar.com/images/8f47c132-9d1f-4f83-b5a4-91db5ee757ab.jpg" ] },
                                  uploadedAt:{ type:"string",
                                    format:"date-time",
                                    description:"Timestamp when the image was uploaded",
                                    examples:[ "2024-01-15T14:30:00Z" ] },
                                  fileSize:{ type:"integer",
                                    description:"Size of the uploaded image in bytes",
                                    examples:[ 1048576 ] },
                                  mimeType:{ type:"string",
                                    description:"The content type of the uploaded image",
                                    examples:[ "image/jpeg",
                                      "image/png" ] } } } } } },
                        400:{ description:"Bad Request",
                          content:{ "application/json":{ schema:{ "x-scalar-ignore":true,
                                description:"RFC 7807 (https://datatracker.ietf.org/doc/html/rfc7807)",
                                type:"object",
                                properties:{ type:{ type:"string",
                                    examples:[ "https://example.com/errors/bad-request" ] },
                                  title:{ type:"string",
                                    examples:[ "Bad Request" ] },
                                  status:{ type:"integer",
                                    format:"int64",
                                    examples:[ 400 ] },
                                  detail:{ type:"string",
                                    examples:[ "The request was invalid." ] } } } },
                            "application/xml":{ schema:{ "x-scalar-ignore":true,
                                description:"RFC 7807 (https://datatracker.ietf.org/doc/html/rfc7807)",
                                type:"object",
                                properties:{ type:{ type:"string",
                                    examples:[ "https://example.com/errors/bad-request" ] },
                                  title:{ type:"string",
                                    examples:[ "Bad Request" ] },
                                  status:{ type:"integer",
                                    format:"int64",
                                    examples:[ 400 ] },
                                  detail:{ type:"string",
                                    examples:[ "The request was invalid." ] } } } } } },
                        403:{ description:"Forbidden",
                          content:{ "application/json":{ schema:{ "x-scalar-ignore":true,
                                description:"RFC 7807 (https://datatracker.ietf.org/doc/html/rfc7807)",
                                type:"object",
                                properties:{ type:{ type:"string",
                                    examples:[ "https://example.com/errors/forbidden" ] },
                                  title:{ type:"string",
                                    examples:[ "Forbidden" ] },
                                  status:{ type:"integer",
                                    format:"int64",
                                    examples:[ 403 ] },
                                  detail:{ type:"string",
                                    examples:[ "You are not authorized to access this resource." ] } } } },
                            "application/xml":{ schema:{ "x-scalar-ignore":true,
                                description:"RFC 7807 (https://datatracker.ietf.org/doc/html/rfc7807)",
                                type:"object",
                                properties:{ type:{ type:"string",
                                    examples:[ "https://example.com/errors/forbidden" ] },
                                  title:{ type:"string",
                                    examples:[ "Forbidden" ] },
                                  status:{ type:"integer",
                                    format:"int64",
                                    examples:[ 403 ] },
                                  detail:{ type:"string",
                                    examples:[ "You are not authorized to access this resource." ] } } } } } },
                        404:{ description:"NotFound",
                          content:{ "application/json":{ schema:{ "x-scalar-ignore":true,
                                description:"RFC 7807 (https://datatracker.ietf.org/doc/html/rfc7807)",
                                type:"object",
                                properties:{ type:{ type:"string",
                                    examples:[ "https://example.com/errors/not-found" ] },
                                  title:{ type:"string",
                                    examples:[ "Not Found" ] },
                                  status:{ type:"integer",
                                    format:"int64",
                                    examples:[ 404 ] },
                                  detail:{ type:"string",
                                    examples:[ "The resource you are trying to access does not exist." ] } } } },
                            "application/xml":{ schema:{ "x-scalar-ignore":true,
                                description:"RFC 7807 (https://datatracker.ietf.org/doc/html/rfc7807)",
                                type:"object",
                                properties:{ type:{ type:"string",
                                    examples:[ "https://example.com/errors/not-found" ] },
                                  title:{ type:"string",
                                    examples:[ "Not Found" ] },
                                  status:{ type:"integer",
                                    format:"int64",
                                    examples:[ 404 ] },
                                  detail:{ type:"string",
                                    examples:[ "The resource you are trying to access does not exist." ] } } } } } } } },
                    pathParameters:undefined } ] } ],
            requestBody:{ description:"Information about a new planet",
              content:{ "application/json":{ schema:{ description:"A planet in the Scalar Galaxy",
                    type:"object",
                    required:[ "id",
                      "name" ],
                    xml:{ name:"planet" },
                    properties:{ id:{ type:"integer",
                        format:"int64",
                        readOnly:true,
                        examples:[ 1 ],
                        "x-variable":"planetId" },
                      name:{ type:"string",
                        examples:[ "Mars",
                          "Jupiter",
                          "HD 40307g" ] },
                      description:{ type:[ "string",
                          "null" ],
                        examples:[ "The red planet",
                          "A gas giant with a great red spot" ] },
                      type:{ type:"string",
                        "enum":[ "terrestrial",
                          "gas_giant",
                          "ice_giant",
                          "dwarf",
                          "super_earth" ],
                        examples:[ "terrestrial" ] },
                      habitabilityIndex:{ type:"number",
                        format:"float",
                        minimum:0,
                        maximum:1,
                        description:"A score from 0 to 1 indicating potential habitability",
                        examples:[ 0.68 ] },
                      physicalProperties:{ type:"object",
                        properties:{ mass:{ type:"number",
                            format:"float",
                            description:"Mass in Earth masses",
                            examples:[ 0.107 ] },
                          radius:{ type:"number",
                            format:"float",
                            description:"Radius in Earth radii",
                            examples:[ 0.532 ] },
                          gravity:{ type:"number",
                            format:"float",
                            description:"Surface gravity in Earth g",
                            examples:[ 0.378 ] },
                          temperature:{ type:"object",
                            properties:{ min:{ type:"number",
                                format:"float",
                                description:"Minimum temperature in Kelvin",
                                examples:[ 130 ] },
                              max:{ type:"number",
                                format:"float",
                                description:"Maximum temperature in Kelvin",
                                examples:[ 308 ] },
                              average:{ type:"number",
                                format:"float",
                                description:"Average temperature in Kelvin",
                                examples:[ 210 ] } } } } },
                      atmosphere:{ type:"array",
                        description:"Atmospheric composition",
                        items:{ type:"object",
                          properties:{ compound:{ type:"string",
                              examples:[ "CO2",
                                "N2" ] },
                            percentage:{ type:"number",
                              format:"float",
                              examples:[ 95.3 ] } } } },
                      discoveredAt:{ type:"string",
                        format:"date-time",
                        examples:[ "1610-01-07T00:00:00Z" ] },
                      image:{ type:"string",
                        nullable:true,
                        examples:[ "https://cdn.scalar.com/photos/mars.jpg" ] },
                      satellites:{ type:"array",
                        items:{ description:"A natural satellite (moon) orbiting a planet",
                          type:"object",
                          required:[ "name" ],
                          properties:{ name:{ type:"string",
                              examples:[ "Phobos" ] },
                            diameter:{ type:"number",
                              format:"float",
                              description:"Diameter in kilometers",
                              examples:[ 22.2 ] } } } },
                      creator:{ description:"A user",
                        type:"object",
                        xml:{ name:"user" },
                        properties:{ id:{ type:"integer",
                            format:"int64",
                            readOnly:true,
                            examples:[ 1 ] },
                          name:{ type:"string",
                            examples:[ "Marc" ] } } },
                      tags:{ type:"array",
                        items:{ type:"string" },
                        examples:[ [ "solar-system",
                            "rocky",
                            "explored" ] ] },
                      lastUpdated:{ type:"string",
                        format:"date-time",
                        readOnly:true,
                        examples:[ "2024-01-15T14:30:00Z" ] },
                      callbackUrl:{ type:"string",
                        format:"uri",
                        description:"URL to receive notifications about this planet",
                        examples:[ "https://example.com/webhook" ] } } } },
                "application/xml":{ schema:{ description:"A planet in the Scalar Galaxy",
                    type:"object",
                    required:[ "id",
                      "name" ],
                    xml:{ name:"planet" },
                    properties:{ id:{ type:"integer",
                        format:"int64",
                        readOnly:true,
                        examples:[ 1 ],
                        "x-variable":"planetId" },
                      name:{ type:"string",
                        examples:[ "Mars",
                          "Jupiter",
                          "HD 40307g" ] },
                      description:{ type:[ "string",
                          "null" ],
                        examples:[ "The red planet",
                          "A gas giant with a great red spot" ] },
                      type:{ type:"string",
                        "enum":[ "terrestrial",
                          "gas_giant",
                          "ice_giant",
                          "dwarf",
                          "super_earth" ],
                        examples:[ "terrestrial" ] },
                      habitabilityIndex:{ type:"number",
                        format:"float",
                        minimum:0,
                        maximum:1,
                        description:"A score from 0 to 1 indicating potential habitability",
                        examples:[ 0.68 ] },
                      physicalProperties:{ type:"object",
                        properties:{ mass:{ type:"number",
                            format:"float",
                            description:"Mass in Earth masses",
                            examples:[ 0.107 ] },
                          radius:{ type:"number",
                            format:"float",
                            description:"Radius in Earth radii",
                            examples:[ 0.532 ] },
                          gravity:{ type:"number",
                            format:"float",
                            description:"Surface gravity in Earth g",
                            examples:[ 0.378 ] },
                          temperature:{ type:"object",
                            properties:{ min:{ type:"number",
                                format:"float",
                                description:"Minimum temperature in Kelvin",
                                examples:[ 130 ] },
                              max:{ type:"number",
                                format:"float",
                                description:"Maximum temperature in Kelvin",
                                examples:[ 308 ] },
                              average:{ type:"number",
                                format:"float",
                                description:"Average temperature in Kelvin",
                                examples:[ 210 ] } } } } },
                      atmosphere:{ type:"array",
                        description:"Atmospheric composition",
                        items:{ type:"object",
                          properties:{ compound:{ type:"string",
                              examples:[ "CO2",
                                "N2" ] },
                            percentage:{ type:"number",
                              format:"float",
                              examples:[ 95.3 ] } } } },
                      discoveredAt:{ type:"string",
                        format:"date-time",
                        examples:[ "1610-01-07T00:00:00Z" ] },
                      image:{ type:"string",
                        nullable:true,
                        examples:[ "https://cdn.scalar.com/photos/mars.jpg" ] },
                      satellites:{ type:"array",
                        items:{ description:"A natural satellite (moon) orbiting a planet",
                          type:"object",
                          required:[ "name" ],
                          properties:{ name:{ type:"string",
                              examples:[ "Phobos" ] },
                            diameter:{ type:"number",
                              format:"float",
                              description:"Diameter in kilometers",
                              examples:[ 22.2 ] } } } },
                      creator:{ description:"A user",
                        type:"object",
                        xml:{ name:"user" },
                        properties:{ id:{ type:"integer",
                            format:"int64",
                            readOnly:true,
                            examples:[ 1 ] },
                          name:{ type:"string",
                            examples:[ "Marc" ] } } },
                      tags:{ type:"array",
                        items:{ type:"string" },
                        examples:[ [ "solar-system",
                            "rocky",
                            "explored" ] ] },
                      lastUpdated:{ type:"string",
                        format:"date-time",
                        readOnly:true,
                        examples:[ "2024-01-15T14:30:00Z" ] },
                      callbackUrl:{ type:"string",
                        format:"uri",
                        description:"URL to receive notifications about this planet",
                        examples:[ "https://example.com/webhook" ] } } } } } },
            responses:{ 200:{ description:"Return a 200 status to indicate that the data was received successfully" } } } } } },
    components:{ securitySchemes:{ bearerAuth:{ type:"http",
          scheme:"bearer",
          description:"JWT Bearer token authentication" },
        basicAuth:{ type:"http",
          scheme:"basic",
          description:"Basic HTTP authentication" },
        apiKeyHeader:{ type:"apiKey",
          "in":"header",
          name:"X-API-Key",
          description:"API key request header" },
        apiKeyQuery:{ type:"apiKey",
          "in":"query",
          name:"api_key",
          description:"API key query parameter" },
        apiKeyCookie:{ type:"apiKey",
          "in":"cookie",
          name:"api_key",
          description:"API key browser cookie" },
        oAuth2:{ type:"oauth2",
          description:"OAuth 2.0 authentication",
          flows:{ authorizationCode:{ authorizationUrl:"https://galaxy.scalar.com/oauth/authorize",
              tokenUrl:"https://galaxy.scalar.com/oauth/token",
              scopes:{ "read:account":"read your account information",
                "write:planets":"modify planets in your account",
                "read:planets":"read your planets" } },
            clientCredentials:{ tokenUrl:"https://galaxy.scalar.com/oauth/token",
              scopes:{ "read:account":"read your account information",
                "write:planets":"modify planets in your account",
                "read:planets":"read your planets" } },
            implicit:{ authorizationUrl:"https://galaxy.scalar.com/oauth/authorize",
              scopes:{ "read:account":"read your account information",
                "write:planets":"modify planets in your account",
                "read:planets":"read your planets" } },
            password:{ tokenUrl:"https://galaxy.scalar.com/oauth/token",
              scopes:{ "read:account":"read your account information",
                "write:planets":"modify planets in your account",
                "read:planets":"read your planets" } } } },
        openIdConnect:{ type:"openIdConnect",
          openIdConnectUrl:"https://galaxy.scalar.com/.well-known/openid-configuration",
          description:"OpenID Connect Authentication" } },
      parameters:{ planetId:{ name:"planetId",
          description:"The ID of the planet to get",
          "in":"path",
          required:true,
          schema:{ type:"integer",
            format:"int64",
            examples:[ 1 ] } },
        limit:{ name:"limit",
          description:"The number of items to return",
          "in":"query",
          required:false,
          schema:{ type:"integer",
            format:"int64",
            "default":10 } },
        offset:{ name:"offset",
          description:"The number of items to skip before starting to collect the result set",
          "in":"query",
          required:false,
          schema:{ type:"integer",
            format:"int64",
            "default":0 } } },
      responses:{ ImageUploaded:{ description:"Image uploaded",
          content:{ "application/json":{ schema:{ "x-scalar-ignore":true,
                description:"Message about an image upload",
                type:"object",
                properties:{ message:{ type:"string",
                    examples:[ "Image uploaded successfully" ] },
                  imageUrl:{ type:"string",
                    description:"The URL where the uploaded image can be accessed",
                    examples:[ "https://cdn.scalar.com/images/8f47c132-9d1f-4f83-b5a4-91db5ee757ab.jpg" ] },
                  uploadedAt:{ type:"string",
                    format:"date-time",
                    description:"Timestamp when the image was uploaded",
                    examples:[ "2024-01-15T14:30:00Z" ] },
                  fileSize:{ type:"integer",
                    description:"Size of the uploaded image in bytes",
                    examples:[ 1048576 ] },
                  mimeType:{ type:"string",
                    description:"The content type of the uploaded image",
                    examples:[ "image/jpeg",
                      "image/png" ] } } } },
            "application/xml":{ schema:{ "x-scalar-ignore":true,
                description:"Message about an image upload",
                type:"object",
                properties:{ message:{ type:"string",
                    examples:[ "Image uploaded successfully" ] },
                  imageUrl:{ type:"string",
                    description:"The URL where the uploaded image can be accessed",
                    examples:[ "https://cdn.scalar.com/images/8f47c132-9d1f-4f83-b5a4-91db5ee757ab.jpg" ] },
                  uploadedAt:{ type:"string",
                    format:"date-time",
                    description:"Timestamp when the image was uploaded",
                    examples:[ "2024-01-15T14:30:00Z" ] },
                  fileSize:{ type:"integer",
                    description:"Size of the uploaded image in bytes",
                    examples:[ 1048576 ] },
                  mimeType:{ type:"string",
                    description:"The content type of the uploaded image",
                    examples:[ "image/jpeg",
                      "image/png" ] } } } } } },
        BadRequest:{ description:"Bad Request",
          content:{ "application/json":{ schema:{ "x-scalar-ignore":true,
                description:"RFC 7807 (https://datatracker.ietf.org/doc/html/rfc7807)",
                type:"object",
                properties:{ type:{ type:"string",
                    examples:[ "https://example.com/errors/bad-request" ] },
                  title:{ type:"string",
                    examples:[ "Bad Request" ] },
                  status:{ type:"integer",
                    format:"int64",
                    examples:[ 400 ] },
                  detail:{ type:"string",
                    examples:[ "The request was invalid." ] } } } },
            "application/xml":{ schema:{ "x-scalar-ignore":true,
                description:"RFC 7807 (https://datatracker.ietf.org/doc/html/rfc7807)",
                type:"object",
                properties:{ type:{ type:"string",
                    examples:[ "https://example.com/errors/bad-request" ] },
                  title:{ type:"string",
                    examples:[ "Bad Request" ] },
                  status:{ type:"integer",
                    format:"int64",
                    examples:[ 400 ] },
                  detail:{ type:"string",
                    examples:[ "The request was invalid." ] } } } } } },
        Forbidden:{ description:"Forbidden",
          content:{ "application/json":{ schema:{ "x-scalar-ignore":true,
                description:"RFC 7807 (https://datatracker.ietf.org/doc/html/rfc7807)",
                type:"object",
                properties:{ type:{ type:"string",
                    examples:[ "https://example.com/errors/forbidden" ] },
                  title:{ type:"string",
                    examples:[ "Forbidden" ] },
                  status:{ type:"integer",
                    format:"int64",
                    examples:[ 403 ] },
                  detail:{ type:"string",
                    examples:[ "You are not authorized to access this resource." ] } } } },
            "application/xml":{ schema:{ "x-scalar-ignore":true,
                description:"RFC 7807 (https://datatracker.ietf.org/doc/html/rfc7807)",
                type:"object",
                properties:{ type:{ type:"string",
                    examples:[ "https://example.com/errors/forbidden" ] },
                  title:{ type:"string",
                    examples:[ "Forbidden" ] },
                  status:{ type:"integer",
                    format:"int64",
                    examples:[ 403 ] },
                  detail:{ type:"string",
                    examples:[ "You are not authorized to access this resource." ] } } } } } },
        NotFound:{ description:"NotFound",
          content:{ "application/json":{ schema:{ "x-scalar-ignore":true,
                description:"RFC 7807 (https://datatracker.ietf.org/doc/html/rfc7807)",
                type:"object",
                properties:{ type:{ type:"string",
                    examples:[ "https://example.com/errors/not-found" ] },
                  title:{ type:"string",
                    examples:[ "Not Found" ] },
                  status:{ type:"integer",
                    format:"int64",
                    examples:[ 404 ] },
                  detail:{ type:"string",
                    examples:[ "The resource you are trying to access does not exist." ] } } } },
            "application/xml":{ schema:{ "x-scalar-ignore":true,
                description:"RFC 7807 (https://datatracker.ietf.org/doc/html/rfc7807)",
                type:"object",
                properties:{ type:{ type:"string",
                    examples:[ "https://example.com/errors/not-found" ] },
                  title:{ type:"string",
                    examples:[ "Not Found" ] },
                  status:{ type:"integer",
                    format:"int64",
                    examples:[ 404 ] },
                  detail:{ type:"string",
                    examples:[ "The resource you are trying to access does not exist." ] } } } } } },
        Unauthorized:{ description:"Unauthorized",
          content:{ "application/json":{ schema:{ "x-scalar-ignore":true,
                description:"RFC 7807 (https://datatracker.ietf.org/doc/html/rfc7807)",
                type:"object",
                properties:{ type:{ type:"string",
                    examples:[ "https://example.com/errors/not-found" ] },
                  title:{ type:"string",
                    examples:[ "Unauthorized" ] },
                  status:{ type:"integer",
                    format:"int64",
                    examples:[ 401 ] },
                  detail:{ type:"string",
                    examples:[ "You are not authorized to access this resource." ] } } } },
            "application/xml":{ schema:{ "x-scalar-ignore":true,
                description:"RFC 7807 (https://datatracker.ietf.org/doc/html/rfc7807)",
                type:"object",
                properties:{ type:{ type:"string",
                    examples:[ "https://example.com/errors/not-found" ] },
                  title:{ type:"string",
                    examples:[ "Unauthorized" ] },
                  status:{ type:"integer",
                    format:"int64",
                    examples:[ 401 ] },
                  detail:{ type:"string",
                    examples:[ "You are not authorized to access this resource." ] } } } } } },
        Conflict:{ description:"Conflict",
          content:{ "application/json":{ schema:{ "x-scalar-ignore":true,
                description:"RFC 7807 (https://datatracker.ietf.org/doc/html/rfc7807)",
                type:"object",
                properties:{ type:{ type:"string",
                    examples:[ "https://example.com/errors/conflict" ] },
                  title:{ type:"string",
                    examples:[ "Conflict" ] },
                  status:{ type:"integer",
                    format:"int64",
                    examples:[ 409 ] },
                  detail:{ type:"string",
                    examples:[ "The resource you are trying to access is in conflict." ] } } } },
            "application/xml":{ schema:{ "x-scalar-ignore":true,
                description:"RFC 7807 (https://datatracker.ietf.org/doc/html/rfc7807)",
                type:"object",
                properties:{ type:{ type:"string",
                    examples:[ "https://example.com/errors/conflict" ] },
                  title:{ type:"string",
                    examples:[ "Conflict" ] },
                  status:{ type:"integer",
                    format:"int64",
                    examples:[ 409 ] },
                  detail:{ type:"string",
                    examples:[ "The resource you are trying to access is in conflict." ] } } } } } },
        UnprocessableEntity:{ description:"Unprocessable Entity",
          content:{ "application/json":{ schema:{ "x-scalar-ignore":true,
                description:"RFC 7807 (https://datatracker.ietf.org/doc/html/rfc7807)",
                type:"object",
                properties:{ type:{ type:"string",
                    examples:[ "https://example.com/errors/unprocessable-entity" ] },
                  title:{ type:"string",
                    examples:[ "Unprocessable Entity" ] },
                  status:{ type:"integer",
                    format:"int64",
                    examples:[ 422 ] },
                  detail:{ type:"string",
                    examples:[ "The request was invalid." ] } } } },
            "application/xml":{ schema:{ "x-scalar-ignore":true,
                description:"RFC 7807 (https://datatracker.ietf.org/doc/html/rfc7807)",
                type:"object",
                properties:{ type:{ type:"string",
                    examples:[ "https://example.com/errors/unprocessable-entity" ] },
                  title:{ type:"string",
                    examples:[ "Unprocessable Entity" ] },
                  status:{ type:"integer",
                    format:"int64",
                    examples:[ 422 ] },
                  detail:{ type:"string",
                    examples:[ "The request was invalid." ] } } } } } } },
      schemas:{ User:{ description:"A user",
          type:"object",
          xml:{ name:"user" },
          properties:{ id:{ type:"integer",
              format:"int64",
              readOnly:true,
              examples:[ 1 ] },
            name:{ type:"string",
              examples:[ "Marc" ] } } },
        Credentials:{ description:"Credentials to authenticate a user",
          type:"object",
          required:[ "email",
            "password" ],
          properties:{ email:{ type:"string",
              format:"email",
              examples:[ "marc@scalar.com" ] },
            password:{ type:"string",
              writeOnly:true,
              examples:[ "i-love-scalar",
                "i-love-OSS",
                "i-love-code" ] } } },
        Token:{ description:"A token to authenticate a user",
          type:"object",
          properties:{ token:{ type:"string",
              examples:[ "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiIxMjM0NTY3ODkwIiwibmFtZSI6IkpvaG4gRG9lIiwiaWF0IjoxNTE2MjM5MDIyfQ.SflKxwRJSMeKKF2QT4fwpMeJf36POk6yJV_adQssw5c" ] } } },
        Planet:{ description:"A planet in the Scalar Galaxy",
          type:"object",
          required:[ "id",
            "name" ],
          xml:{ name:"planet" },
          properties:{ id:{ type:"integer",
              format:"int64",
              readOnly:true,
              examples:[ 1 ],
              "x-variable":"planetId" },
            name:{ type:"string",
              examples:[ "Mars",
                "Jupiter",
                "HD 40307g" ] },
            description:{ type:[ "string",
                "null" ],
              examples:[ "The red planet",
                "A gas giant with a great red spot" ] },
            type:{ type:"string",
              "enum":[ "terrestrial",
                "gas_giant",
                "ice_giant",
                "dwarf",
                "super_earth" ],
              examples:[ "terrestrial" ] },
            habitabilityIndex:{ type:"number",
              format:"float",
              minimum:0,
              maximum:1,
              description:"A score from 0 to 1 indicating potential habitability",
              examples:[ 0.68 ] },
            physicalProperties:{ type:"object",
              properties:{ mass:{ type:"number",
                  format:"float",
                  description:"Mass in Earth masses",
                  examples:[ 0.107 ] },
                radius:{ type:"number",
                  format:"float",
                  description:"Radius in Earth radii",
                  examples:[ 0.532 ] },
                gravity:{ type:"number",
                  format:"float",
                  description:"Surface gravity in Earth g",
                  examples:[ 0.378 ] },
                temperature:{ type:"object",
                  properties:{ min:{ type:"number",
                      format:"float",
                      description:"Minimum temperature in Kelvin",
                      examples:[ 130 ] },
                    max:{ type:"number",
                      format:"float",
                      description:"Maximum temperature in Kelvin",
                      examples:[ 308 ] },
                    average:{ type:"number",
                      format:"float",
                      description:"Average temperature in Kelvin",
                      examples:[ 210 ] } } } } },
            atmosphere:{ type:"array",
              description:"Atmospheric composition",
              items:{ type:"object",
                properties:{ compound:{ type:"string",
                    examples:[ "CO2",
                      "N2" ] },
                  percentage:{ type:"number",
                    format:"float",
                    examples:[ 95.3 ] } } } },
            discoveredAt:{ type:"string",
              format:"date-time",
              examples:[ "1610-01-07T00:00:00Z" ] },
            image:{ type:"string",
              nullable:true,
              examples:[ "https://cdn.scalar.com/photos/mars.jpg" ] },
            satellites:{ type:"array",
              items:{ description:"A natural satellite (moon) orbiting a planet",
                type:"object",
                required:[ "name" ],
                properties:{ name:{ type:"string",
                    examples:[ "Phobos" ] },
                  diameter:{ type:"number",
                    format:"float",
                    description:"Diameter in kilometers",
                    examples:[ 22.2 ] } } } },
            creator:{ description:"A user",
              type:"object",
              xml:{ name:"user" },
              properties:{ id:{ type:"integer",
                  format:"int64",
                  readOnly:true,
                  examples:[ 1 ] },
                name:{ type:"string",
                  examples:[ "Marc" ] } } },
            tags:{ type:"array",
              items:{ type:"string" },
              examples:[ [ "solar-system",
                  "rocky",
                  "explored" ] ] },
            lastUpdated:{ type:"string",
              format:"date-time",
              readOnly:true,
              examples:[ "2024-01-15T14:30:00Z" ] },
            callbackUrl:{ type:"string",
              format:"uri",
              description:"URL to receive notifications about this planet",
              examples:[ "https://example.com/webhook" ] } } },
        PaginatedResource:{ description:"A paginated resource",
          type:"object",
          properties:{ meta:{ type:"object",
              properties:{ limit:{ type:"integer",
                  format:"int64",
                  examples:[ 10 ] },
                offset:{ type:"integer",
                  format:"int64",
                  examples:[ 0 ] },
                total:{ type:"integer",
                  format:"int64",
                  examples:[ 100 ] },
                next:{ type:[ "string",
                    "null" ],
                  examples:[ "/planets?limit=10&offset=10" ] } } } } },
        Satellite:{ description:"A natural satellite (moon) orbiting a planet",
          type:"object",
          required:[ "name" ],
          properties:{ name:{ type:"string",
              examples:[ "Phobos" ] },
            diameter:{ type:"number",
              format:"float",
              description:"Diameter in kilometers",
              examples:[ 22.2 ] } } } } } } }